/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/ev-emitter/ev-emitter.js":
/*!***********************************************!*\
  !*** ./node_modules/ev-emitter/ev-emitter.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */

(function (global, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }
})(typeof window != 'undefined' ? window : this, function () {
  function EvEmitter() {}
  var proto = EvEmitter.prototype;
  proto.on = function (eventName, listener) {
    if (!eventName || !listener) return this;

    // set events hash
    var events = this._events = this._events || {};
    // set listeners array
    var listeners = events[eventName] = events[eventName] || [];
    // only add once
    if (!listeners.includes(listener)) {
      listeners.push(listener);
    }
    return this;
  };
  proto.once = function (eventName, listener) {
    if (!eventName || !listener) return this;

    // add event
    this.on(eventName, listener);
    // set once flag
    // set onceEvents hash
    var onceEvents = this._onceEvents = this._onceEvents || {};
    // set onceListeners object
    var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
    // set flag
    onceListeners[listener] = true;
    return this;
  };
  proto.off = function (eventName, listener) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) return this;
    var index = listeners.indexOf(listener);
    if (index != -1) {
      listeners.splice(index, 1);
    }
    return this;
  };
  proto.emitEvent = function (eventName, args) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) return this;

    // copy over to avoid interference if .off() in listener
    listeners = listeners.slice(0);
    args = args || [];
    // once stuff
    var onceListeners = this._onceEvents && this._onceEvents[eventName];
    var _iterator = _createForOfIteratorHelper(listeners),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var listener = _step.value;
        var isOnce = onceListeners && onceListeners[listener];
        if (isOnce) {
          // remove listener
          // remove before trigger to prevent recursion
          this.off(eventName, listener);
          // unset once flag
          delete onceListeners[listener];
        }
        // trigger listener
        listener.apply(this, args);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return this;
  };
  proto.allOff = function () {
    delete this._events;
    delete this._onceEvents;
    return this;
  };
  return EvEmitter;
});

/***/ }),

/***/ "./node_modules/fizzy-ui-utils/utils.js":
/*!**********************************************!*\
  !*** ./node_modules/fizzy-ui-utils/utils.js ***!
  \**********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */

(function (global, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(global);
  } else {
    // browser global
    global.fizzyUIUtils = factory(global);
  }
})(this, function factory(global) {
  var utils = {};

  // ----- extend ----- //

  // extends objects
  utils.extend = function (a, b) {
    return Object.assign(a, b);
  };

  // ----- modulo ----- //

  utils.modulo = function (num, div) {
    return (num % div + div) % div;
  };

  // ----- makeArray ----- //

  // turn element or nodeList into an array
  utils.makeArray = function (obj) {
    // use object if already an array
    if (Array.isArray(obj)) return obj;

    // return empty array if undefined or null. #6
    if (obj === null || obj === undefined) return [];
    var isArrayLike = _typeof(obj) == 'object' && typeof obj.length == 'number';
    // convert nodeList to array
    if (isArrayLike) return _toConsumableArray(obj);

    // array of single index
    return [obj];
  };

  // ----- removeFrom ----- //

  utils.removeFrom = function (ary, obj) {
    var index = ary.indexOf(obj);
    if (index != -1) {
      ary.splice(index, 1);
    }
  };

  // ----- getParent ----- //

  utils.getParent = function (elem, selector) {
    while (elem.parentNode && elem != document.body) {
      elem = elem.parentNode;
      if (elem.matches(selector)) return elem;
    }
  };

  // ----- getQueryElement ----- //

  // use element as selector string
  utils.getQueryElement = function (elem) {
    if (typeof elem == 'string') {
      return document.querySelector(elem);
    }
    return elem;
  };

  // ----- handleEvent ----- //

  // enable .ontype to trigger from .addEventListener( elem, 'type' )
  utils.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };

  // ----- filterFindElements ----- //

  utils.filterFindElements = function (elems, selector) {
    // make array of elems
    elems = utils.makeArray(elems);
    return elems
    // check that elem is an actual element
    .filter(function (elem) {
      return elem instanceof HTMLElement;
    }).reduce(function (ffElems, elem) {
      var _ffElems;
      // add elem if no selector
      if (!selector) {
        ffElems.push(elem);
        return ffElems;
      }
      // filter & find items if we have a selector
      // filter
      if (elem.matches(selector)) {
        ffElems.push(elem);
      }
      // find children
      var childElems = elem.querySelectorAll(selector);
      // concat childElems to filterFound array
      ffElems = (_ffElems = ffElems).concat.apply(_ffElems, _toConsumableArray(childElems));
      return ffElems;
    }, []);
  };

  // ----- debounceMethod ----- //

  utils.debounceMethod = function (_class, methodName, threshold) {
    threshold = threshold || 100;
    // original method
    var method = _class.prototype[methodName];
    var timeoutName = methodName + 'Timeout';
    _class.prototype[methodName] = function () {
      var _this = this;
      clearTimeout(this[timeoutName]);
      var args = arguments;
      this[timeoutName] = setTimeout(function () {
        method.apply(_this, args);
        delete _this[timeoutName];
      }, threshold);
    };
  };

  // ----- docReady ----- //

  utils.docReady = function (onDocReady) {
    var readyState = document.readyState;
    if (readyState == 'complete' || readyState == 'interactive') {
      // do async to allow for other scripts to run. metafizzy/flickity#441
      setTimeout(onDocReady);
    } else {
      document.addEventListener('DOMContentLoaded', onDocReady);
    }
  };

  // ----- htmlInit ----- //

  // http://bit.ly/3oYLusc
  utils.toDashed = function (str) {
    return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
      return $1 + '-' + $2;
    }).toLowerCase();
  };
  var console = global.console;

  // allow user to initialize classes via [data-namespace] or .js-namespace class
  // htmlInit( Widget, 'widgetName' )
  // options are parsed from data-namespace-options
  utils.htmlInit = function (WidgetClass, namespace) {
    utils.docReady(function () {
      var dashedNamespace = utils.toDashed(namespace);
      var dataAttr = 'data-' + dashedNamespace;
      var dataAttrElems = document.querySelectorAll("[".concat(dataAttr, "]"));
      var jQuery = global.jQuery;
      _toConsumableArray(dataAttrElems).forEach(function (elem) {
        var attr = elem.getAttribute(dataAttr);
        var options;
        try {
          options = attr && JSON.parse(attr);
        } catch (error) {
          // log error, do not initialize
          if (console) {
            console.error("Error parsing ".concat(dataAttr, " on ").concat(elem.className, ": ").concat(error));
          }
          return;
        }
        // initialize
        var instance = new WidgetClass(elem, options);
        // make available via $().data('namespace')
        if (jQuery) {
          jQuery.data(elem, namespace, instance);
        }
      });
    });
  };

  // -----  ----- //

  return utils;
});

/***/ }),

/***/ "./node_modules/flickity/js/add-remove-cell.js":
/*!*****************************************************!*\
  !*** ./node_modules/flickity/js/add-remove-cell.js ***!
  \*****************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// add, remove cell
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  // append cells to a document fragment
  function getCellsFragment(cells) {
    var fragment = document.createDocumentFragment();
    cells.forEach(function (cell) {
      return fragment.appendChild(cell.element);
    });
    return fragment;
  }

  // -------------------------- add/remove cell prototype -------------------------- //

  var proto = Flickity.prototype;

  /**
   * Insert, prepend, or append cells
   * @param {[Element, Array, NodeList]} elems - Elements to insert
   * @param {Integer} index - Zero-based number to insert
   */
  proto.insert = function (elems, index) {
    var cells = this._makeCells(elems);
    if (!cells || !cells.length) return;
    var len = this.cells.length;
    // default to append
    index = index === undefined ? len : index;
    // add cells with document fragment
    var fragment = getCellsFragment(cells);
    // append to slider
    var isAppend = index === len;
    if (isAppend) {
      this.slider.appendChild(fragment);
    } else {
      var insertCellElement = this.cells[index].element;
      this.slider.insertBefore(fragment, insertCellElement);
    }
    // add to this.cells
    if (index === 0) {
      // prepend, add to start
      this.cells = cells.concat(this.cells);
    } else if (isAppend) {
      // append, add to end
      this.cells = this.cells.concat(cells);
    } else {
      // insert in this.cells
      var endCells = this.cells.splice(index, len - index);
      this.cells = this.cells.concat(cells).concat(endCells);
    }
    this._sizeCells(cells);
    this.cellChange(index);
    this.positionSliderAtSelected();
  };
  proto.append = function (elems) {
    this.insert(elems, this.cells.length);
  };
  proto.prepend = function (elems) {
    this.insert(elems, 0);
  };

  /**
   * Remove cells
   * @param {[Element, Array, NodeList]} elems - ELements to remove
   */
  proto.remove = function (elems) {
    var _this = this;
    var cells = this.getCells(elems);
    if (!cells || !cells.length) return;
    var minCellIndex = this.cells.length - 1;
    // remove cells from collection & DOM
    cells.forEach(function (cell) {
      cell.remove();
      var index = _this.cells.indexOf(cell);
      minCellIndex = Math.min(index, minCellIndex);
      utils.removeFrom(_this.cells, cell);
    });
    this.cellChange(minCellIndex);
    this.positionSliderAtSelected();
  };

  /**
   * logic to be run after a cell's size changes
   * @param {Element} elem - cell's element
   */
  proto.cellSizeChange = function (elem) {
    var cell = this.getCell(elem);
    if (!cell) return;
    cell.getSize();
    var index = this.cells.indexOf(cell);
    this.cellChange(index);
    // do not position slider after lazy load
  };

  /**
   * logic any time a cell is changed: added, removed, or size changed
   * @param {Integer} changedCellIndex - index of the changed cell, optional
   */
  proto.cellChange = function (changedCellIndex) {
    var prevSelectedElem = this.selectedElement;
    this._positionCells(changedCellIndex);
    this._updateWrapShiftCells();
    this.setGallerySize();
    // update selectedIndex, try to maintain position & select previous selected element
    var cell = this.getCell(prevSelectedElem);
    if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
    this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
    this.emitEvent('cellChange', [changedCellIndex]);
    // position slider
    this.select(this.selectedIndex);
  };

  // -----  ----- //

  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/animate.js":
/*!*********************************************!*\
  !*** ./node_modules/flickity/js/animate.js ***!
  \*********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// animate
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(utils) {
  // -------------------------- animate -------------------------- //

  var proto = {};
  proto.startAnimation = function () {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.restingFrames = 0;
    this.animate();
  };
  proto.animate = function () {
    var _this = this;
    this.applyDragForce();
    this.applySelectedAttraction();
    var previousX = this.x;
    this.integratePhysics();
    this.positionSlider();
    this.settle(previousX);
    // animate next frame
    if (this.isAnimating) requestAnimationFrame(function () {
      return _this.animate();
    });
  };
  proto.positionSlider = function () {
    var x = this.x;
    // wrap position around
    if (this.isWrapping) {
      x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
      this.shiftWrapCells(x);
    }
    this.setTranslateX(x, this.isAnimating);
    this.dispatchScrollEvent();
  };
  proto.setTranslateX = function (x, is3d) {
    x += this.cursorPosition;
    // reverse if right-to-left and using transform
    if (this.options.rightToLeft) x = -x;
    var translateX = this.getPositionValue(x);
    // use 3D transforms for hardware acceleration on iOS
    // but use 2D when settled, for better font-rendering
    this.slider.style.transform = is3d ? "translate3d(".concat(translateX, ",0,0)") : "translateX(".concat(translateX, ")");
  };
  proto.dispatchScrollEvent = function () {
    var firstSlide = this.slides[0];
    if (!firstSlide) return;
    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent('scroll', null, [progress, positionX]);
  };
  proto.positionSliderAtSelected = function () {
    if (!this.cells.length) return;
    this.x = -this.selectedSlide.target;
    this.velocity = 0; // stop wobble
    this.positionSlider();
  };
  proto.getPositionValue = function (position) {
    if (this.options.percentPosition) {
      // percent position, round to 2 digits, like 12.34%
      return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
    } else {
      // pixel positioning
      return Math.round(position) + 'px';
    }
  };
  proto.settle = function (previousX) {
    // keep track of frames where x hasn't moved
    var isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
    if (isResting) this.restingFrames++;
    // stop animating if resting for 3 or more frames
    if (this.restingFrames > 2) {
      this.isAnimating = false;
      delete this.isFreeScrolling;
      // render position with translateX when settled
      this.positionSlider();
      this.dispatchEvent('settle', null, [this.selectedIndex]);
    }
  };
  proto.shiftWrapCells = function (x) {
    // shift before cells
    var beforeGap = this.cursorPosition + x;
    this._shiftCells(this.beforeShiftCells, beforeGap, -1);
    // shift after cells
    var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
    this._shiftCells(this.afterShiftCells, afterGap, 1);
  };
  proto._shiftCells = function (cells, gap, shift) {
    var _this2 = this;
    cells.forEach(function (cell) {
      var cellShift = gap > 0 ? shift : 0;
      _this2._wrapShiftCell(cell, cellShift);
      gap -= cell.size.outerWidth;
    });
  };
  proto._unshiftCells = function (cells) {
    var _this3 = this;
    if (!cells || !cells.length) return;
    cells.forEach(function (cell) {
      return _this3._wrapShiftCell(cell, 0);
    });
  };

  // @param {Integer} shift - 0, 1, or -1
  proto._wrapShiftCell = function (cell, shift) {
    this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
  };

  // -------------------------- physics -------------------------- //

  proto.integratePhysics = function () {
    this.x += this.velocity;
    this.velocity *= this.getFrictionFactor();
  };
  proto.applyForce = function (force) {
    this.velocity += force;
  };
  proto.getFrictionFactor = function () {
    return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
  };
  proto.getRestingPosition = function () {
    // my thanks to Steven Wittens, who simplified this math greatly
    return this.x + this.velocity / (1 - this.getFrictionFactor());
  };
  proto.applyDragForce = function () {
    if (!this.isDraggable || !this.isPointerDown) return;

    // change the position to drag position by applying force
    var dragVelocity = this.dragX - this.x;
    var dragForce = dragVelocity - this.velocity;
    this.applyForce(dragForce);
  };
  proto.applySelectedAttraction = function () {
    // do not attract if pointer down or no slides
    var dragDown = this.isDraggable && this.isPointerDown;
    if (dragDown || this.isFreeScrolling || !this.slides.length) return;
    var distance = this.selectedSlide.target * -1 - this.x;
    var force = distance * this.options.selectedAttraction;
    this.applyForce(force);
  };
  return proto;
});

/***/ }),

/***/ "./node_modules/flickity/js/cell.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/cell.js ***!
  \******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// Flickity.Cell
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! get-size */ "./node_modules/get-size/get-size.js"));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(window.getSize);
  }
})(typeof window != 'undefined' ? window : this, function factory(getSize) {
  var cellClassName = 'flickity-cell';
  function Cell(elem) {
    this.element = elem;
    this.element.classList.add(cellClassName);
    this.x = 0;
    this.unselect();
  }
  var proto = Cell.prototype;
  proto.destroy = function () {
    // reset style
    this.unselect();
    this.element.classList.remove(cellClassName);
    this.element.style.transform = '';
    this.element.removeAttribute('aria-hidden');
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
  };
  proto.select = function () {
    this.element.classList.add('is-selected');
    this.element.removeAttribute('aria-hidden');
  };
  proto.unselect = function () {
    this.element.classList.remove('is-selected');
    this.element.setAttribute('aria-hidden', 'true');
  };
  proto.remove = function () {
    this.element.remove();
  };
  return Cell;
});

/***/ }),

/***/ "./node_modules/flickity/js/core.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/core.js ***!
  \******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// Flickity main
/* eslint-disable max-params */
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"), __webpack_require__(/*! get-size */ "./node_modules/get-size/get-size.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"), __webpack_require__(/*! ./cell */ "./node_modules/flickity/js/cell.js"), __webpack_require__(/*! ./slide */ "./node_modules/flickity/js/slide.js"), __webpack_require__(/*! ./animate */ "./node_modules/flickity/js/animate.js"));
  } else {
    // browser global
    var _Flickity = window.Flickity;
    window.Flickity = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
  }
})(typeof window != 'undefined' ? window : this, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
  /* eslint-enable max-params */

  // vars
  var getComputedStyle = window.getComputedStyle,
    console = window.console;
  var jQuery = window.jQuery;

  // -------------------------- Flickity -------------------------- //

  // globally unique identifiers
  var GUID = 0;
  // internal store of all Flickity intances
  var instances = {};
  function Flickity(element, options) {
    var queryElement = utils.getQueryElement(element);
    if (!queryElement) {
      if (console) console.error("Bad element for Flickity: ".concat(queryElement || element));
      return;
    }
    this.element = queryElement;
    // do not initialize twice on same element
    if (this.element.flickityGUID) {
      var instance = instances[this.element.flickityGUID];
      if (instance) instance.option(options);
      return instance;
    }

    // add jQuery
    if (jQuery) {
      this.$element = jQuery(this.element);
    }
    // options
    this.options = _objectSpread({}, this.constructor.defaults);
    this.option(options);

    // kick things off
    this._create();
  }
  Flickity.defaults = {
    accessibility: true,
    // adaptiveHeight: false,
    cellAlign: 'center',
    // cellSelector: undefined,
    // contain: false,
    freeScrollFriction: 0.075,
    // friction when free-scrolling
    friction: 0.28,
    // friction when selecting
    namespaceJQueryEvents: true,
    // initialIndex: 0,
    percentPosition: true,
    resize: true,
    selectedAttraction: 0.025,
    setGallerySize: true
    // watchCSS: false,
    // wrapAround: false
  };

  // hash of methods triggered on _create()
  Flickity.create = {};
  var proto = Flickity.prototype;
  // inherit EventEmitter
  Object.assign(proto, EvEmitter.prototype);
  proto._create = function () {
    var _this$options = this.options,
      resize = _this$options.resize,
      watchCSS = _this$options.watchCSS,
      rightToLeft = _this$options.rightToLeft;
    // add id for Flickity.data
    var id = this.guid = ++GUID;
    this.element.flickityGUID = id; // expando
    instances[id] = this; // associate via id
    // initial properties
    this.selectedIndex = 0;
    // how many frames slider has been in same position
    this.restingFrames = 0;
    // initial physics properties
    this.x = 0;
    this.velocity = 0;
    this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
    this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
    // create viewport & slider
    this.viewport = document.createElement('div');
    this.viewport.className = 'flickity-viewport';
    this._createSlider();
    // used for keyboard navigation
    this.focusableElems = [this.element];
    if (resize || watchCSS) {
      window.addEventListener('resize', this);
    }

    // add listeners from on option
    for (var eventName in this.options.on) {
      var listener = this.options.on[eventName];
      this.on(eventName, listener);
    }
    for (var method in Flickity.create) {
      Flickity.create[method].call(this);
    }
    if (watchCSS) {
      this.watchCSS();
    } else {
      this.activate();
    }
  };

  /**
   * set options
   * @param {Object} opts - options to extend
   */
  proto.option = function (opts) {
    Object.assign(this.options, opts);
  };
  proto.activate = function () {
    var _this$slider;
    if (this.isActive) return;
    this.isActive = true;
    this.element.classList.add('flickity-enabled');
    if (this.options.rightToLeft) {
      this.element.classList.add('flickity-rtl');
    }
    this.getSize();
    // move initial cell elements so they can be loaded as cells
    var cellElems = this._filterFindCellElements(this.element.children);
    (_this$slider = this.slider).append.apply(_this$slider, _toConsumableArray(cellElems));
    this.viewport.append(this.slider);
    this.element.append(this.viewport);
    // get cells from children
    this.reloadCells();
    if (this.options.accessibility) {
      // allow element to focusable
      this.element.tabIndex = 0;
      // listen for key presses
      this.element.addEventListener('keydown', this);
    }
    this.emitEvent('activate');
    this.selectInitialIndex();
    // flag for initial activation, for using initialIndex
    this.isInitActivated = true;
    // ready event. #493
    this.dispatchEvent('ready');
  };

  // slider positions the cells
  proto._createSlider = function () {
    // slider element does all the positioning
    var slider = document.createElement('div');
    slider.className = 'flickity-slider';
    this.slider = slider;
  };
  proto._filterFindCellElements = function (elems) {
    return utils.filterFindElements(elems, this.options.cellSelector);
  };

  // goes through all children
  proto.reloadCells = function () {
    // collection of item elements
    this.cells = this._makeCells(this.slider.children);
    this.positionCells();
    this._updateWrapShiftCells();
    this.setGallerySize();
  };

  /**
   * turn elements into Flickity.Cells
   * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
   * @returns {Array} items - collection of new Flickity Cells
   */
  proto._makeCells = function (elems) {
    var cellElems = this._filterFindCellElements(elems);

    // create new Cells for collection
    return cellElems.map(function (cellElem) {
      return new Cell(cellElem);
    });
  };
  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };
  proto.getLastSlide = function () {
    return this.slides[this.slides.length - 1];
  };

  // positions all cells
  proto.positionCells = function () {
    // size all cells
    this._sizeCells(this.cells);
    // position all cells
    this._positionCells(0);
  };

  /**
   * position certain cells
   * @param {Integer} index - which cell to start with
   */
  proto._positionCells = function (index) {
    var _this = this;
    index = index || 0;
    // also measure maxCellHeight
    // start 0 if positioning all cells
    this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
    var cellX = 0;
    // get cellX
    if (index > 0) {
      var startCell = this.cells[index - 1];
      cellX = startCell.x + startCell.size.outerWidth;
    }
    this.cells.slice(index).forEach(function (cell) {
      cell.x = cellX;
      _this._renderCellPosition(cell, cellX);
      cellX += cell.size.outerWidth;
      _this.maxCellHeight = Math.max(cell.size.outerHeight, _this.maxCellHeight);
    });
    // keep track of cellX for wrap-around
    this.slideableWidth = cellX;
    // slides
    this.updateSlides();
    // contain slides target
    this._containSlides();
    // update slidesWidth
    this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
  };
  proto._renderCellPosition = function (cell, x) {
    // render position of cell with in slider
    var sideOffset = this.options.rightToLeft ? -1 : 1;
    var renderX = x * sideOffset;
    if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
    var positionValue = this.getPositionValue(renderX);
    cell.element.style.transform = "translateX( ".concat(positionValue, " )");
  };

  /**
   * cell.getSize() on multiple cells
   * @param {Array} cells - cells to size
   */
  proto._sizeCells = function (cells) {
    cells.forEach(function (cell) {
      return cell.getSize();
    });
  };

  // --------------------------  -------------------------- //

  proto.updateSlides = function () {
    var _this2 = this;
    this.slides = [];
    if (!this.cells.length) return;
    var beginMargin = this.beginMargin,
      endMargin = this.endMargin;
    var slide = new Slide(beginMargin, endMargin, this.cellAlign);
    this.slides.push(slide);
    var canCellFit = this._getCanCellFit();
    this.cells.forEach(function (cell, i) {
      // just add cell if first cell in slide
      if (!slide.cells.length) {
        slide.addCell(cell);
        return;
      }
      var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
      if (canCellFit(i, slideWidth)) {
        slide.addCell(cell);
      } else {
        // doesn't fit, new slide
        slide.updateTarget();
        slide = new Slide(beginMargin, endMargin, _this2.cellAlign);
        _this2.slides.push(slide);
        slide.addCell(cell);
      }
    });
    // last slide
    slide.updateTarget();
    // update .selectedSlide
    this.updateSelectedSlide();
  };
  proto._getCanCellFit = function () {
    var groupCells = this.options.groupCells;
    if (!groupCells) return function () {
      return false;
    };
    if (typeof groupCells == 'number') {
      // group by number. 3 -> [0,1,2], [3,4,5], ...
      var number = parseInt(groupCells, 10);
      return function (i) {
        return i % number !== 0;
      };
    }
    // default, group by width of slide
    var percent = 1;
    // parse '75%
    var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
    if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
    var groupWidth = (this.size.innerWidth + 1) * percent;
    return function (i, slideWidth) {
      return slideWidth <= groupWidth;
    };
  };

  // alias _init for jQuery plugin .flickity()
  proto._init = proto.reposition = function () {
    this.positionCells();
    this.positionSliderAtSelected();
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
    this.setCellAlign();
    this.cursorPosition = this.size.innerWidth * this.cellAlign;
  };
  var cellAlignShorthands = {
    left: 0,
    center: 0.5,
    right: 1
  };
  proto.setCellAlign = function () {
    var _this$options2 = this.options,
      cellAlign = _this$options2.cellAlign,
      rightToLeft = _this$options2.rightToLeft;
    var shorthand = cellAlignShorthands[cellAlign];
    this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
    if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
  };
  proto.setGallerySize = function () {
    if (!this.options.setGallerySize) return;
    var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = "".concat(height, "px");
  };
  proto._updateWrapShiftCells = function () {
    // update isWrapping
    this.isWrapping = this.getIsWrapping();
    // only for wrap-around
    if (!this.isWrapping) return;

    // unshift previous cells
    this._unshiftCells(this.beforeShiftCells);
    this._unshiftCells(this.afterShiftCells);
    // get before cells
    // initial gap
    var beforeGapX = this.cursorPosition;
    var lastIndex = this.cells.length - 1;
    this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
    // get after cells
    // ending gap between last cell and end of gallery viewport
    var afterGapX = this.size.innerWidth - this.cursorPosition;
    // start cloning at first cell, working forwards
    this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
  };
  proto.getIsWrapping = function () {
    var wrapAround = this.options.wrapAround;
    if (!wrapAround || this.slides.length < 2) return false;
    if (wrapAround !== 'fill') return true;
    // check that slides can fit

    var gapWidth = this.slideableWidth - this.size.innerWidth;
    if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
    // check that content width - shifting cell is bigger than viewport width
    var _iterator = _createForOfIteratorHelper(this.cells),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cell = _step.value;
        if (cell.size.outerWidth > gapWidth) return false;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return true;
  };
  proto._getGapCells = function (gapX, cellIndex, increment) {
    // keep adding cells until the cover the initial gap
    var cells = [];
    while (gapX > 0) {
      var cell = this.cells[cellIndex];
      if (!cell) break;
      cells.push(cell);
      cellIndex += increment;
      gapX -= cell.size.outerWidth;
    }
    return cells;
  };

  // ----- contain & wrap ----- //

  // contain cell targets so no excess sliding
  proto._containSlides = function () {
    var _this3 = this;
    var isContaining = this.options.contain && !this.isWrapping && this.cells.length;
    if (!isContaining) return;
    var contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
    // content is less than gallery size
    var isContentSmaller = contentWidth < this.size.innerWidth;
    if (isContentSmaller) {
      // all cells fit inside gallery
      this.slides.forEach(function (slide) {
        slide.target = contentWidth * _this3.cellAlign;
      });
    } else {
      // contain to bounds
      var beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
      var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
      this.slides.forEach(function (slide) {
        slide.target = Math.max(slide.target, beginBound);
        slide.target = Math.min(slide.target, endBound);
      });
    }
  };

  // ----- events ----- //

  /**
   * emits events via eventEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */
  proto.dispatchEvent = function (type, event, args) {
    var emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);
    if (jQuery && this.$element) {
      // default trigger with type if no event
      type += this.options.namespaceJQueryEvents ? '.flickity' : '';
      var $event = type;
      if (event) {
        // create jQuery event
        var jQEvent = new jQuery.Event(event);
        jQEvent.type = type;
        $event = jQEvent;
      }
      this.$element.trigger($event, args);
    }
  };
  var unidraggerEvents = ['dragStart', 'dragMove', 'dragEnd', 'pointerDown', 'pointerMove', 'pointerEnd', 'staticClick'];
  var _emitEvent = proto.emitEvent;
  proto.emitEvent = function (eventName, args) {
    if (eventName === 'staticClick') {
      // add cellElem and cellIndex args to staticClick
      var clickedCell = this.getParentCell(args[0].target);
      var cellElem = clickedCell && clickedCell.element;
      var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
      args = args.concat(cellElem, cellIndex);
    }
    // do regular thing
    _emitEvent.call(this, eventName, args);
    // duck-punch in jQuery events for Unidragger events
    var isUnidraggerEvent = unidraggerEvents.includes(eventName);
    if (!isUnidraggerEvent || !jQuery || !this.$element) return;
    eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var event = args.shift(0);
    var jQEvent = new jQuery.Event(event);
    jQEvent.type = eventName;
    this.$element.trigger(jQEvent, args);
  };

  // -------------------------- select -------------------------- //

  /**
   * @param {Integer} index - index of the slide
   * @param {Boolean} isWrap - will wrap-around to last/first if at the end
   * @param {Boolean} isInstant - will immediately set position at selected cell
   */
  proto.select = function (index, isWrap, isInstant) {
    if (!this.isActive) return;
    index = parseInt(index, 10);
    this._wrapSelect(index);
    if (this.isWrapping || isWrap) {
      index = utils.modulo(index, this.slides.length);
    }
    // bail if invalid index
    if (!this.slides[index]) return;
    var prevIndex = this.selectedIndex;
    this.selectedIndex = index;
    this.updateSelectedSlide();
    if (isInstant) {
      this.positionSliderAtSelected();
    } else {
      this.startAnimation();
    }
    if (this.options.adaptiveHeight) {
      this.setGallerySize();
    }
    // events
    this.dispatchEvent('select', null, [index]);
    // change event if new index
    if (index !== prevIndex) {
      this.dispatchEvent('change', null, [index]);
    }
  };

  // wraps position for wrapAround, to move to closest slide. #113
  proto._wrapSelect = function (index) {
    if (!this.isWrapping) return;
    var selectedIndex = this.selectedIndex,
      slideableWidth = this.slideableWidth,
      length = this.slides.length;
    // shift index for wrap, do not wrap dragSelect
    if (!this.isDragSelect) {
      var wrapIndex = utils.modulo(index, length);
      // go to shortest
      var delta = Math.abs(wrapIndex - selectedIndex);
      var backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
      var forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
      if (backWrapDelta < delta) {
        index += length;
      } else if (forewardWrapDelta < delta) {
        index -= length;
      }
    }

    // wrap position so slider is within normal area
    if (index < 0) {
      this.x -= slideableWidth;
    } else if (index >= length) {
      this.x += slideableWidth;
    }
  };
  proto.previous = function (isWrap, isInstant) {
    this.select(this.selectedIndex - 1, isWrap, isInstant);
  };
  proto.next = function (isWrap, isInstant) {
    this.select(this.selectedIndex + 1, isWrap, isInstant);
  };
  proto.updateSelectedSlide = function () {
    var slide = this.slides[this.selectedIndex];
    // selectedIndex could be outside of slides, if triggered before resize()
    if (!slide) return;

    // unselect previous selected slide
    this.unselectSelectedSlide();
    // update new selected slide
    this.selectedSlide = slide;
    slide.select();
    this.selectedCells = slide.cells;
    this.selectedElements = slide.getCellElements();
    // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
    this.selectedCell = slide.cells[0];
    this.selectedElement = this.selectedElements[0];
  };
  proto.unselectSelectedSlide = function () {
    if (this.selectedSlide) this.selectedSlide.unselect();
  };
  proto.selectInitialIndex = function () {
    var initialIndex = this.options.initialIndex;
    // already activated, select previous selectedIndex
    if (this.isInitActivated) {
      this.select(this.selectedIndex, false, true);
      return;
    }
    // select with selector string
    if (initialIndex && typeof initialIndex == 'string') {
      var cell = this.queryCell(initialIndex);
      if (cell) {
        this.selectCell(initialIndex, false, true);
        return;
      }
    }
    var index = 0;
    // select with number
    if (initialIndex && this.slides[initialIndex]) {
      index = initialIndex;
    }
    // select instantly
    this.select(index, false, true);
  };

  /**
   * select slide from number or cell element
   * @param {[Element, Number]} value - zero-based index or element to select
   * @param {Boolean} isWrap - enables wrapping around for extra index
   * @param {Boolean} isInstant - disables slide animation
   */
  proto.selectCell = function (value, isWrap, isInstant) {
    // get cell
    var cell = this.queryCell(value);
    if (!cell) return;
    var index = this.getCellSlideIndex(cell);
    this.select(index, isWrap, isInstant);
  };
  proto.getCellSlideIndex = function (cell) {
    // get index of slide that has cell
    var cellSlide = this.slides.find(function (slide) {
      return slide.cells.includes(cell);
    });
    return this.slides.indexOf(cellSlide);
  };

  // -------------------------- get cells -------------------------- //

  /**
   * get Flickity.Cell, given an Element
   * @param {Element} elem - matching cell element
   * @returns {Flickity.Cell} cell - matching cell
   */
  proto.getCell = function (elem) {
    // loop through cells to get the one that matches
    var _iterator2 = _createForOfIteratorHelper(this.cells),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var cell = _step2.value;
        if (cell.element === elem) return cell;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };

  /**
   * get collection of Flickity.Cells, given Elements
   * @param {[Element, Array, NodeList]} elems - multiple elements
   * @returns {Array} cells - Flickity.Cells
   */
  proto.getCells = function (elems) {
    var _this4 = this;
    elems = utils.makeArray(elems);
    return elems.map(function (elem) {
      return _this4.getCell(elem);
    }).filter(Boolean);
  };

  /**
   * get cell elements
   * @returns {Array} cellElems
   */
  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };

  /**
   * get parent cell from an element
   * @param {Element} elem - child element
   * @returns {Flickit.Cell} cell - parent cell
   */
  proto.getParentCell = function (elem) {
    // first check if elem is cell
    var cell = this.getCell(elem);
    if (cell) return cell;

    // try to get parent cell elem
    var closest = elem.closest('.flickity-slider > *');
    return this.getCell(closest);
  };

  /**
   * get cells adjacent to a slide
   * @param {Integer} adjCount - number of adjacent slides
   * @param {Integer} index - index of slide to start
   * @returns {Array} cells - array of Flickity.Cells
   */
  proto.getAdjacentCellElements = function (adjCount, index) {
    if (!adjCount) return this.selectedSlide.getCellElements();
    index = index === undefined ? this.selectedIndex : index;
    var len = this.slides.length;
    if (1 + adjCount * 2 >= len) {
      return this.getCellElements(); // get all
    }

    var cellElems = [];
    for (var i = index - adjCount; i <= index + adjCount; i++) {
      var slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
      var slide = this.slides[slideIndex];
      if (slide) {
        cellElems = cellElems.concat(slide.getCellElements());
      }
    }
    return cellElems;
  };

  /**
   * select slide from number or cell element
   * @param {[Element, String, Number]} selector - element, selector string, or index
   * @returns {Flickity.Cell} - matching cell
   */
  proto.queryCell = function (selector) {
    if (typeof selector == 'number') {
      // use number as index
      return this.cells[selector];
    }
    // do not select invalid selectors from hash: #123, #/. #791
    var isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);
    if (isSelectorString) {
      // use string as selector, get element
      selector = this.element.querySelector(selector);
    }
    // get cell from element
    return this.getCell(selector);
  };

  // -------------------------- events -------------------------- //

  proto.uiChange = function () {
    this.emitEvent('uiChange');
  };

  // ----- resize ----- //

  proto.onresize = function () {
    this.watchCSS();
    this.resize();
  };
  utils.debounceMethod(Flickity, 'onresize', 150);
  proto.resize = function () {
    // #1177 disable resize behavior when animating or dragging for iOS 15
    if (!this.isActive || this.isAnimating || this.isDragging) return;
    this.getSize();
    // wrap values
    if (this.isWrapping) {
      this.x = utils.modulo(this.x, this.slideableWidth);
    }
    this.positionCells();
    this._updateWrapShiftCells();
    this.setGallerySize();
    this.emitEvent('resize');
    // update selected index for group slides, instant
    // TODO: position can be lost between groups of various numbers
    var selectedElement = this.selectedElements && this.selectedElements[0];
    this.selectCell(selectedElement, false, true);
  };

  // watches the :after property, activates/deactivates
  proto.watchCSS = function () {
    if (!this.options.watchCSS) return;
    var afterContent = getComputedStyle(this.element, ':after').content;
    // activate if :after { content: 'flickity' }
    if (afterContent.includes('flickity')) {
      this.activate();
    } else {
      this.deactivate();
    }
  };

  // ----- keydown ----- //

  // go previous/next if left/right keys pressed
  proto.onkeydown = function (event) {
    var _document = document,
      activeElement = _document.activeElement;
    var handler = Flickity.keyboardHandlers[event.key];
    // only work if element is in focus
    if (!this.options.accessibility || !activeElement || !handler) return;
    var isFocused = this.focusableElems.some(function (elem) {
      return activeElement === elem;
    });
    if (isFocused) handler.call(this);
  };
  Flickity.keyboardHandlers = {
    ArrowLeft: function ArrowLeft() {
      this.uiChange();
      var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
      this[leftMethod]();
    },
    ArrowRight: function ArrowRight() {
      this.uiChange();
      var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
      this[rightMethod]();
    }
  };

  // ----- focus ----- //

  proto.focus = function () {
    this.element.focus({
      preventScroll: true
    });
  };

  // -------------------------- destroy -------------------------- //

  // deactivate all Flickity functionality, but keep stuff available
  proto.deactivate = function () {
    var _this$element;
    if (!this.isActive) return;
    this.element.classList.remove('flickity-enabled');
    this.element.classList.remove('flickity-rtl');
    this.unselectSelectedSlide();
    // destroy cells
    this.cells.forEach(function (cell) {
      return cell.destroy();
    });
    this.viewport.remove();
    // move child elements back into element
    (_this$element = this.element).append.apply(_this$element, _toConsumableArray(this.slider.children));
    if (this.options.accessibility) {
      this.element.removeAttribute('tabIndex');
      this.element.removeEventListener('keydown', this);
    }
    // set flags
    this.isActive = false;
    this.emitEvent('deactivate');
  };
  proto.destroy = function () {
    this.deactivate();
    window.removeEventListener('resize', this);
    this.allOff();
    this.emitEvent('destroy');
    if (jQuery && this.$element) {
      jQuery.removeData(this.element, 'flickity');
    }
    delete this.element.flickityGUID;
    delete instances[this.guid];
  };

  // -------------------------- prototype -------------------------- //

  Object.assign(proto, animatePrototype);

  // -------------------------- extras -------------------------- //

  /**
   * get Flickity instance from element
   * @param {[Element, String]} elem - element or selector string
   * @returns {Flickity} - Flickity instance
   */
  Flickity.data = function (elem) {
    elem = utils.getQueryElement(elem);
    if (elem) return instances[elem.flickityGUID];
  };
  utils.htmlInit(Flickity, 'flickity');
  var jQueryBridget = window.jQueryBridget;
  if (jQuery && jQueryBridget) {
    jQueryBridget('flickity', Flickity, jQuery);
  }

  // set internal jQuery, for Webpack + jQuery v3, #478
  Flickity.setJQuery = function (jq) {
    jQuery = jq;
  };
  Flickity.Cell = Cell;
  Flickity.Slide = Slide;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/drag.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/drag.js ***!
  \******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// drag
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! unidragger */ "./node_modules/unidragger/unidragger.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(window, Flickity, Unidragger, utils) {
  // ----- defaults ----- //

  Object.assign(Flickity.defaults, {
    draggable: '>1',
    dragThreshold: 3
  });

  // -------------------------- drag prototype -------------------------- //

  var proto = Flickity.prototype;
  Object.assign(proto, Unidragger.prototype); // inherit Unidragger
  proto.touchActionValue = '';

  // --------------------------  -------------------------- //

  Flickity.create.drag = function () {
    this.on('activate', this.onActivateDrag);
    this.on('uiChange', this._uiChangeDrag);
    this.on('deactivate', this.onDeactivateDrag);
    this.on('cellChange', this.updateDraggable);
    this.on('pointerDown', this.handlePointerDown);
    this.on('pointerUp', this.handlePointerUp);
    this.on('pointerDown', this.handlePointerDone);
    this.on('dragStart', this.handleDragStart);
    this.on('dragMove', this.handleDragMove);
    this.on('dragEnd', this.handleDragEnd);
    this.on('staticClick', this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
  };

  proto.onActivateDrag = function () {
    this.handles = [this.viewport];
    this.bindHandles();
    this.updateDraggable();
  };
  proto.onDeactivateDrag = function () {
    this.unbindHandles();
    this.element.classList.remove('is-draggable');
  };
  proto.updateDraggable = function () {
    // disable dragging if less than 2 slides. #278
    if (this.options.draggable === '>1') {
      this.isDraggable = this.slides.length > 1;
    } else {
      this.isDraggable = this.options.draggable;
    }
    this.element.classList.toggle('is-draggable', this.isDraggable);
  };
  proto._uiChangeDrag = function () {
    delete this.isFreeScrolling;
  };

  // -------------------------- pointer events -------------------------- //

  proto.handlePointerDown = function (event) {
    if (!this.isDraggable) {
      // proceed for staticClick
      this.bindActivePointerEvents(event);
      return;
    }
    var isTouchStart = event.type === 'touchstart';
    var isTouchPointer = event.pointerType === 'touch';
    var isFocusNode = event.target.matches('input, textarea, select');
    if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
    if (!isFocusNode) this.focus();
    // blur
    if (document.activeElement !== this.element) document.activeElement.blur();
    // stop if it was moving
    this.dragX = this.x;
    this.viewport.classList.add('is-pointer-down');
    // track scrolling
    this.pointerDownScroll = getScrollPosition();
    window.addEventListener('scroll', this);
    this.bindActivePointerEvents(event);
  };

  // ----- move ----- //

  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > this.options.dragThreshold;
  };

  // ----- up ----- //

  proto.handlePointerUp = function () {
    delete this.isTouchScrolling;
    this.viewport.classList.remove('is-pointer-down');
  };
  proto.handlePointerDone = function () {
    window.removeEventListener('scroll', this);
    delete this.pointerDownScroll;
  };

  // -------------------------- dragging -------------------------- //

  proto.handleDragStart = function () {
    if (!this.isDraggable) return;
    this.dragStartPosition = this.x;
    this.startAnimation();
    window.removeEventListener('scroll', this);
  };
  proto.handleDragMove = function (event, pointer, moveVector) {
    if (!this.isDraggable) return;
    event.preventDefault();
    this.previousDragX = this.dragX;
    // reverse if right-to-left
    var direction = this.options.rightToLeft ? -1 : 1;
    // wrap around move. #589
    if (this.isWrapping) moveVector.x %= this.slideableWidth;
    var dragX = this.dragStartPosition + moveVector.x * direction;
    if (!this.isWrapping) {
      // slow drag
      var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
      dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
      var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
      dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
    }
    this.dragX = dragX;
    this.dragMoveTime = new Date();
  };
  proto.handleDragEnd = function () {
    if (!this.isDraggable) return;
    var freeScroll = this.options.freeScroll;
    if (freeScroll) this.isFreeScrolling = true;
    // set selectedIndex based on where flick will end up
    var index = this.dragEndRestingSelect();
    if (freeScroll && !this.isWrapping) {
      // if free-scroll & not wrap around
      // do not free-scroll if going outside of bounding slides
      // so bounding slides can attract slider, and keep it in bounds
      var restingX = this.getRestingPosition();
      this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
    } else if (!freeScroll && index === this.selectedIndex) {
      // boost selection if selected index has not changed
      index += this.dragEndBoostSelect();
    }
    delete this.previousDragX;
    // apply selection
    // HACK, set flag so dragging stays in correct direction
    this.isDragSelect = this.isWrapping;
    this.select(index);
    delete this.isDragSelect;
  };
  proto.dragEndRestingSelect = function () {
    var restingX = this.getRestingPosition();
    // how far away from selected slide
    var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
    // get closet resting going up and going down
    var positiveResting = this._getClosestResting(restingX, distance, 1);
    var negativeResting = this._getClosestResting(restingX, distance, -1);
    // use closer resting for wrap-around
    return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
  };

  /**
   * given resting X and distance to selected cell
   * get the distance and index of the closest cell
   * @param {Number} restingX - estimated post-flick resting position
   * @param {Number} distance - distance to selected cell
   * @param {Integer} increment - +1 or -1, going up or down
   * @returns {Object} - { distance: {Number}, index: {Integer} }
   */
  proto._getClosestResting = function (restingX, distance, increment) {
    var index = this.selectedIndex;
    var minDistance = Infinity;
    var condition = this.options.contain && !this.isWrapping ?
    // if containing, keep going if distance is equal to minDistance
    function (dist, minDist) {
      return dist <= minDist;
    } : function (dist, minDist) {
      return dist < minDist;
    };
    while (condition(distance, minDistance)) {
      // measure distance to next cell
      index += increment;
      minDistance = distance;
      distance = this.getSlideDistance(-restingX, index);
      if (distance === null) break;
      distance = Math.abs(distance);
    }
    return {
      distance: minDistance,
      // selected was previous index
      index: index - increment
    };
  };

  /**
   * measure distance between x and a slide target
   * @param {Number} x - horizontal position
   * @param {Integer} index - slide index
   * @returns {Number} - slide distance
   */
  proto.getSlideDistance = function (x, index) {
    var len = this.slides.length;
    // wrap around if at least 2 slides
    var isWrapAround = this.options.wrapAround && len > 1;
    var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
    var slide = this.slides[slideIndex];
    if (!slide) return null;

    // add distance for wrap-around slides
    var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
    return x - (slide.target + wrap);
  };
  proto.dragEndBoostSelect = function () {
    // do not boost if no previousDragX or dragMoveTime
    if (this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100) {
      return 0;
    }
    var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
    var delta = this.previousDragX - this.dragX;
    if (distance > 0 && delta > 0) {
      // boost to next if moving towards the right, and positive velocity
      return 1;
    } else if (distance < 0 && delta < 0) {
      // boost to previous if moving towards the left, and negative velocity
      return -1;
    }
    return 0;
  };

  // ----- scroll ----- //

  proto.onscroll = function () {
    var scroll = getScrollPosition();
    var scrollMoveX = this.pointerDownScroll.x - scroll.x;
    var scrollMoveY = this.pointerDownScroll.y - scroll.y;
    // cancel click/tap if scroll is too much
    if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
      this.pointerDone();
    }
  };

  // ----- utils ----- //

  function getScrollPosition() {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }

  // -----  ----- //

  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/imagesloaded.js":
/*!**************************************************!*\
  !*** ./node_modules/flickity/js/imagesloaded.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// imagesloaded
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! imagesloaded */ "./node_modules/imagesloaded/imagesloaded.js"));
  } else {
    // browser global
    factory(window.Flickity, window.imagesLoaded);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, imagesLoaded) {
  Flickity.create.imagesLoaded = function () {
    this.on('activate', this.imagesLoaded);
  };
  Flickity.prototype.imagesLoaded = function () {
    var _this = this;
    if (!this.options.imagesLoaded) return;
    var onImagesLoadedProgress = function onImagesLoadedProgress(instance, image) {
      var cell = _this.getParentCell(image.img);
      _this.cellSizeChange(cell && cell.element);
      if (!_this.options.freeScroll) _this.positionSliderAtSelected();
    };
    imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
  };
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/index.js":
/*!*******************************************!*\
  !*** ./node_modules/flickity/js/index.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */

if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
  var Flickity = __webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js");
  __webpack_require__(/*! ./drag */ "./node_modules/flickity/js/drag.js");
  __webpack_require__(/*! ./prev-next-button */ "./node_modules/flickity/js/prev-next-button.js");
  __webpack_require__(/*! ./page-dots */ "./node_modules/flickity/js/page-dots.js");
  __webpack_require__(/*! ./player */ "./node_modules/flickity/js/player.js");
  __webpack_require__(/*! ./add-remove-cell */ "./node_modules/flickity/js/add-remove-cell.js");
  __webpack_require__(/*! ./lazyload */ "./node_modules/flickity/js/lazyload.js");
  __webpack_require__(/*! ./imagesloaded */ "./node_modules/flickity/js/imagesloaded.js");
  module.exports = Flickity;
}

/***/ }),

/***/ "./node_modules/flickity/js/lazyload.js":
/*!**********************************************!*\
  !*** ./node_modules/flickity/js/lazyload.js ***!
  \**********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// lazyload
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  var lazyAttr = 'data-flickity-lazyload';
  var lazySrcAttr = "".concat(lazyAttr, "-src");
  var lazySrcsetAttr = "".concat(lazyAttr, "-srcset");
  var imgSelector = "img[".concat(lazyAttr, "], img[").concat(lazySrcAttr, "], ") + "img[".concat(lazySrcsetAttr, "], source[").concat(lazySrcsetAttr, "]");
  Flickity.create.lazyLoad = function () {
    this.on('select', this.lazyLoad);
    this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
  };
  var proto = Flickity.prototype;
  proto.lazyLoad = function () {
    var _this = this;
    var lazyLoad = this.options.lazyLoad;
    if (!lazyLoad) return;

    // get adjacent cells, use lazyLoad option for adjacent count
    var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
    // lazy load images
    this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach(function (img) {
      return new LazyLoader(img, _this.handleLazyLoadComplete);
    });
  };
  function getCellLazyImages(cellElem) {
    // check if cell element is lazy image
    if (cellElem.matches('img')) {
      var cellAttr = cellElem.getAttribute(lazyAttr);
      var cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
      var cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
      if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
        return cellElem;
      }
    }
    // select lazy images in cell
    return _toConsumableArray(cellElem.querySelectorAll(imgSelector));
  }
  proto.onLazyLoadComplete = function (img, event) {
    var cell = this.getParentCell(img);
    var cellElem = cell && cell.element;
    this.cellSizeChange(cellElem);
    this.dispatchEvent('lazyLoad', event, cellElem);
  };

  // -------------------------- LazyLoader -------------------------- //

  /**
   * class to handle loading images
   * @param {Image} img - Image element
   * @param {Function} onComplete - callback function
   */
  function LazyLoader(img, onComplete) {
    this.img = img;
    this.onComplete = onComplete;
    this.load();
  }
  LazyLoader.prototype.handleEvent = utils.handleEvent;
  LazyLoader.prototype.load = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this);
    // get src & srcset
    var src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
    var srcset = this.img.getAttribute(lazySrcsetAttr);
    // set src & serset
    this.img.src = src;
    if (srcset) this.img.setAttribute('srcset', srcset);
    // remove attr
    this.img.removeAttribute(lazyAttr);
    this.img.removeAttribute(lazySrcAttr);
    this.img.removeAttribute(lazySrcsetAttr);
  };
  LazyLoader.prototype.onload = function (event) {
    this.complete(event, 'flickity-lazyloaded');
  };
  LazyLoader.prototype.onerror = function (event) {
    this.complete(event, 'flickity-lazyerror');
  };
  LazyLoader.prototype.complete = function (event, className) {
    // unbind events
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
    var mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
    mediaElem.classList.add(className);
    this.onComplete(this.img, event);
  };

  // -----  ----- //

  Flickity.LazyLoader = LazyLoader;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/page-dots.js":
/*!***********************************************!*\
  !*** ./node_modules/flickity/js/page-dots.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// page dots
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"), __webpack_require__(/*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  // -------------------------- PageDots -------------------------- //

  function PageDots() {
    // create holder element
    this.holder = document.createElement('div');
    this.holder.className = 'flickity-page-dots';
    // create dots, array of elements
    this.dots = [];
  }
  PageDots.prototype.setDots = function (slidesLength) {
    // get difference between number of slides and number of dots
    var delta = slidesLength - this.dots.length;
    if (delta > 0) {
      this.addDots(delta);
    } else if (delta < 0) {
      this.removeDots(-delta);
    }
  };
  PageDots.prototype.addDots = function (count) {
    var _this = this,
      _this$holder;
    var newDots = new Array(count).fill().map(function (item, i) {
      var dot = document.createElement('button');
      dot.setAttribute('type', 'button');
      var num = i + 1 + _this.dots.length;
      dot.className = 'flickity-page-dot';
      dot.textContent = "View slide ".concat(num);
      return dot;
    });
    (_this$holder = this.holder).append.apply(_this$holder, _toConsumableArray(newDots));
    this.dots = this.dots.concat(newDots);
  };
  PageDots.prototype.removeDots = function (count) {
    // remove from this.dots collection
    var removeDots = this.dots.splice(this.dots.length - count, count);
    // remove from DOM
    removeDots.forEach(function (dot) {
      return dot.remove();
    });
  };
  PageDots.prototype.updateSelected = function (index) {
    // remove selected class on previous
    if (this.selectedDot) {
      this.selectedDot.classList.remove('is-selected');
      this.selectedDot.removeAttribute('aria-current');
    }
    // don't proceed if no dots
    if (!this.dots.length) return;
    this.selectedDot = this.dots[index];
    this.selectedDot.classList.add('is-selected');
    this.selectedDot.setAttribute('aria-current', 'step');
  };
  Flickity.PageDots = PageDots;

  // -------------------------- Flickity -------------------------- //

  Object.assign(Flickity.defaults, {
    pageDots: true
  });
  Flickity.create.pageDots = function () {
    if (!this.options.pageDots) return;
    this.pageDots = new PageDots();
    this.handlePageDotsClick = this.onPageDotsClick.bind(this);
    // events
    this.on('activate', this.activatePageDots);
    this.on('select', this.updateSelectedPageDots);
    this.on('cellChange', this.updatePageDots);
    this.on('resize', this.updatePageDots);
    this.on('deactivate', this.deactivatePageDots);
  };
  var proto = Flickity.prototype;
  proto.activatePageDots = function () {
    var _this$focusableElems;
    this.pageDots.setDots(this.slides.length);
    (_this$focusableElems = this.focusableElems).push.apply(_this$focusableElems, _toConsumableArray(this.pageDots.dots));
    this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
    this.element.append(this.pageDots.holder);
  };
  proto.onPageDotsClick = function (event) {
    var index = this.pageDots.dots.indexOf(event.target);
    if (index === -1) return; // only dot clicks

    this.uiChange();
    this.select(index);
  };
  proto.updateSelectedPageDots = function () {
    this.pageDots.updateSelected(this.selectedIndex);
  };
  proto.updatePageDots = function () {
    var _this2 = this,
      _this$focusableElems2;
    this.pageDots.dots.forEach(function (dot) {
      utils.removeFrom(_this2.focusableElems, dot);
    });
    this.pageDots.setDots(this.slides.length);
    (_this$focusableElems2 = this.focusableElems).push.apply(_this$focusableElems2, _toConsumableArray(this.pageDots.dots));
  };
  proto.deactivatePageDots = function () {
    this.pageDots.holder.remove();
    this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
  };

  // -----  ----- //

  Flickity.PageDots = PageDots;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/player.js":
/*!********************************************!*\
  !*** ./node_modules/flickity/js/player.js ***!
  \********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// player & autoPlay
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"));
  } else {
    // browser global
    factory(window.Flickity);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity) {
  // -------------------------- Player -------------------------- //

  function Player(autoPlay, onTick) {
    this.autoPlay = autoPlay;
    this.onTick = onTick;
    this.state = 'stopped';
    // visibility change event handler
    this.onVisibilityChange = this.visibilityChange.bind(this);
    this.onVisibilityPlay = this.visibilityPlay.bind(this);
  }

  // start play
  Player.prototype.play = function () {
    if (this.state === 'playing') return;

    // do not play if page is hidden, start playing when page is visible
    var isPageHidden = document.hidden;
    if (isPageHidden) {
      document.addEventListener('visibilitychange', this.onVisibilityPlay);
      return;
    }
    this.state = 'playing';
    // listen to visibility change
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    // start ticking
    this.tick();
  };
  Player.prototype.tick = function () {
    var _this = this;
    // do not tick if not playing
    if (this.state !== 'playing') return;

    // default to 3 seconds
    var time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
    // HACK: reset ticks if stopped and started within interval
    this.clear();
    this.timeout = setTimeout(function () {
      _this.onTick();
      _this.tick();
    }, time);
  };
  Player.prototype.stop = function () {
    this.state = 'stopped';
    this.clear();
    // remove visibility change event
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  };
  Player.prototype.clear = function () {
    clearTimeout(this.timeout);
  };
  Player.prototype.pause = function () {
    if (this.state === 'playing') {
      this.state = 'paused';
      this.clear();
    }
  };
  Player.prototype.unpause = function () {
    // re-start play if paused
    if (this.state === 'paused') this.play();
  };

  // pause if page visibility is hidden, unpause if visible
  Player.prototype.visibilityChange = function () {
    var isPageHidden = document.hidden;
    this[isPageHidden ? 'pause' : 'unpause']();
  };
  Player.prototype.visibilityPlay = function () {
    this.play();
    document.removeEventListener('visibilitychange', this.onVisibilityPlay);
  };

  // -------------------------- Flickity -------------------------- //

  Object.assign(Flickity.defaults, {
    pauseAutoPlayOnHover: true
  });
  Flickity.create.player = function () {
    var _this2 = this;
    this.player = new Player(this.options.autoPlay, function () {
      _this2.next(true);
    });
    this.on('activate', this.activatePlayer);
    this.on('uiChange', this.stopPlayer);
    this.on('pointerDown', this.stopPlayer);
    this.on('deactivate', this.deactivatePlayer);
  };
  var proto = Flickity.prototype;
  proto.activatePlayer = function () {
    if (!this.options.autoPlay) return;
    this.player.play();
    this.element.addEventListener('mouseenter', this);
  };

  // Player API, don't hate the ... thanks I know where the door is

  proto.playPlayer = function () {
    this.player.play();
  };
  proto.stopPlayer = function () {
    this.player.stop();
  };
  proto.pausePlayer = function () {
    this.player.pause();
  };
  proto.unpausePlayer = function () {
    this.player.unpause();
  };
  proto.deactivatePlayer = function () {
    this.player.stop();
    this.element.removeEventListener('mouseenter', this);
  };

  // ----- mouseenter/leave ----- //

  // pause auto-play on hover
  proto.onmouseenter = function () {
    if (!this.options.pauseAutoPlayOnHover) return;
    this.player.pause();
    this.element.addEventListener('mouseleave', this);
  };

  // resume auto-play on hover off
  proto.onmouseleave = function () {
    this.player.unpause();
    this.element.removeEventListener('mouseleave', this);
  };

  // -----  ----- //

  Flickity.Player = Player;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/prev-next-button.js":
/*!******************************************************!*\
  !*** ./node_modules/flickity/js/prev-next-button.js ***!
  \******************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// prev/next buttons
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(__webpack_require__(/*! ./core */ "./node_modules/flickity/js/core.js"));
  } else {
    // browser global
    factory(window.Flickity);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity) {
  var svgURI = 'http://www.w3.org/2000/svg';

  // -------------------------- PrevNextButton -------------------------- //

  function PrevNextButton(increment, direction, arrowShape) {
    this.increment = increment;
    this.direction = direction;
    this.isPrevious = increment === 'previous';
    this.isLeft = direction === 'left';
    this._create(arrowShape);
  }
  PrevNextButton.prototype._create = function (arrowShape) {
    // properties
    var element = this.element = document.createElement('button');
    element.className = "flickity-button flickity-prev-next-button ".concat(this.increment);
    var label = this.isPrevious ? 'Previous' : 'Next';
    // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
    element.setAttribute('type', 'button');
    element.setAttribute('aria-label', label);
    // init as disabled
    this.disable();
    // create arrow
    var svg = this.createSVG(label, arrowShape);
    element.append(svg);
  };
  PrevNextButton.prototype.createSVG = function (label, arrowShape) {
    var svg = document.createElementNS(svgURI, 'svg');
    svg.setAttribute('class', 'flickity-button-icon');
    svg.setAttribute('viewBox', '0 0 100 100');
    // add title #1189
    var title = document.createElementNS(svgURI, 'title');
    title.append(label);
    // add path
    var path = document.createElementNS(svgURI, 'path');
    var pathMovements = getArrowMovements(arrowShape);
    path.setAttribute('d', pathMovements);
    path.setAttribute('class', 'arrow');
    // rotate arrow
    if (!this.isLeft) {
      path.setAttribute('transform', 'translate(100, 100) rotate(180)');
    }
    svg.append(title, path);
    return svg;
  };

  // get SVG path movmement
  function getArrowMovements(shape) {
    // use shape as movement if string
    if (typeof shape == 'string') return shape;
    var x0 = shape.x0,
      x1 = shape.x1,
      x2 = shape.x2,
      x3 = shape.x3,
      y1 = shape.y1,
      y2 = shape.y2;

    // create movement string
    return "M ".concat(x0, ", 50\n    L ").concat(x1, ", ").concat(y1 + 50, "\n    L ").concat(x2, ", ").concat(y2 + 50, "\n    L ").concat(x3, ", 50\n    L ").concat(x2, ", ").concat(50 - y2, "\n    L ").concat(x1, ", ").concat(50 - y1, "\n    Z");
  }

  // -----  ----- //

  PrevNextButton.prototype.enable = function () {
    this.element.removeAttribute('disabled');
  };
  PrevNextButton.prototype.disable = function () {
    this.element.setAttribute('disabled', true);
  };

  // -------------------------- Flickity prototype -------------------------- //

  Object.assign(Flickity.defaults, {
    prevNextButtons: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 70,
      y2: 40,
      x3: 30
    }
  });
  Flickity.create.prevNextButtons = function () {
    var _this = this;
    if (!this.options.prevNextButtons) return;
    var _this$options = this.options,
      rightToLeft = _this$options.rightToLeft,
      arrowShape = _this$options.arrowShape;
    var prevDirection = rightToLeft ? 'right' : 'left';
    var nextDirection = rightToLeft ? 'left' : 'right';
    this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
    this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
    this.focusableElems.push(this.prevButton.element);
    this.focusableElems.push(this.nextButton.element);
    this.handlePrevButtonClick = function () {
      _this.uiChange();
      _this.previous();
    };
    this.handleNextButtonClick = function () {
      _this.uiChange();
      _this.next();
    };
    this.on('activate', this.activatePrevNextButtons);
    this.on('select', this.updatePrevNextButtons);
  };
  var proto = Flickity.prototype;
  proto.updatePrevNextButtons = function () {
    var lastIndex = this.slides.length ? this.slides.length - 1 : 0;
    this.updatePrevNextButton(this.prevButton, 0);
    this.updatePrevNextButton(this.nextButton, lastIndex);
  };
  proto.updatePrevNextButton = function (button, disabledIndex) {
    // enable is wrapAround and at least 2 slides
    if (this.isWrapping && this.slides.length > 1) {
      button.enable();
      return;
    }
    var isEnabled = this.selectedIndex !== disabledIndex;
    button[isEnabled ? 'enable' : 'disable']();
    // if disabling button that is focused,
    // shift focus to element to maintain keyboard accessibility
    var isDisabledFocused = !isEnabled && document.activeElement === button.element;
    if (isDisabledFocused) this.focus();
  };
  proto.activatePrevNextButtons = function () {
    this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
    this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
    this.element.append(this.prevButton.element, this.nextButton.element);
    this.on('deactivate', this.deactivatePrevNextButtons);
  };
  proto.deactivatePrevNextButtons = function () {
    this.prevButton.element.remove();
    this.nextButton.element.remove();
    this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
    this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
    this.off('deactivate', this.deactivatePrevNextButtons);
  };

  // --------------------------  -------------------------- //

  Flickity.PrevNextButton = PrevNextButton;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/slide.js":
/*!*******************************************!*\
  !*** ./node_modules/flickity/js/slide.js ***!
  \*******************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// slide
(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }
})(typeof window != 'undefined' ? window : this, function factory() {
  function Slide(beginMargin, endMargin, cellAlign) {
    this.beginMargin = beginMargin;
    this.endMargin = endMargin;
    this.cellAlign = cellAlign;
    this.cells = [];
    this.outerWidth = 0;
    this.height = 0;
  }
  var proto = Slide.prototype;
  proto.addCell = function (cell) {
    this.cells.push(cell);
    this.outerWidth += cell.size.outerWidth;
    this.height = Math.max(cell.size.outerHeight, this.height);
    // first cell stuff
    if (this.cells.length === 1) {
      this.x = cell.x; // x comes from first cell
      this.firstMargin = cell.size[this.beginMargin];
    }
  };
  proto.updateTarget = function () {
    var lastCell = this.getLastCell();
    var lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
    var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
    this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
  };
  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };
  proto.select = function () {
    this.cells.forEach(function (cell) {
      return cell.select();
    });
  };
  proto.unselect = function () {
    this.cells.forEach(function (cell) {
      return cell.unselect();
    });
  };
  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };
  return Slide;
});

/***/ }),

/***/ "./node_modules/get-size/get-size.js":
/*!*******************************************!*\
  !*** ./node_modules/get-size/get-size.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */

(function (window, factory) {
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }
})(window, function factory() {
  // -------------------------- helpers -------------------------- //

  // get a number from a string, not a percentage
  function getStyleSize(value) {
    var num = parseFloat(value);
    // not a percent like '100%', and a number
    var isValid = value.indexOf('%') == -1 && !isNaN(num);
    return isValid && num;
  }

  // -------------------------- measurements -------------------------- //

  var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
  var measurementsLength = measurements.length;
  function getZeroSize() {
    var size = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    };
    measurements.forEach(function (measurement) {
      size[measurement] = 0;
    });
    return size;
  }

  // -------------------------- getSize -------------------------- //

  function getSize(elem) {
    // use querySeletor if elem is string
    if (typeof elem == 'string') elem = document.querySelector(elem);

    // do not proceed on non-objects
    var isElement = elem && _typeof(elem) == 'object' && elem.nodeType;
    if (!isElement) return;
    var style = getComputedStyle(elem);

    // if hidden, everything is 0
    if (style.display == 'none') return getZeroSize();
    var size = {};
    size.width = elem.offsetWidth;
    size.height = elem.offsetHeight;
    var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

    // get all measurements
    measurements.forEach(function (measurement) {
      var value = style[measurement];
      var num = parseFloat(value);
      // any 'auto', 'medium' value will be 0
      size[measurement] = !isNaN(num) ? num : 0;
    });
    var paddingWidth = size.paddingLeft + size.paddingRight;
    var paddingHeight = size.paddingTop + size.paddingBottom;
    var marginWidth = size.marginLeft + size.marginRight;
    var marginHeight = size.marginTop + size.marginBottom;
    var borderWidth = size.borderLeftWidth + size.borderRightWidth;
    var borderHeight = size.borderTopWidth + size.borderBottomWidth;

    // overwrite width and height if we can get it from style
    var styleWidth = getStyleSize(style.width);
    if (styleWidth !== false) {
      size.width = styleWidth + (
      // add padding and border unless it's already including it
      isBorderBox ? 0 : paddingWidth + borderWidth);
    }
    var styleHeight = getStyleSize(style.height);
    if (styleHeight !== false) {
      size.height = styleHeight + (
      // add padding and border unless it's already including it
      isBorderBox ? 0 : paddingHeight + borderHeight);
    }
    size.innerWidth = size.width - (paddingWidth + borderWidth);
    size.innerHeight = size.height - (paddingHeight + borderHeight);
    size.outerWidth = size.width + marginWidth;
    size.outerHeight = size.height + marginHeight;
    return size;
  }
  return getSize;
});

/***/ }),

/***/ "./node_modules/imagesloaded/imagesloaded.js":
/*!***************************************************!*\
  !*** ./node_modules/imagesloaded/imagesloaded.js ***!
  \***************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"));
  } else {
    // browser global
    window.imagesLoaded = factory(window, window.EvEmitter);
  }
})(typeof window !== 'undefined' ? window : this, function factory(window, EvEmitter) {
  var $ = window.jQuery;
  var console = window.console;

  // -------------------------- helpers -------------------------- //

  // turn element or nodeList into an array
  function makeArray(obj) {
    // use object if already an array
    if (Array.isArray(obj)) return obj;
    var isArrayLike = _typeof(obj) == 'object' && typeof obj.length == 'number';
    // convert nodeList to array
    if (isArrayLike) return _toConsumableArray(obj);

    // array of single index
    return [obj];
  }

  // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {[Array, Element, NodeList, String]} elem
   * @param {[Object, Function]} options - if function, use as callback
   * @param {Function} onAlways - callback function
   * @returns {ImagesLoaded}
   */
  function ImagesLoaded(elem, options, onAlways) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if (!(this instanceof ImagesLoaded)) {
      return new ImagesLoaded(elem, options, onAlways);
    }
    // use elem as selector string
    var queryElem = elem;
    if (typeof elem == 'string') {
      queryElem = document.querySelectorAll(elem);
    }
    // bail if bad element
    if (!queryElem) {
      console.error("Bad element for imagesLoaded ".concat(queryElem || elem));
      return;
    }
    this.elements = makeArray(queryElem);
    this.options = {};
    // shift arguments if no options set
    if (typeof options == 'function') {
      onAlways = options;
    } else {
      Object.assign(this.options, options);
    }
    if (onAlways) this.on('always', onAlways);
    this.getImages();
    // add jQuery Deferred object
    if ($) this.jqDeferred = new $.Deferred();

    // HACK check async to allow time to bind listeners
    setTimeout(this.check.bind(this));
  }
  ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
  ImagesLoaded.prototype.getImages = function () {
    this.images = [];

    // filter & find items if we have an item selector
    this.elements.forEach(this.addElementImages, this);
  };
  var elementNodeTypes = [1, 9, 11];

  /**
   * @param {Node} elem
   */
  ImagesLoaded.prototype.addElementImages = function (elem) {
    // filter siblings
    if (elem.nodeName === 'IMG') {
      this.addImage(elem);
    }
    // get background image on element
    if (this.options.background === true) {
      this.addElementBackgroundImages(elem);
    }

    // find children
    // no non-element nodes, #143
    var nodeType = elem.nodeType;
    if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
    var childImgs = elem.querySelectorAll('img');
    // concat childElems to filterFound array
    var _iterator = _createForOfIteratorHelper(childImgs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var img = _step.value;
        this.addImage(img);
      }

      // get child background images
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (typeof this.options.background == 'string') {
      var children = elem.querySelectorAll(this.options.background);
      var _iterator2 = _createForOfIteratorHelper(children),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          this.addElementBackgroundImages(child);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  };
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  ImagesLoaded.prototype.addElementBackgroundImages = function (elem) {
    var style = getComputedStyle(elem);
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    if (!style) return;

    // get url inside url("...")
    var matches = reURL.exec(style.backgroundImage);
    while (matches !== null) {
      var url = matches && matches[2];
      if (url) {
        this.addBackground(url, elem);
      }
      matches = reURL.exec(style.backgroundImage);
    }
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function (img) {
    var loadingImage = new LoadingImage(img);
    this.images.push(loadingImage);
  };
  ImagesLoaded.prototype.addBackground = function (url, elem) {
    var background = new Background(url, elem);
    this.images.push(background);
  };
  ImagesLoaded.prototype.check = function () {
    var _this = this;
    this.progressedCount = 0;
    this.hasAnyBroken = false;
    // complete if no images
    if (!this.images.length) {
      this.complete();
      return;
    }

    /* eslint-disable-next-line func-style */
    var onProgress = function onProgress(image, elem, message) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout(function () {
        _this.progress(image, elem, message);
      });
    };
    this.images.forEach(function (loadingImage) {
      loadingImage.once('progress', onProgress);
      loadingImage.check();
    });
  };
  ImagesLoaded.prototype.progress = function (image, elem, message) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // progress event
    this.emitEvent('progress', [this, image, elem]);
    if (this.jqDeferred && this.jqDeferred.notify) {
      this.jqDeferred.notify(this, image);
    }
    // check if completed
    if (this.progressedCount === this.images.length) {
      this.complete();
    }
    if (this.options.debug && console) {
      console.log("progress: ".concat(message), image, elem);
    }
  };
  ImagesLoaded.prototype.complete = function () {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emitEvent(eventName, [this]);
    this.emitEvent('always', [this]);
    if (this.jqDeferred) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[jqMethod](this);
    }
  };

  // --------------------------  -------------------------- //

  function LoadingImage(img) {
    this.img = img;
  }
  LoadingImage.prototype = Object.create(EvEmitter.prototype);
  LoadingImage.prototype.check = function () {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();
    if (isComplete) {
      // report based on naturalWidth
      this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    this.proxyImage = new Image();
    // add crossOrigin attribute. #204
    if (this.img.crossOrigin) {
      this.proxyImage.crossOrigin = this.img.crossOrigin;
    }
    this.proxyImage.addEventListener('load', this);
    this.proxyImage.addEventListener('error', this);
    // bind to image as well for Firefox. #191
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this);
    this.proxyImage.src = this.img.currentSrc || this.img.src;
  };
  LoadingImage.prototype.getIsImageComplete = function () {
    // check for non-zero, non-undefined naturalWidth
    // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
    return this.img.complete && this.img.naturalWidth;
  };
  LoadingImage.prototype.confirm = function (isLoaded, message) {
    this.isLoaded = isLoaded;
    var parentNode = this.img.parentNode;
    // emit progress with parent <picture> or self <img>
    var elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
    this.emitEvent('progress', [this, elem, message]);
  };

  // ----- events ----- //

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };
  LoadingImage.prototype.onload = function () {
    this.confirm(true, 'onload');
    this.unbindEvents();
  };
  LoadingImage.prototype.onerror = function () {
    this.confirm(false, 'onerror');
    this.unbindEvents();
  };
  LoadingImage.prototype.unbindEvents = function () {
    this.proxyImage.removeEventListener('load', this);
    this.proxyImage.removeEventListener('error', this);
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
  };

  // -------------------------- Background -------------------------- //

  function Background(url, element) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  }

  // inherit LoadingImage prototype
  Background.prototype = Object.create(LoadingImage.prototype);
  Background.prototype.check = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this);
    this.img.src = this.url;
    // check if image is already complete
    var isComplete = this.getIsImageComplete();
    if (isComplete) {
      this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
      this.unbindEvents();
    }
  };
  Background.prototype.unbindEvents = function () {
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
  };
  Background.prototype.confirm = function (isLoaded, message) {
    this.isLoaded = isLoaded;
    this.emitEvent('progress', [this, this.element, message]);
  };

  // -------------------------- jQuery -------------------------- //

  ImagesLoaded.makeJQueryPlugin = function (jQuery) {
    jQuery = jQuery || window.jQuery;
    if (!jQuery) return;

    // set local variable
    $ = jQuery;
    // $().imagesLoaded()
    $.fn.imagesLoaded = function (options, onAlways) {
      var instance = new ImagesLoaded(this, options, onAlways);
      return instance.jqDeferred.promise($(this));
    };
  };
  // try making plugin
  ImagesLoaded.makeJQueryPlugin();

  // --------------------------  -------------------------- //

  return ImagesLoaded;
});

/***/ }),

/***/ "./node_modules/unidragger/unidragger.js":
/*!***********************************************!*\
  !*** ./node_modules/unidragger/unidragger.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */

(function (window, factory) {
  // universal module definition
  if (( false ? 0 : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, __webpack_require__(/*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"));
  } else {
    // browser global
    window.Unidragger = factory(window, window.EvEmitter);
  }
})(typeof window != 'undefined' ? window : this, function factory(window, EvEmitter) {
  function Unidragger() {}

  // inherit EvEmitter
  var proto = Unidragger.prototype = Object.create(EvEmitter.prototype);

  // ----- bind start ----- //

  // trigger handler methods for events
  proto.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };
  var startEvent, activeEvents;
  if ('ontouchstart' in window) {
    // HACK prefer Touch Events as you can preventDefault on touchstart to
    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
    startEvent = 'touchstart';
    activeEvents = ['touchmove', 'touchend', 'touchcancel'];
  } else if (window.PointerEvent) {
    // Pointer Events
    startEvent = 'pointerdown';
    activeEvents = ['pointermove', 'pointerup', 'pointercancel'];
  } else {
    // mouse events
    startEvent = 'mousedown';
    activeEvents = ['mousemove', 'mouseup'];
  }

  // prototype so it can be overwriteable by Flickity
  proto.touchActionValue = 'none';
  proto.bindHandles = function () {
    this._bindHandles('addEventListener', this.touchActionValue);
  };
  proto.unbindHandles = function () {
    this._bindHandles('removeEventListener', '');
  };

  /**
   * Add or remove start event
   * @param {String} bindMethod - addEventListener or removeEventListener
   * @param {String} touchAction - value for touch-action CSS property
   */
  proto._bindHandles = function (bindMethod, touchAction) {
    var _this = this;
    this.handles.forEach(function (handle) {
      handle[bindMethod](startEvent, _this);
      handle[bindMethod]('click', _this);
      // touch-action: none to override browser touch gestures. metafizzy/flickity#540
      if (window.PointerEvent) handle.style.touchAction = touchAction;
    });
  };
  proto.bindActivePointerEvents = function () {
    var _this2 = this;
    activeEvents.forEach(function (eventName) {
      window.addEventListener(eventName, _this2);
    });
  };
  proto.unbindActivePointerEvents = function () {
    var _this3 = this;
    activeEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, _this3);
    });
  };

  // ----- event handler helpers ----- //

  // trigger method with matching pointer
  proto.withPointer = function (methodName, event) {
    if (event.pointerId === this.pointerIdentifier) {
      this[methodName](event, event);
    }
  };

  // trigger method with matching touch
  proto.withTouch = function (methodName, event) {
    var touch;
    var _iterator = _createForOfIteratorHelper(event.changedTouches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var changedTouch = _step.value;
        if (changedTouch.identifier === this.pointerIdentifier) {
          touch = changedTouch;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (touch) this[methodName](event, touch);
  };

  // ----- start event ----- //

  proto.onmousedown = function (event) {
    this.pointerDown(event, event);
  };
  proto.ontouchstart = function (event) {
    this.pointerDown(event, event.changedTouches[0]);
  };
  proto.onpointerdown = function (event) {
    this.pointerDown(event, event);
  };

  // nodes that have text fields
  var cursorNodes = ['TEXTAREA', 'INPUT', 'SELECT', 'OPTION'];
  // input types that do not have text fields
  var clickTypes = ['radio', 'checkbox', 'button', 'submit', 'image', 'file'];

  /**
   * any time you set `event, pointer` it refers to:
   * @param {Event} event
   * @param {Event | Touch} pointer
   */
  proto.pointerDown = function (event, pointer) {
    // dismiss multi-touch taps, right clicks, and clicks on text fields
    var isCursorNode = cursorNodes.includes(event.target.nodeName);
    var isClickType = clickTypes.includes(event.target.type);
    var isOkayElement = !isCursorNode || isClickType;
    var isOkay = !this.isPointerDown && !event.button && isOkayElement;
    if (!isOkay) return;
    this.isPointerDown = true;
    // save pointer identifier to match up touch events
    this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;
    // track position for move
    this.pointerDownPointer = {
      pageX: pointer.pageX,
      pageY: pointer.pageY
    };
    this.bindActivePointerEvents();
    this.emitEvent('pointerDown', [event, pointer]);
  };

  // ----- move ----- //

  proto.onmousemove = function (event) {
    this.pointerMove(event, event);
  };
  proto.onpointermove = function (event) {
    this.withPointer('pointerMove', event);
  };
  proto.ontouchmove = function (event) {
    this.withTouch('pointerMove', event);
  };
  proto.pointerMove = function (event, pointer) {
    var moveVector = {
      x: pointer.pageX - this.pointerDownPointer.pageX,
      y: pointer.pageY - this.pointerDownPointer.pageY
    };
    this.emitEvent('pointerMove', [event, pointer, moveVector]);
    // start drag if pointer has moved far enough to start drag
    var isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
    if (isDragStarting) this.dragStart(event, pointer);
    if (this.isDragging) this.dragMove(event, pointer, moveVector);
  };

  // condition if pointer has moved far enough to start drag
  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
  };

  // ----- drag ----- //

  proto.dragStart = function (event, pointer) {
    this.isDragging = true;
    this.isPreventingClicks = true; // set flag to prevent clicks
    this.emitEvent('dragStart', [event, pointer]);
  };
  proto.dragMove = function (event, pointer, moveVector) {
    this.emitEvent('dragMove', [event, pointer, moveVector]);
  };

  // ----- end ----- //

  proto.onmouseup = function (event) {
    this.pointerUp(event, event);
  };
  proto.onpointerup = function (event) {
    this.withPointer('pointerUp', event);
  };
  proto.ontouchend = function (event) {
    this.withTouch('pointerUp', event);
  };
  proto.pointerUp = function (event, pointer) {
    this.pointerDone();
    this.emitEvent('pointerUp', [event, pointer]);
    if (this.isDragging) {
      this.dragEnd(event, pointer);
    } else {
      // pointer didn't move enough for drag to start
      this.staticClick(event, pointer);
    }
  };
  proto.dragEnd = function (event, pointer) {
    var _this4 = this;
    this.isDragging = false; // reset flag
    // re-enable clicking async
    setTimeout(function () {
      return delete _this4.isPreventingClicks;
    });
    this.emitEvent('dragEnd', [event, pointer]);
  };

  // triggered on pointer up & pointer cancel
  proto.pointerDone = function () {
    this.isPointerDown = false;
    delete this.pointerIdentifier;
    this.unbindActivePointerEvents();
    this.emitEvent('pointerDone');
  };

  // ----- cancel ----- //

  proto.onpointercancel = function (event) {
    this.withPointer('pointerCancel', event);
  };
  proto.ontouchcancel = function (event) {
    this.withTouch('pointerCancel', event);
  };
  proto.pointerCancel = function (event, pointer) {
    this.pointerDone();
    this.emitEvent('pointerCancel', [event, pointer]);
  };

  // ----- click ----- //

  // handle all clicks and prevent clicks when dragging
  proto.onclick = function (event) {
    if (this.isPreventingClicks) event.preventDefault();
  };

  // triggered after pointer down & up with no/tiny movement
  proto.staticClick = function (event, pointer) {
    var _this5 = this;
    // ignore emulated mouse up clicks
    var isMouseup = event.type === 'mouseup';
    if (isMouseup && this.isIgnoringMouseUp) return;
    this.emitEvent('staticClick', [event, pointer]);

    // set flag for emulated clicks 300ms after touchend
    if (isMouseup) {
      this.isIgnoringMouseUp = true;
      // reset flag after 400ms
      setTimeout(function () {
        delete _this5.isIgnoringMouseUp;
      }, 400);
    }
  };

  // -----  ----- //

  return Unidragger;
});

/***/ }),

/***/ "./src/js/helpers/format-money.js":
/*!****************************************!*\
  !*** ./src/js/helpers/format-money.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || '${{amount}}';
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  var value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/helpers/scroll-to-element.js":
/*!*********************************************!*\
  !*** ./src/js/helpers/scroll-to-element.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "scrollToElement": () => (/* binding */ scrollToElement)
/* harmony export */ });
var scrollToElement = function scrollToElement(target) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var targetElement = null;

  // 1️⃣ HTMLElement direkt übergeben
  if (target instanceof HTMLElement) {
    targetElement = target;
  }

  // 2️⃣ String übergeben
  else if (typeof target === 'string') {
    // a) normaler Selector (#id / .class / [data-x])
    if (target.startsWith('#') || target.startsWith('.') || target.startsWith('[')) {
      targetElement = document.querySelector(target);
    }

    // b) alter Shopify Section Shortcut
    else {
      targetElement = document.querySelector('#shopify-section-' + target);
    }
  }
  if (!targetElement) return;
  var y = targetElement.getBoundingClientRect().top + window.pageYOffset + offset;
  window.scrollTo({
    top: y,
    behavior: 'smooth'
  });
};

/***/ }),

/***/ "./src/js/modules/bundle-builder/ed-bundle-builder-cart-helper.js":
/*!************************************************************************!*\
  !*** ./src/js/modules/bundle-builder/ed-bundle-builder-cart-helper.js ***!
  \************************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdBundleBuilderCartHelper = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleBuilderCartHelper, _HTMLElement);
  var _super = _createSuper(EdBundleBuilderCartHelper);
  function EdBundleBuilderCartHelper() {
    _classCallCheck(this, EdBundleBuilderCartHelper);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleBuilderCartHelper, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._boot();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (window.jQuery && this._onCartRequestComplete) {
        window.jQuery(document).off('cart.requestComplete', this._onCartRequestComplete);
      }
      if (this._onToggleClick) {
        document.removeEventListener('click', this._onToggleClick);
      }
    }
  }, {
    key: "_boot",
    value: function () {
      var _boot2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this._attachListeners();
              _context.next = 3;
              return this._waitForCartRender();
            case 3:
              this._attachSelectors();
              this._cleanupInjectedBundleLists();
              this.bundleComponentsLists.forEach(function (list) {
                return _this.moveListToCartItem(list);
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _boot() {
        return _boot2.apply(this, arguments);
      }
      return _boot;
    }()
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      if (!window.jQuery) return;

      // einmal binden (für off())
      if (!this._onCartRequestComplete) {
        this._onCartRequestComplete = function () {
          return _this2.onCartChanged();
        };
      }
      window.jQuery(document).on('cart.requestComplete', this._onCartRequestComplete);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.bundleComponentsLists = Array.from(this.querySelectorAll('.ed-bb-bundle-components-list[data-line-key]'));
      this.cartItems = Array.from(document.querySelectorAll('.cart__product[data-key]'));
      this.cartItemByKey = new Map(this.cartItems.map(function (el) {
        return [String(el.dataset.key || '').trim(), el];
      }));
    }
  }, {
    key: "onCartChanged",
    value: function () {
      var _onCartChanged = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var sectionId, url, res, json, html, doc, freshRoot, currentRoot;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              sectionId = this.getAttribute('data-section-id');
              if (sectionId) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              url = "/?sections=".concat(encodeURIComponent(sectionId));
              _context2.next = 7;
              return fetch(url, {
                headers: {
                  Accept: 'application/json'
                }
              });
            case 7:
              res = _context2.sent;
              if (res.ok) {
                _context2.next = 10;
                break;
              }
              return _context2.abrupt("return");
            case 10:
              _context2.next = 12;
              return res.json();
            case 12:
              json = _context2.sent;
              html = json === null || json === void 0 ? void 0 : json[sectionId];
              if (html) {
                _context2.next = 16;
                break;
              }
              return _context2.abrupt("return");
            case 16:
              doc = new DOMParser().parseFromString(html, 'text/html'); // Shopify wrapper ist IMMER da:
              freshRoot = doc.querySelector("#shopify-section-".concat(CSS.escape(sectionId)));
              currentRoot = document.querySelector("#shopify-section-".concat(CSS.escape(sectionId)));
              if (!(!freshRoot || !currentRoot)) {
                _context2.next = 21;
                break;
              }
              return _context2.abrupt("return");
            case 21:
              currentRoot.replaceWith(freshRoot);
              _context2.next = 27;
              break;
            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](3);
              console.warn('[EdBundleBuilderCartHelper] section rerender failed', _context2.t0);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 24]]);
      }));
      function onCartChanged() {
        return _onCartChanged.apply(this, arguments);
      }
      return onCartChanged;
    }()
  }, {
    key: "_waitForCartRender",
    value: function () {
      var _waitForCartRender2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var start, maxMs;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              start = Date.now();
              maxMs = 4000;
            case 2:
              if (!(Date.now() - start < maxMs)) {
                _context3.next = 9;
                break;
              }
              if (!document.querySelector('.cart__product[data-key]')) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              _context3.next = 7;
              return new Promise(function (r) {
                return setTimeout(r, 50);
              });
            case 7:
              _context3.next = 2;
              break;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function _waitForCartRender() {
        return _waitForCartRender2.apply(this, arguments);
      }
      return _waitForCartRender;
    }()
  }, {
    key: "moveListToCartItem",
    value: function moveListToCartItem(list) {
      var key = String(list.dataset.lineKey || '').trim();
      if (!key) return;
      var cartItem = this.cartItemByKey.get(key);
      if (!cartItem) return;
      var target = cartItem.querySelector('.ed-bundle-components[data-bundle-components]');
      if (!target) return;
      if (target.dataset.bbEnhanced === 'true') return;
      list.classList.add('ed-bundle-components-list', 'is-inline');
      var toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'ed-bundle-components__toggle';
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.textContent = 'Bundle Inhalt anzeigen';
      target.innerHTML = '';
      target.appendChild(toggleBtn);
      target.appendChild(list);
      target.classList.remove('active');
      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = target.classList.toggle('active');
        toggleBtn.setAttribute('aria-expanded', String(isOpen));
        toggleBtn.textContent = isOpen ? 'Weniger anzeigen' : 'Bundle Inhalt anzeigen';
      });
      target.dataset.bbEnhanced = 'true';
    }
  }, {
    key: "_cleanupInjectedBundleLists",
    value: function _cleanupInjectedBundleLists() {
      document.querySelectorAll('.ed-bundle-components[data-bundle-components]').forEach(function (target) {
        var _target$querySelector, _target$querySelector2;
        if (target.dataset.bbEnhanced !== 'true') return;

        // injected list + toggle entfernen (nur das, was wir eingefügt haben)
        (_target$querySelector = target.querySelector('.ed-bundle-components__toggle')) === null || _target$querySelector === void 0 ? void 0 : _target$querySelector.remove();
        (_target$querySelector2 = target.querySelector('.ed-bundle-components-list')) === null || _target$querySelector2 === void 0 ? void 0 : _target$querySelector2.remove();
        target.classList.remove('active');
        delete target.dataset.bbEnhanced;
      });
    }
  }]);
  return EdBundleBuilderCartHelper;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-builder-cart-helper')) {
  customElements.define('ed-bundle-builder-cart-helper', EdBundleBuilderCartHelper);
}

/***/ }),

/***/ "./src/js/modules/bundle-builder/ed-bundle-builder-cart.js":
/*!*****************************************************************!*\
  !*** ./src/js/modules/bundle-builder/ed-bundle-builder-cart.js ***!
  \*****************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdBundleBuilderCart = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleBuilderCart, _HTMLElement);
  var _super = _createSuper(EdBundleBuilderCart);
  function EdBundleBuilderCart() {
    _classCallCheck(this, EdBundleBuilderCart);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleBuilderCart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.cart = [];
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.bundleBuilderMain = this.closest('ed-bundle-builder');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.bundleBuilderMain.addEventListener('ed:bb:add-to-cart', this.onAddToCart.bind(this));
      this.bundleBuilderMain.addEventListener('ed:bb:remove-from-cart', this.onRemoveFromCart.bind(this));
      this.bundleBuilderMain.addEventListener('ed:bb:remove-from-cart-by-index', this.onRemoveFromCartByIndex.bind(this));
    }
  }, {
    key: "onAddToCart",
    value: function onAddToCart(e) {
      var newItem = e.detail;
      this.addToCart(newItem);
    }
  }, {
    key: "onRemoveFromCart",
    value: function onRemoveFromCart(e) {
      var _ref = e.detail || {},
        variantId = _ref.variantId;
      if (!variantId) return;
      this.removeFromCart(variantId);
    }
  }, {
    key: "onRemoveFromCartByIndex",
    value: function onRemoveFromCartByIndex(e) {
      var _e$detail;
      var idx = Number((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.index);
      if (!Number.isFinite(idx)) return;
      this.removeFromCartByIndex(idx);
    }
  }, {
    key: "setCart",
    value: function setCart(newCart) {
      this.cart = Array.isArray(newCart) ? newCart : [];
      this._emitCartUpdated();
    }
  }, {
    key: "addToCart",
    value: function addToCart(itemData) {
      var _this$bundleBuilderMa, _this$bundleBuilderMa2;
      var qty = Number(itemData.quantity || 1);
      var limitedBundle = true; // todo
      var currentCartSize = this.cart.length;
      var nextLimit = Number(((_this$bundleBuilderMa = this.bundleBuilderMain) === null || _this$bundleBuilderMa === void 0 ? void 0 : (_this$bundleBuilderMa2 = _this$bundleBuilderMa._getNextLimit) === null || _this$bundleBuilderMa2 === void 0 ? void 0 : _this$bundleBuilderMa2.call(_this$bundleBuilderMa)) || 0);

      // wenn es kein nächstes Limit gibt -> "open bundle" / unlimited
      if (limitedBundle && nextLimit > 0 && currentCartSize + qty >= nextLimit) {
        var _this$bundleBuilderMa3;
        var requiredSize = currentCartSize + qty;
        (_this$bundleBuilderMa3 = this.bundleBuilderMain) === null || _this$bundleBuilderMa3 === void 0 ? void 0 : _this$bundleBuilderMa3.dispatchEvent(new CustomEvent('ed:bb:need-upgrade', {
          detail: {
            requiredSize: requiredSize,
            nextLimit: nextLimit,
            attemptedQty: qty,
            itemData: itemData
          },
          bubbles: true,
          composed: true
        }));
        return;
      }

      // NICHT blocken: wir dürfen über currentSlotSize hinaus adden (4/3 ist ok)
      for (var i = 0; i < qty; i++) {
        this.cart.push(_objectSpread(_objectSpread({}, itemData), {}, {
          quantity: 1
        }));
      }
      this._emitCartUpdated();
    }
  }, {
    key: "removeFromCart",
    value: function removeFromCart(variantId) {
      var index = this.cart.findIndex(function (item) {
        return String(item.variantId) === String(variantId);
      });
      if (index === -1) return;
      this.cart.splice(index, 1);
      this._emitCartUpdated();
    }
  }, {
    key: "removeFromCartByIndex",
    value: function removeFromCartByIndex(idx) {
      if (!Array.isArray(this.cart)) this.cart = [];
      if (idx < 0 || idx >= this.cart.length) return;
      this.cart.splice(idx, 1);
      this._emitCartUpdated();
    }
  }, {
    key: "_emitCartUpdated",
    value: function _emitCartUpdated() {
      var _this$bundleBuilderMa4;
      var eventTarget = this.bundleBuilderMain || document;
      var currentCartSize = this.cart.length;
      var currentBundleSize = (_this$bundleBuilderMa4 = this.bundleBuilderMain) === null || _this$bundleBuilderMa4 === void 0 ? void 0 : _this$bundleBuilderMa4.currentSlotSize;
      eventTarget.dispatchEvent(new CustomEvent('ed:bb:cart-updated', {
        detail: {
          cart: this.cart,
          cartSize: currentCartSize,
          currentBundleSize: currentBundleSize
        },
        bubbles: true,
        composed: true
      }));
    }
  }]);
  return EdBundleBuilderCart;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-builder-cart')) {
  customElements.define('ed-bundle-builder-cart', EdBundleBuilderCart);
}

/***/ }),

/***/ "./src/js/modules/bundle-builder/ed-bundle-builder-item-drawer.js":
/*!************************************************************************!*\
  !*** ./src/js/modules/bundle-builder/ed-bundle-builder-item-drawer.js ***!
  \************************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdBundleBuilderItemDrawer = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleBuilderItemDrawer, _HTMLElement);
  var _super = _createSuper(EdBundleBuilderItemDrawer);
  function EdBundleBuilderItemDrawer() {
    _classCallCheck(this, EdBundleBuilderItemDrawer);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleBuilderItemDrawer, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'open') return;
      if (newValue !== null) {
        this.onOpen();
      } else {
        this.onClose();
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.baseUrl = 'https://' + this.getAttribute('base-url');
      this.collectionId = this.getAttribute('data-collection');
      this.collectionGid = this.getAttribute('data-collection-gid') || "gid://shopify/Collection/".concat(this.collectionId);
      this.cursors = [null];
      this.currentPage = 1;
      this.activeFilterInputsByKey = new Map();
      this.facetsByKey = new Map();

      // search
      this.debugDisableCollectionTag = false; // note: if set to false, metafield is used in search
      this.searchTerm = '';
      this._searchDebounce = null;

      // load more function
      this._isLoadingMore = false;
      this._hasNextPage = true;
      this._io = null;
      this._attachSelectors();
      this._attachListeners();
      setTimeout(function () {
        _this._applyI18n();
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener('click', this.onClickOutside);
      if (this._io) this._io.disconnect();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.bundleBuilderMain = document.querySelector('ed-bundle-builder');
      this.filterSelects = this.querySelectorAll('select');
      this.productListContainer = this.querySelector('[data-product-list]');
      this.drawerHeader = this.querySelector('[data-drawer-header]');
      this.searchInput = this.querySelector('[data-search-input]');
      this.loadMoreSentinel = this.querySelector('[data-load-more-sentinel]');
      this.ctaClose = this.querySelector('[data-btn-close]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      this.addEventListener('click', this.onClickOutside);
      this.drawerHeader.addEventListener('click', this.closeDrawer.bind(this));
      this.ctaClose.addEventListener('click', this.closeDrawer.bind(this));
      this.filterSelects.forEach(function (select) {
        select.addEventListener('change', _this2.onFilterSelectChange.bind(_this2));
      });
      this.searchInput.addEventListener('input', this.onSearchInputChange.bind(this));
      this.bundleBuilderMain.addEventListener('ed:bb:cart-updated', this.onCartUpdated.bind(this));
    }
  }, {
    key: "_applyI18n",
    value: function _applyI18n() {
      var _this$searchInput;
      var main = this.bundleBuilderMain;
      if (!main) return;
      this.drawerHeader = this.querySelector('[data-drawer-title]');
      if (this.drawerHeader) {
        this.drawerHeader.innerText = main.drawerHeading;
      }
      this.labelDrawerCta = this.querySelector('[data-drawer-cta]');
      if (this.labelDrawerCta) {
        this.labelDrawerCta.innerText = main.labelDrawerCta;
      }
      (_this$searchInput = this.searchInput) === null || _this$searchInput === void 0 ? void 0 : _this$searchInput.setAttribute('placeholder', main === null || main === void 0 ? void 0 : main.labelSearchPlaceholder);
      this.filterLabel = this.querySelector('[data-drawer-filter-label]');
      if (this.filterLabel) {
        this.filterLabel.innerText = main.filterLabel;
      }
      this.filterLabelSize = this.querySelector('[data-drawer-filter-size]');
      if (this.filterLabelSize) {
        this.filterLabelSize.innerText = main.filterLabelSize;
      }
      this.filterLabelCategory = this.querySelector('[data-drawer-filter-category]');
      if (this.filterLabelCategory) {
        this.filterLabelCategory.innerText = main.filterLabelCategory;
      }
    }
  }, {
    key: "onCartUpdated",
    value: function onCartUpdated(e) {
      var cart = e.detail.cart || [];
      if (!this.productListContainer) return;
      var qtyByVariantId = new Map();
      cart.forEach(function (line) {
        var vId = line.variantId;
        if (!vId) return;
        qtyByVariantId.set(vId, (qtyByVariantId.get(vId) || 0) + 1);
      });

      // set next discount badge
      var badge = this.bundleBuilderMain && typeof this.bundleBuilderMain._getNextAddBadge === 'function' ? this.bundleBuilderMain._getNextAddBadge() : null;
      var items = this.productListContainer.querySelectorAll('ed-bundle-builder-item');
      items.forEach(function (item) {
        var variantId = item.dataset.variantId;
        var qty = qtyByVariantId.get(variantId) || 0;
        if (typeof item.setQuantityInCart === 'function') {
          item.setQuantityInCart(qty);
        }
        if (typeof item.setNextAddBadge === 'function') {
          item.setNextAddBadge(badge);
        }
      });
    }

    /*** SEARCH ***/
  }, {
    key: "onSearchInputChange",
    value: function onSearchInputChange(e) {
      var _this3 = this;
      var value = (e.target.value || '').trim();
      this.searchTerm = value;
      clearTimeout(this._searchDebounce);
      this._searchDebounce = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3._resetAndFetch();
            case 2:
              _this3._setupInfiniteScroll();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), 250);
    }
  }, {
    key: "_resetAndFetch",
    value: function () {
      var _resetAndFetch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this._io) this._io.disconnect();
              this.currentPage = 1;
              this.cursors = [null];
              if (this.productListContainer) this.productListContainer.innerHTML = '';
              this._hasNextPage = true;
              this._isLoadingMore = false;

              // important: wait for initial fetch
              _context2.next = 8;
              return this.fetchCurrent();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _resetAndFetch() {
        return _resetAndFetch2.apply(this, arguments);
      }
      return _resetAndFetch;
    }() /*** FILTERS ***/
  }, {
    key: "onFilterSelectChange",
    value: function () {
      var _onFilterSelectChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var _select$selectedOptio;
        var select, key, selected, val, _selected$dataset, inputJson;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              select = e.target;
              key = select.dataset.filterKey;
              if (key) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              selected = (_select$selectedOptio = select.selectedOptions) === null || _select$selectedOptio === void 0 ? void 0 : _select$selectedOptio[0];
              val = select.value; // remove filter
              if (!val || val === '__all__') {
                this.activeFilterInputsByKey["delete"](key);
              } else {
                inputJson = selected === null || selected === void 0 ? void 0 : (_selected$dataset = selected.dataset) === null || _selected$dataset === void 0 ? void 0 : _selected$dataset.input;
                if (inputJson) {
                  try {
                    this.activeFilterInputsByKey.set(key, JSON.parse(inputJson));
                  } catch (err) {
                    console.warn('Invalid filter input JSON', inputJson, err);
                  }
                }
              }
              _context3.next = 9;
              return this._resetAndFetch();
            case 9:
              this._setupInfiniteScroll();
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function onFilterSelectChange(_x) {
        return _onFilterSelectChange.apply(this, arguments);
      }
      return onFilterSelectChange;
    }()
  }, {
    key: "fetchCurrent",
    value: function fetchCurrent() {
      if (this.searchTerm && this.searchTerm.length >= 2) {
        return this.fetchSearchProducts(this.currentPage);
      }
      return this.fetchCollectionProducts(this.collectionGid, this.currentPage);
    }
  }, {
    key: "fetchSearchProducts",
    value: function () {
      var _fetchSearchProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(pageNumber) {
        var _json$data;
        var productsPerPage, afterCursor, _this$_getStorefrontC, language, country, productFilters, q, query, res, json, conn, pageInfo;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              productsPerPage = 20;
              afterCursor = this.cursors[pageNumber - 2] || null;
              _this$_getStorefrontC = this._getStorefrontContext(), language = _this$_getStorefrontC.language, country = _this$_getStorefrontC.country; // note: kein {available: true} Filter -> ausverkaufte Produkte werden bewusst mit angezeigt
              // (Badge + Add-Blockierung erfolgt in ed-bundle-builder-item)
              productFilters = []; // ATTENTION: FILTER HAS TO BE ENABLED IN SEARCH & DISCOVERY APP
              if (this.debugDisableCollectionTag !== true) {
                productFilters.push({
                  productMetafield: {
                    namespace: "ed_ink",
                    key: "bb_collection_id",
                    value: String(this.collectionId)
                  }
                });
              }
              productFilters.push.apply(productFilters, _toConsumableArray(Array.from(this.activeFilterInputsByKey.values())));

              // Suchquery: Suchterm + optional Collection-Einschränkung
              // Hinweis: Ob collection_id im Shop-Suchindex unterstützt ist, kann je nach Setup variieren.
              // Wenn es bei dir nicht greift, lass den collection_id Teil weg.
              q = "".concat(this.searchTerm);
              query = "\n            query SearchProducts($first: Int!, $after: String, $query: String!, $productFilters: [ProductFilter!], $language: LanguageCode, $country: CountryCode) @inContext(country: $country, language: $language) {\n              search(first: $first, after: $after, query: $query, types: [PRODUCT], productFilters: $productFilters) {\n        \n                productFilters {\n                  id\n                  label\n                  type\n                  values {\n                    id\n                    label\n                    count\n                    input\n                  }\n                }\n        \n                edges {\n                  cursor\n                  node {\n                    ... on Product {\n                      id\n                      title\n                      handle\n                      featuredImage {\n                        url(transform: { maxWidth: 400, maxHeight: 400 })\n                        altText\n                        width\n                        height\n                      }\n                      images(first: 3) {\n                          edges {\n                            node {\n                              url(transform: { maxWidth: 400, maxHeight: 400 })\n                              altText\n                              width\n                              height\n                            }\n                          }\n                       }\n                      variants(first: 50) {\n                        edges {\n                          node {\n                            id\n                            title\n                            availableForSale\n                            price { amount currencyCode }\n                            image {\n                                url(transform: { maxWidth: 400, maxHeight: 400 })\n                                altText\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n                pageInfo { hasNextPage endCursor }\n              }\n            }\n          ";
              _context4.next = 10;
              return fetch(this.baseUrl + '/api/2025-10/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  query: query,
                  variables: {
                    first: productsPerPage,
                    after: afterCursor,
                    query: q,
                    productFilters: productFilters,
                    language: language,
                    country: country
                  }
                })
              });
            case 10:
              res = _context4.sent;
              _context4.next = 13;
              return res.json();
            case 13:
              json = _context4.sent;
              if (!json.errors) {
                _context4.next = 17;
                break;
              }
              console.error('Search GraphQL errors:', json.errors);
              return _context4.abrupt("return");
            case 17:
              conn = json === null || json === void 0 ? void 0 : (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.search; // render filters
              this.renderFilterSelects((conn === null || conn === void 0 ? void 0 : conn.productFilters) || []);
              this.renderProducts((conn === null || conn === void 0 ? void 0 : conn.edges) || []);
              pageInfo = conn === null || conn === void 0 ? void 0 : conn.pageInfo;
              if (pageInfo !== null && pageInfo !== void 0 && pageInfo.endCursor && !this.cursors[pageNumber - 1]) {
                this.cursors[pageNumber - 1] = pageInfo.endCursor;
              }
              this._hasNextPage = !!(pageInfo !== null && pageInfo !== void 0 && pageInfo.hasNextPage);
            case 23:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchSearchProducts(_x2) {
        return _fetchSearchProducts.apply(this, arguments);
      }
      return fetchSearchProducts;
    }()
  }, {
    key: "fetchCollectionProducts",
    value: function () {
      var _fetchCollectionProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(collectionId, pageNumber) {
        var _json$data2, _json$data2$collectio, _json$data3, _json$data3$collectio, _json$data3$collectio2;
        var _this$_getStorefrontC2, language, country, productsPerPage, afterCursor, filters, query, res, json, conn, pageInfo;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this$_getStorefrontC2 = this._getStorefrontContext(), language = _this$_getStorefrontC2.language, country = _this$_getStorefrontC2.country;
              productsPerPage = 20;
              afterCursor = this.cursors[pageNumber - 2]; // note: kein {available: true} Filter -> ausverkaufte Produkte werden bewusst mit angezeigt
              filters = _toConsumableArray(Array.from(this.activeFilterInputsByKey.values()));
              query = "\n            query CollectionProducts($collectionId: ID!, $first: Int!, $after: String, $filters: [ProductFilter!], $country: CountryCode, $language: LanguageCode) @inContext(country: $country, language: $language) {\n              collection(id: $collectionId) {\n                products(first: $first, after: $after, filters: $filters) {\n        \n                  filters {\n                    id\n                    label\n                    type\n                    values {\n                      id\n                      label\n                      count\n                      input\n                    }\n                  }\n        \n                  edges {\n                    cursor\n                    node {\n                      id\n                      title\n                      handle\n                      featuredImage {\n                        url(transform: { maxWidth: 400, maxHeight: 400 })\n                        altText\n                        width\n                        height\n                      }\n                      images(first: 3) {\n                          edges {\n                            node {\n                              url(transform: { maxWidth: 400, maxHeight: 400 })\n                              altText\n                              width\n                              height\n                            }\n                          }\n                       }\n                      variants(first: 50) {\n                        edges {\n                          node {\n                            id\n                            title\n                            availableForSale\n                            price { amount currencyCode }\n                            image {\n                                url(transform: { maxWidth: 400, maxHeight: 400 })\n                                altText\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                  pageInfo { hasNextPage endCursor }\n                }\n              }\n            }\n          ";
              _context5.next = 7;
              return fetch(this.baseUrl + '/api/2025-10/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  query: query,
                  variables: {
                    collectionId: collectionId,
                    first: productsPerPage,
                    after: afterCursor,
                    filters: filters,
                    language: language,
                    country: country
                  }
                })
              });
            case 7:
              res = _context5.sent;
              _context5.next = 10;
              return res.json();
            case 10:
              json = _context5.sent;
              if (!json.errors) {
                _context5.next = 14;
                break;
              }
              console.error('Collection GraphQL errors:', json.errors);
              return _context5.abrupt("return");
            case 14:
              conn = json === null || json === void 0 ? void 0 : (_json$data2 = json.data) === null || _json$data2 === void 0 ? void 0 : (_json$data2$collectio = _json$data2.collection) === null || _json$data2$collectio === void 0 ? void 0 : _json$data2$collectio.products; // init filter facets
              if (!this._filtersInitialized) {
                this.renderFilterSelects((conn === null || conn === void 0 ? void 0 : conn.filters) || []);
                //this._filtersInitialized = true;
              }

              this.renderProducts((conn === null || conn === void 0 ? void 0 : conn.edges) || []);
              pageInfo = json === null || json === void 0 ? void 0 : (_json$data3 = json.data) === null || _json$data3 === void 0 ? void 0 : (_json$data3$collectio = _json$data3.collection) === null || _json$data3$collectio === void 0 ? void 0 : (_json$data3$collectio2 = _json$data3$collectio.products) === null || _json$data3$collectio2 === void 0 ? void 0 : _json$data3$collectio2.pageInfo;
              if (pageInfo !== null && pageInfo !== void 0 && pageInfo.endCursor && !this.cursors[pageNumber - 1]) {
                this.cursors[pageNumber - 1] = pageInfo.endCursor;
              }
              this._hasNextPage = !!(pageInfo !== null && pageInfo !== void 0 && pageInfo.hasNextPage);
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchCollectionProducts(_x3, _x4) {
        return _fetchCollectionProducts.apply(this, arguments);
      }
      return fetchCollectionProducts;
    }()
  }, {
    key: "renderProducts",
    value: function renderProducts(edges) {
      var _this4 = this,
        _this$bundleBuilderMa,
        _this$bundleBuilderMa2;
      if (!this.productListContainer) {
        return;
      }
      var fragment = document.createDocumentFragment();
      edges.forEach(function (edge) {
        var _node$variants, _node$images, _defaultVariant$price, _this4$bundleBuilderM, _this4$bundleBuilderM2;
        var node = edge === null || edge === void 0 ? void 0 : edge.node;
        if (!node) return;
        var variantsAll = (((_node$variants = node.variants) === null || _node$variants === void 0 ? void 0 : _node$variants.edges) || []).map(function (e) {
          return e === null || e === void 0 ? void 0 : e.node;
        }).filter(Boolean).map(function (variant) {
          var _variant$price$amount, _variant$price, _variant$image, _variant$image2;
          return {
            id: stripShopifyGid(variant.id),
            title: variant.title || '',
            availableForSale: !!variant.availableForSale,
            price: (_variant$price$amount = variant === null || variant === void 0 ? void 0 : (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : _variant$price.amount) !== null && _variant$price$amount !== void 0 ? _variant$price$amount : null,
            imageUrl: (variant === null || variant === void 0 ? void 0 : (_variant$image = variant.image) === null || _variant$image === void 0 ? void 0 : _variant$image.url) || '',
            imageAlt: (variant === null || variant === void 0 ? void 0 : (_variant$image2 = variant.image) === null || _variant$image2 === void 0 ? void 0 : _variant$image2.altText) || ''
          };
        });

        // get first variant
        var defaultVariant = variantsAll.find(function (v) {
          return v.availableForSale;
        }) || variantsAll[0] || null;

        // images
        var images = (((_node$images = node.images) === null || _node$images === void 0 ? void 0 : _node$images.edges) || []).map(function (e) {
          return e === null || e === void 0 ? void 0 : e.node;
        }).filter(Boolean);
        var imageUrlsAll = images.map(function (img) {
          return img.url;
        }).filter(Boolean);
        var imageAltsAll = images.map(function (img) {
          return img.altText || '';
        }).filter(Boolean);
        var imageUrls = [];
        if (imageUrlsAll[0]) imageUrls.push(imageUrlsAll[0]);
        if (imageUrlsAll[2]) imageUrls.push(imageUrlsAll[2]);
        var imageAlt = imageAltsAll[0] || node.title || '';
        var item = document.createElement('ed-bundle-builder-item');
        var rawProductId = node.id;

        // Nur Daten setzen, kein HTML
        item.productData = {
          productId: stripShopifyGid(rawProductId),
          handle: node.handle,
          variantId: (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.id) || '',
          variants: variantsAll,
          title: node.title,
          productTitle: node.title,
          // for display name title + variant title
          price: (_defaultVariant$price = defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.price) !== null && _defaultVariant$price !== void 0 ? _defaultVariant$price : null,
          imageUrls: imageUrls,
          imageAlt: imageAlt,
          labelBtnPreview: (_this4$bundleBuilderM = _this4.bundleBuilderMain) === null || _this4$bundleBuilderM === void 0 ? void 0 : _this4$bundleBuilderM.labelBtnPreview,
          labelSoldOut: (_this4$bundleBuilderM2 = _this4.bundleBuilderMain) === null || _this4$bundleBuilderM2 === void 0 ? void 0 : _this4$bundleBuilderM2.labelSoldOut
        };
        fragment.appendChild(item);
      });
      this.productListContainer.appendChild(fragment);

      // update cart for badges
      this.onCartUpdated({
        detail: {
          cart: ((_this$bundleBuilderMa = this.bundleBuilderMain) === null || _this$bundleBuilderMa === void 0 ? void 0 : (_this$bundleBuilderMa2 = _this$bundleBuilderMa.bundleBuilderCart) === null || _this$bundleBuilderMa2 === void 0 ? void 0 : _this$bundleBuilderMa2.cart) || []
        }
      });

      // set next badges
      /**
       const badge =
       this.bundleBuilderMain && typeof this.bundleBuilderMain._getNextAddBadge === 'function'
       ? this.bundleBuilderMain._getNextAddBadge()
       : null;
        this.productListContainer
       .querySelectorAll('ed-bundle-builder-item')
       .forEach(item => {
       if (typeof item.setNextAddBadge === 'function') {
       item.setNextAddBadge(badge);
       }
       });
       ***/
    }

    /** INFINITE SCROLL + LOAD MORE **/
  }, {
    key: "_setupInfiniteScroll",
    value: function _setupInfiniteScroll() {
      var _this5 = this;
      if (!this.loadMoreSentinel) return;
      if (this._io) this._io.disconnect();
      var rootEl = this.querySelector('.drawer-inner');
      this._io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!(entry !== null && entry !== void 0 && entry.isIntersecting)) return;

        // Bedingungen
        if (!_this5._hasNextPage) return;
        if (_this5._isLoadingMore) return;
        _this5._isLoadingMore = true;
        _this5.currentPage += 1;
        Promise.resolve(_this5.fetchCurrent())["finally"](function () {
          _this5._isLoadingMore = false;
        });
      }, {
        root: rootEl,
        rootMargin: '200px 0px',
        // lädt schon etwas vor "ganz unten"
        threshold: 0.01
      });
      this._io.observe(this.loadMoreSentinel);
    }
  }, {
    key: "onLoadMore",
    value: function onLoadMore() {
      this.currentPage += 1;
      this.fetchCurrent();
    }

    /** POPUP HANDLING **/
  }, {
    key: "onClickOutside",
    value: function onClickOutside(event) {
      if (event.target === this) {
        this.closeDrawer();
      }
    }
  }, {
    key: "onOpen",
    value: function () {
      var _onOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this$bundleBuilderMa3, _this$bundleBuilderMa4;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this._lockBodyScroll();
              if (this.initialLoad) {
                _context6.next = 8;
                break;
              }
              this.initialLoad = true;
              _context6.next = 5;
              return this.fetchCurrent();
            case 5:
              // WICHTIG: erst fertig laden…
              this._setupInfiniteScroll(); // …dann Observer aktivieren
              _context6.next = 9;
              break;
            case 8:
              this._setupInfiniteScroll();
            case 9:
              this.onCartUpdated({
                detail: {
                  cart: ((_this$bundleBuilderMa3 = this.bundleBuilderMain) === null || _this$bundleBuilderMa3 === void 0 ? void 0 : (_this$bundleBuilderMa4 = _this$bundleBuilderMa3.bundleBuilderCart) === null || _this$bundleBuilderMa4 === void 0 ? void 0 : _this$bundleBuilderMa4.cart) || []
                }
              });
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function onOpen() {
        return _onOpen.apply(this, arguments);
      }
      return onOpen;
    }()
  }, {
    key: "onClose",
    value: function onClose() {
      this._unlockBodyScroll();
    }
  }, {
    key: "closeDrawer",
    value: function closeDrawer() {
      this.removeAttribute('open');
    }

    // lock
  }, {
    key: "_lockBodyScroll",
    value: function _lockBodyScroll() {
      if (document.documentElement.classList.contains('ed-scroll-locked')) return;

      // save scrol position
      this._scrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('ed-scroll-locked');
      document.body.classList.add('ed-scroll-locked');

      // for ios
      document.body.style.position = 'fixed';
      document.body.style.top = "-".concat(this._scrollY, "px");
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
  }, {
    key: "_unlockBodyScroll",
    value: function _unlockBodyScroll() {
      if (!document.documentElement.classList.contains('ed-scroll-locked')) return;
      document.documentElement.classList.remove('ed-scroll-locked');
      document.body.classList.remove('ed-scroll-locked');

      // reset scrol
      var y = this._scrollY || 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, y);
      this._scrollY = 0;
    }

    /*** FILTER LOGIC ***/
  }, {
    key: "renderFilterSelects",
    value: function renderFilterSelects(facets) {
      var _this$filterSelects,
        _this6 = this;
      if (!((_this$filterSelects = this.filterSelects) !== null && _this$filterSelects !== void 0 && _this$filterSelects.length)) return;
      this.filterSelects.forEach(function (select) {
        var _select$querySelector;
        var key = select.dataset.filterKey;
        if (!key) return;
        var prevValue = select.value;
        var facet = _this6._matchFacetForKey(key, facets);
        if (!facet) return;
        var placeholderText = ((_select$querySelector = select.querySelector("option")) === null || _select$querySelector === void 0 ? void 0 : _select$querySelector.textContent) || "Kategorie";
        if (key === 'size') {
          select.innerHTML = "\n                <option value=\"\" disabled selected>".concat(placeholderText, "</option>\n                <option value=\"__all__\">Alle anzeigen</option>\n                ");
        } else if (key === 'category') {
          select.innerHTML = "\n                <option value=\"\" disabled selected>".concat(placeholderText, "</option>\n                ");
        }
        facet.values.forEach(function (v) {
          var opt = document.createElement("option");
          opt.value = v.id;
          opt.textContent = "".concat(v.label, " (").concat(v.count, ")");
          opt.dataset.input = v.input;
          select.appendChild(opt);
        });
        if (_toConsumableArray(select.options).some(function (o) {
          return o.value === prevValue;
        })) {
          select.value = prevValue;
        }
      });
    }
  }, {
    key: "_matchFacetForKey",
    value: function _matchFacetForKey(key, facets) {
      var norm = function norm(s) {
        return (s || '').toLowerCase();
      };
      if (key === 'size') {
        return facets.find(function (f) {
          return ['größe', 'size'].includes(norm(f.label));
        });
      }
      if (key === 'category') {
        return facets.find(function (f) {
          return ['kategorie', 'category'].includes(norm(f.label));
        });
      }
      return null;
    }
  }, {
    key: "_getStorefrontContext",
    value: function _getStorefrontContext() {
      var htmlLang = document.documentElement.getAttribute('lang') || 'de-DE';

      // akzeptiert z. B. en-US, en_US, en
      var normalized = htmlLang.replace('_', '-');
      var _normalized$split = normalized.split('-'),
        _normalized$split2 = _slicedToArray(_normalized$split, 2),
        _normalized$split2$ = _normalized$split2[0],
        langPart = _normalized$split2$ === void 0 ? 'de' : _normalized$split2$,
        _normalized$split2$2 = _normalized$split2[1],
        countryPart = _normalized$split2$2 === void 0 ? 'DE' : _normalized$split2$2;
      return {
        raw: htmlLang,
        language: langPart.toUpperCase(),
        country: countryPart.toUpperCase()
      };
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['open'];
    }
  }]);
  return EdBundleBuilderItemDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-builder-item-drawer')) {
  customElements.define('ed-bundle-builder-item-drawer', EdBundleBuilderItemDrawer);
}
function stripShopifyGid(gid) {
  if (!gid) return '';
  // nimmt den Teil nach dem letzten Slash
  return gid.split('/').pop();
}

/***/ }),

/***/ "./src/js/modules/bundle-builder/ed-bundle-builder-item.js":
/*!*****************************************************************!*\
  !*** ./src/js/modules/bundle-builder/ed-bundle-builder-item.js ***!
  \*****************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdBundleBuilderItem = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleBuilderItem, _HTMLElement);
  var _super = _createSuper(EdBundleBuilderItem);
  function EdBundleBuilderItem() {
    _classCallCheck(this, EdBundleBuilderItem);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleBuilderItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      if (this._productData) {
        this._render();
      }
    }
  }, {
    key: "productData",
    get: function get() {
      return this._productData;
    },
    set: function set(data) {
      this._productData = data;
      this._syncDatasetFromData();
      this._render();
    }
  }, {
    key: "_syncDatasetFromData",
    value: function _syncDatasetFromData() {
      if (!this._productData) return;
      var _this$_productData = this._productData,
        productId = _this$_productData.productId,
        handle = _this$_productData.handle,
        variantId = _this$_productData.variantId,
        imageAlt = _this$_productData.imageAlt;
      var imageUrl = Array.isArray(this._productData.imageUrls) && this._productData.imageUrls[0] || this._productData.imageUrl || '';
      this.dataset.productId = productId || '';
      this.dataset.productHandle = handle || '';
      this.dataset.variantId = variantId || '';
      this.dataset.imageUrl = imageUrl || '';
      this.dataset.imageAlt = imageAlt || '';
    }
  }, {
    key: "_buildItemData",
    value: function _buildItemData() {
      var _this$variantSelectEl;
      var data = this._productData || {};
      var imageUrl = Array.isArray(data.imageUrls) && data.imageUrls[0] || data.imageUrl || this.dataset.imageUrl || '';

      // get selected variant id
      var selectedVariantId = ((_this$variantSelectEl = this.variantSelectEl) === null || _this$variantSelectEl === void 0 ? void 0 : _this$variantSelectEl.value) || data.variantId || this.dataset.variantId;

      // build item title
      var variants = Array.isArray(data.variants) ? data.variants : [];
      var selected = variants.find(function (v) {
        return String(v.id) === String(selectedVariantId);
      });
      var productTitle = data.productTitle || data.title || '';
      var displayTitle = this._getDisplayTitle(productTitle, selected === null || selected === void 0 ? void 0 : selected.title);
      return {
        productId: data.productId || this.dataset.productId,
        variantId: selectedVariantId,
        handle: data.handle || this.dataset.productHandle,
        quantity: 1,
        title: displayTitle,
        imageUrl: imageUrl,
        imageAlt: data.imageAlt || this.dataset.imageAlt,
        price: data.price || null,
        available: this._isSelectedVariantAvailable()
      };
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.bundleBuilderMain = document.querySelector('ed-bundle-builder');
      // more selectors in _render()
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('click', this._onClick.bind(this));
    }
  }, {
    key: "_render",
    value: function _render() {
      var _this$qtyPlus,
        _this = this,
        _this$qtyMinus,
        _this$variantSelectEl2;
      var data = this._productData;
      if (!data) return;
      var title = data.title,
        _data$imageUrls = data.imageUrls,
        imageUrls = _data$imageUrls === void 0 ? [] : _data$imageUrls,
        imageAlt = data.imageAlt,
        labelBtnPreview = data.labelBtnPreview;
      var a = imageUrls[0] || '';
      var b = imageUrls[1] || '';

      /* variant select*/
      var variants = Array.isArray(data.variants) ? data.variants : [];
      var hasVariantSelect = variants.length > 1;
      var optionsHtml = hasVariantSelect ? variants.map(function (v) {
        var label = v.title || 'Variante';
        var disabled = v.availableForSale ? '' : 'disabled';
        var selected = String(v.id) === String(data.variantId) ? 'selected' : '';
        return "<option value=\"".concat(v.id, "\" ").concat(selected, " ").concat(disabled, ">").concat(label, "</option>");
      }).join('') : '';
      /* end variant select */

      this.innerHTML = "\n            <div class=\"image-container\" data-swipe>\n             <div class=\"bb-swipe-track\" data-track>\n                 <img class=\"bb-swipe-img is-active\" data-img-a src=\"".concat(a, "\" alt=\"").concat(imageAlt || title, "\" draggable=\"false\" />\n                 ").concat(b ? "<img class=\"bb-swipe-img\" data-img-b src=\"".concat(b, "\" alt=\"").concat(imageAlt || title, "\" draggable=\"false\" />") : "", "\n             </div>\n             \n             ").concat(b ? "\n              <div class=\"bb-dots\" data-dots aria-label=\"Bildauswahl\">\n                <button type=\"button\" class=\"bb-dot is-active\" data-dot=\"0\" aria-label=\"Bild 1\"></button>\n                <button type=\"button\" class=\"bb-dot\" data-dot=\"1\" aria-label=\"Bild 2\"></button>\n              </div>\n              " : "", "\n             \n                <div class=\"qty-selector\">\n                <div class=\"qty-minus\" data-qty-minus></div>\n                <div class=\"qty-input\"><input type=\"number\" data-qty-in-cart/></div>\n                <div class=\"qty-plus\" data-qty-plus></div>\n                </div>\n                <div class=\"bb-next-badge\" data-next-badge></div>\n                <div class=\"bb-sold-out-badge\" data-sold-out-badge></div>\n            </div>\n            <div class=\"ed-bundle-item-title\">\n                ").concat(title, "\n            </div>\n             ").concat(hasVariantSelect ? "\n                <div class=\"ed-bundle-item-variant\">\n                  <select class=\"ed-bundle-item-variant-select\" data-variant-select aria-label=\"Variante w\xE4hlen\">\n                    ".concat(optionsHtml, "\n                  </select>\n                </div>\n              ") : '', "\n            <div class=\"ed-bundle-item-preview-button\" data-open-preview>\n                + ").concat(labelBtnPreview, "\n            </div>\n        ");

      // nach innerHTML neu referenzen holen
      this.classList.add('ed-bundle-item');
      this.imageEl = this.querySelector('img');
      this.titleEl = this.querySelector('.ed-bundle-item-title');
      this.qtyEl = this.querySelector('[data-qty-in-cart]');
      this.qtyPlus = this.querySelector('[data-qty-plus]');
      this.qtyMinus = this.querySelector('[data-qty-minus]');
      this.variantSelectEl = this.querySelector('[data-variant-select]');
      this.btnOpenPreview = this.querySelector('[data-open-preview]');

      // Listener
      (_this$qtyPlus = this.qtyPlus) === null || _this$qtyPlus === void 0 ? void 0 : _this$qtyPlus.addEventListener('click', function (e) {
        e.stopPropagation();
        _this.onQtyPlus();
      });
      (_this$qtyMinus = this.qtyMinus) === null || _this$qtyMinus === void 0 ? void 0 : _this$qtyMinus.addEventListener('click', function (e) {
        e.stopPropagation();
        _this.onQtyMinus();
      });
      this.btnOpenPreview.addEventListener('click', function (e) {
        var _this$bundleBuilderMa;
        e.preventDefault();
        e.stopPropagation();
        var data = _this._productData || {};
        var itemData = _this._buildItemData();
        (_this$bundleBuilderMa = _this.bundleBuilderMain) === null || _this$bundleBuilderMa === void 0 ? void 0 : _this$bundleBuilderMa.dispatchEvent(new CustomEvent('ed:bb:open-preview', {
          detail: {
            handle: data.handle,
            title: data.title,
            variantId: itemData.variantId,
            itemData: itemData
          },
          bubbles: true,
          composed: true
        }));
      });

      // Variant select change
      (_this$variantSelectEl2 = this.variantSelectEl) === null || _this$variantSelectEl2 === void 0 ? void 0 : _this$variantSelectEl2.addEventListener('change', function (e) {
        var _this$_productData2, _this$bundleBuilderMa2, _this$bundleBuilderMa3;
        e.stopPropagation();
        var selectedId = _this.variantSelectEl.value;
        if (!selectedId) return;
        _this.dataset.variantId = String(selectedId);
        var variants = Array.isArray((_this$_productData2 = _this._productData) === null || _this$_productData2 === void 0 ? void 0 : _this$_productData2.variants) ? _this._productData.variants : [];
        var selected = variants.find(function (v) {
          return String(v.id) === String(selectedId);
        });
        if (_this._productData) {
          _this._productData.variantId = String(selectedId);
          if (selected && selected.price != null) {
            _this._productData.price = selected.price;
          }
        }
        var cart = ((_this$bundleBuilderMa2 = _this.bundleBuilderMain) === null || _this$bundleBuilderMa2 === void 0 ? void 0 : (_this$bundleBuilderMa3 = _this$bundleBuilderMa2.bundleBuilderCart) === null || _this$bundleBuilderMa3 === void 0 ? void 0 : _this$bundleBuilderMa3.cart) || [];
        var qty = cart.reduce(function (sum, line) {
          return sum + (String(line === null || line === void 0 ? void 0 : line.variantId) === String(selectedId) ? 1 : 0);
        }, 0);
        _this.setQuantityInCart(qty);

        // show variant image
        var imgA = _this.querySelector('[data-img-a]');
        if (imgA && selected !== null && selected !== void 0 && selected.imageUrl) {
          imgA.src = selected.imageUrl;
          imgA.alt = selected.imageAlt || imgA.alt || '';
        }

        // variant image in cart
        if (_this._productData && selected !== null && selected !== void 0 && selected.imageUrl) {
          _this._productData.imageUrls = [selected.imageUrl].concat(_toConsumableArray((_this._productData.imageUrls || []).slice(1)));
        }

        // change title
        if (_this.titleEl && selected) {
          var _this$_productData3, _this$_productData4;
          var productTitle = ((_this$_productData3 = _this._productData) === null || _this$_productData3 === void 0 ? void 0 : _this$_productData3.productTitle) || ((_this$_productData4 = _this._productData) === null || _this$_productData4 === void 0 ? void 0 : _this$_productData4.title) || '';
          _this.titleEl.textContent = _this._getDisplayTitle(productTitle, selected.title);
        }

        // re-evaluate sold out state for the newly selected variant
        _this._updateSoldOutState();
      });

      // for swipe function
      this._imageUrls = Array.isArray(imageUrls) ? imageUrls : [];
      this._imageIndex = 0;
      this._setupSwipe();

      // sold out state (badge + block add)
      this._updateSoldOutState();
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      var plus = e.target.closest('[data-qty-plus]');
      if (plus) {
        e.preventDefault();
        this.onQtyPlus();
        return;
      }
      var minus = e.target.closest('[data-qty-minus]');
      if (minus) {
        e.preventDefault();
        this.onQtyMinus();
        return;
      }
      var btnPreview = e.target.closest('[data-open-preview]');
      if (btnPreview) {
        e.preventDefault();
        return;
      }
      var dot = e.target.closest('[data-dot]');
      if (dot) {
        e.preventDefault();
        return;
      }
      var variantSelect = e.target.closest('[data-variant-select]');
      if (variantSelect) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // prevent atc when swiping
      if (this._suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.onItemClick(e);
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(e) {
      if (e.target.closest('.qty-selector')) return;
      if (!this._isSelectedVariantAvailable()) return; // ausverkauft -> nicht hinzufügen
      var itemData = this._buildItemData();
      this.bundleBuilderMain.dispatchEvent(new CustomEvent('ed:bb:add-to-cart', {
        detail: itemData,
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "setQuantityInCart",
    value: function setQuantityInCart(quantity) {
      var qty = Number(quantity || 0);
      if (!this.qtyEl) {
        this.qtyEl = this.querySelector('[data-qty-in-cart]');
      }
      if (!this.qtyEl) return;
      if (qty > 0) {
        this.qtyEl.value = String(qty);
        this.classList.add('has-qty-in-cart');
      } else {
        // wenn du lieber 0 anzeigen willst:
        // this.qtyEl.value = '0';
        this.qtyEl.value = '';
        this.classList.remove('has-qty-in-cart');
      }
    }

    /*** QUANTITY ***/
  }, {
    key: "onQtyMinus",
    value: function onQtyMinus() {
      var _this$_productData5;
      var variantId = ((_this$_productData5 = this._productData) === null || _this$_productData5 === void 0 ? void 0 : _this$_productData5.variantId) || this.dataset.variantId;
      if (!variantId) return;
      this.bundleBuilderMain.dispatchEvent(new CustomEvent('ed:bb:remove-from-cart', {
        detail: {
          variantId: variantId
        },
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "onQtyPlus",
    value: function onQtyPlus() {
      if (!this._isSelectedVariantAvailable()) return; // ausverkauft -> nicht hinzufügen
      var itemData = this._buildItemData();
      this.bundleBuilderMain.dispatchEvent(new CustomEvent('ed:bb:add-to-cart', {
        detail: itemData,
        bubbles: true,
        composed: true
      }));
    }

    /** SOLD OUT LOGIC **/
  }, {
    key: "_isSelectedVariantAvailable",
    value: function _isSelectedVariantAvailable() {
      var _this$variantSelectEl3;
      var data = this._productData || {};
      var variants = Array.isArray(data.variants) ? data.variants : [];
      if (!variants.length) return true; // keine Variant-Infos -> nicht blockieren

      var selectedId = ((_this$variantSelectEl3 = this.variantSelectEl) === null || _this$variantSelectEl3 === void 0 ? void 0 : _this$variantSelectEl3.value) || data.variantId || this.dataset.variantId;
      var selected = variants.find(function (v) {
        return String(v.id) === String(selectedId);
      });
      if (!selected) return true;
      return !!selected.availableForSale;
    }
  }, {
    key: "_updateSoldOutState",
    value: function _updateSoldOutState() {
      var soldOut = !this._isSelectedVariantAvailable();
      this.classList.toggle('is-sold-out', soldOut);
      var badgeEl = this.querySelector('[data-sold-out-badge]');
      if (badgeEl) {
        var _this$_productData6;
        badgeEl.textContent = soldOut ? ((_this$_productData6 = this._productData) === null || _this$_productData6 === void 0 ? void 0 : _this$_productData6.labelSoldOut) || '' : '';
      }

      // sold out hat Vorrang vor "Gratis"/Rabatt Badge (gleiche Position oben links)
      if (soldOut) {
        var nextBadge = this.querySelector('[data-next-badge]');
        if (nextBadge) {
          nextBadge.textContent = '';
          nextBadge.classList.remove('active', 'is-free', 'is-discount');
        }
      }
    }

    /** BADGE LOGIC **/
  }, {
    key: "setNextAddBadge",
    value: function setNextAddBadge(badge) {
      var el = this.querySelector('[data-next-badge]');
      if (!el) return;

      // ausverkauft: kein "nächstes Add"-Badge, sold out badge bleibt sichtbar
      if (this.classList.contains('is-sold-out')) {
        el.textContent = '';
        el.classList.remove('active', 'is-free', 'is-discount');
        return;
      }
      if (!badge || !badge.label) {
        el.textContent = '';
        el.classList.remove('active', 'is-free', 'is-discount');
        return;
      }
      el.textContent = badge.label;
      el.classList.add('active');
      if (badge.type === 'free') {
        el.classList.add('is-free');
        el.classList.remove('is-discount');
      } else if (badge.type === 'discount') {
        el.classList.add('is-discount');
        el.classList.remove('is-free');
      } else {
        el.classList.remove('is-free', 'is-discount');
      }
    }

    /** SWIPE FUNCTION **/
  }, {
    key: "_setupSwipe",
    value: function _setupSwipe() {
      var _this2 = this;
      this._suppressClick = false;
      var swipeArea = this.querySelector('[data-swipe]');
      var track = this.querySelector('[data-track]');
      if (!swipeArea || !track) return;
      if (!this._imageUrls || this._imageUrls.length < 2) return;
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastT = 0;
      var vx = 0;
      var dragging = false;
      var axisLocked = false;
      var isHorizontal = false;
      var axisRatio = 1.2;
      var lockThreshold = 6; // px bis lock
      var snapDistance = 0.22; // % der Breite (22%)
      var snapVelocity = 0.5; // px/ms
      var maxIndex = 1; // nur 2 slides

      var setTrack = function setTrack(percent, withAnim) {
        track.style.transition = withAnim ? 'transform 260ms cubic-bezier(.22,.61,.36,1)' : 'none';
        track.style.transform = "translate3d(".concat(percent, "%,0,0)");
      };
      var basePercent = function basePercent() {
        return -(_this2._imageIndex * 50);
      }; // 0 => 0%, 1 => -50%

      var onDown = function onDown(e) {
        var _swipeArea$setPointer;
        if (e.target.closest('.qty-selector') || e.target.closest('[data-open-preview]')) return;
        _this2._suppressClick = false;
        dragging = true;
        axisLocked = false;
        isHorizontal = false;
        startX = lastX = e.clientX;
        startY = e.clientY;
        lastT = performance.now();
        vx = 0;

        // Transition aus, damit es “am Finger klebt”
        setTrack(basePercent(), false);
        (_swipeArea$setPointer = swipeArea.setPointerCapture) === null || _swipeArea$setPointer === void 0 ? void 0 : _swipeArea$setPointer.call(swipeArea, e.pointerId);
      };
      var onMove = function onMove(e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        // axis lock
        if (!axisLocked) {
          if (Math.abs(dx) < lockThreshold && Math.abs(dy) < lockThreshold) return;
          axisLocked = true;
          if (Math.abs(dy) > Math.abs(dx) * axisRatio) {
            // vertical scroll -> abort drag
            dragging = false;
            return;
          }
          isHorizontal = true;
        }
        if (!isHorizontal) return;
        if (Math.abs(dx) > 8) _this2._suppressClick = true;

        // Scroll verhindern, aber nur wenn wir horizontal sind
        e.preventDefault();

        // velocity (px/ms)
        var now = performance.now();
        var dt = Math.max(1, now - lastT);
        vx = (e.clientX - lastX) / dt;
        lastX = e.clientX;
        lastT = now;

        // translate in %
        var w = swipeArea.clientWidth || 1;
        var deltaPercent = dx / w * 50; // 50% entspricht 1 slide
        var next = basePercent() + deltaPercent;

        // clamp: 0% bis -50%
        next = Math.min(0, Math.max(-50, next));
        setTrack(next, false);
      };
      var onUp = function onUp(e) {
        if (!dragging) return;
        dragging = false;
        if (_this2._suppressClick) {
          setTimeout(function () {
            _this2._suppressClick = false;
          }, 0);
        }
        var dx = e.clientX - startX;
        var w = swipeArea.clientWidth || 1;
        var moved = dx / w; // -1..1

        // Entscheidungslogik: Distanz oder Velocity
        var nextIndex = _this2._imageIndex;
        if (Math.abs(vx) > snapVelocity) {
          // schneller fling
          nextIndex = vx < 0 ? 1 : 0;
        } else if (Math.abs(moved) > snapDistance) {
          // genug gezogen
          nextIndex = moved < 0 ? 1 : 0;
        }
        _this2._imageIndex = Math.max(0, Math.min(maxIndex, nextIndex));
        setTrack(basePercent(), true);
        _this2._updateDots();
      };
      swipeArea.addEventListener('pointerdown', onDown, {
        passive: true
      });
      swipeArea.addEventListener('pointermove', onMove, {
        passive: false
      });
      swipeArea.addEventListener('pointerup', onUp, {
        passive: true
      });
      swipeArea.addEventListener('pointercancel', onUp, {
        passive: true
      });

      // sicherstellen: initial korrekt
      setTrack(basePercent(), true);
      this._bindDotClicks();
      this._updateDots();
    }
  }, {
    key: "_goToImage",
    value: function _goToImage(nextIndex) {
      var imgs = this._imageUrls || [];
      if (imgs.length < 2) return;
      var max = imgs.length - 1;
      var idx = Math.max(0, Math.min(max, nextIndex));
      if (idx === this._imageIndex) return;
      this._imageIndex = idx;
      var imgEl = this.querySelector('.image-container img');
      if (!imgEl) return;
      imgEl.src = imgs[idx];
    }
  }, {
    key: "_updateDots",
    value: function _updateDots() {
      var _this3 = this;
      var dots = this.querySelectorAll('[data-dot]');
      if (!(dots !== null && dots !== void 0 && dots.length)) return;
      dots.forEach(function (btn) {
        var i = Number(btn.dataset.dot || 0);
        btn.classList.toggle('is-active', i === _this3._imageIndex);
      });
    }
  }, {
    key: "_bindDotClicks",
    value: function _bindDotClicks() {
      var _this4 = this;
      var dotsWrap = this.querySelector('[data-dots]');
      if (!dotsWrap) return;
      dotsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-dot]');
        if (!btn) return;
        e.stopPropagation(); // nicht "add to cart" triggern
        var idx = Number(btn.dataset.dot || 0);
        _this4._setImageIndex(idx, true);
      });
    }
  }, {
    key: "_setImageIndex",
    value: function _setImageIndex(idx) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var swipeArea = this.querySelector('[data-swipe]');
      var track = this.querySelector('[data-track]');
      if (!swipeArea || !track) return;
      var maxIndex = 1;
      var next = Math.max(0, Math.min(maxIndex, Number(idx || 0)));
      if (next === this._imageIndex) return;
      this._imageIndex = next;
      track.style.transition = animate ? 'transform 260ms cubic-bezier(.22,.61,.36,1)' : 'none';
      track.style.transform = "translate3d(".concat(-this._imageIndex * 50, "%,0,0)");
      this._updateDots();
    }
    /** END SWIPE FUNCTION **/
  }, {
    key: "_getDisplayTitle",
    value: function _getDisplayTitle(productTitle, variantTitle) {
      var p = (productTitle || '').trim();
      var v = (variantTitle || '').trim();

      // Shopify hat oft "Default Title" bei 1 Variante
      if (!v || v.toLowerCase() === 'default title') return p;
      return "".concat(p, " - ").concat(v);
    }
  }]);
  return EdBundleBuilderItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-builder-item')) {
  customElements.define('ed-bundle-builder-item', EdBundleBuilderItem);
}

/***/ }),

/***/ "./src/js/modules/bundle-builder/ed-bundle-builder-notification.js":
/*!*************************************************************************!*\
  !*** ./src/js/modules/bundle-builder/ed-bundle-builder-notification.js ***!
  \*************************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdBundleBuilderNotification = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleBuilderNotification, _HTMLElement);
  var _super = _createSuper(EdBundleBuilderNotification);
  function EdBundleBuilderNotification() {
    _classCallCheck(this, EdBundleBuilderNotification);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleBuilderNotification, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachTemplates();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.bundleBuilderMain = document.querySelector('ed-bundle-builder');
      this.bundleActionNotification = this.querySelector('[data-bundle-action-notification]');
      this.bundleReadyNotification = this.querySelector('[data-bundle-ready-notification]');

      // external: counter
      this.counterEl = document.querySelector('[data-ed-bb-counter]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.bundleBuilderMain.addEventListener('ed:bb:cart-updated', this.onCartUpdated.bind(this));
      this.bundleBuilderMain.addEventListener('ed:bb:add-to-cart', this.onItemAdded.bind(this));
    }
  }, {
    key: "_attachTemplates",
    value: function _attachTemplates() {
      var _this$counterEl;
      this.tplItemAdded = this.getAttribute('data-text-item-added') || '';
      this.txtReady = this.getAttribute('data-text-ready') || '';
      this.tplNotReady = this.getAttribute('data-text-not-ready') || '';
      this.tplCounter = ((_this$counterEl = this.counterEl) === null || _this$counterEl === void 0 ? void 0 : _this$counterEl.getAttribute('data-text')) || '';
    }
  }, {
    key: "onItemAdded",
    value: function onItemAdded(e) {
      var addedProduct = e.detail;
      var title = (addedProduct === null || addedProduct === void 0 ? void 0 : addedProduct.title) || '';
      var msg = this._format(this.tplItemAdded, {
        title: title
      });
      if (msg) this.bundleActionNotification.innerText = msg;
    }
  }, {
    key: "onCartUpdated",
    value: function onCartUpdated(e) {
      var _e$detail, _e$detail$cartSize, _e$detail2, _e$detail$currentBund, _e$detail3;
      var cart = ((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.cart) || [];
      var have = Number((_e$detail$cartSize = (_e$detail2 = e.detail) === null || _e$detail2 === void 0 ? void 0 : _e$detail2.cartSize) !== null && _e$detail$cartSize !== void 0 ? _e$detail$cartSize : cart.length);
      var required = Number((_e$detail$currentBund = (_e$detail3 = e.detail) === null || _e$detail3 === void 0 ? void 0 : _e$detail3.currentBundleSize) !== null && _e$detail$currentBund !== void 0 ? _e$detail$currentBund : 0);
      var missing = Math.max(0, required - have);
      var msg = '';
      if (required && have < required) {
        msg = this._format(this.tplNotReady, {
          have: have,
          required: required,
          missing: missing
        });
        this.classList.remove('is-ready');
      } else {
        msg = this.txtReady;
      }
      if (msg) this.bundleReadyNotification.innerText = msg;
      if (have > 0) this.classList.add('active');

      // update counter
      this._updateCounter(have, required);
    }
  }, {
    key: "_updateCounter",
    value: function _updateCounter(have, required) {
      if (!this.counterEl) return;
      if (!required) {
        this.counterEl.textContent = '';
        this.counterEl.setAttribute('aria-hidden', 'true');
        return;
      }
      if (required && have > required) {
        have = required;
      }
      var txt = this._format(this.tplCounter, {
        have: have,
        required: required
      });
      if (txt) this.counterEl.textContent = txt;
      this.counterEl.removeAttribute('aria-hidden');
    }
  }, {
    key: "_format",
    value: function _format(template) {
      var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!template) return '';
      return String(template).replace(/\{(\w+)\}/g, function (_, key) {
        return vars[key] != null ? String(vars[key]) : '';
      });
    }
  }]);
  return EdBundleBuilderNotification;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-builder-notification')) {
  customElements.define('ed-bundle-builder-notification', EdBundleBuilderNotification); // todo: translation
}

/***/ }),

/***/ "./src/js/modules/bundle-builder/ed-bundle-builder-preview-drawer.js":
/*!***************************************************************************!*\
  !*** ./src/js/modules/bundle-builder/ed-bundle-builder-preview-drawer.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! flickity */ "./node_modules/flickity/js/index.js");
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdBundleBuilderPreviewDrawer = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleBuilderPreviewDrawer, _HTMLElement);
  var _super = _createSuper(EdBundleBuilderPreviewDrawer);
  function EdBundleBuilderPreviewDrawer() {
    _classCallCheck(this, EdBundleBuilderPreviewDrawer);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleBuilderPreviewDrawer, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'open') return;
      if (newValue === null) this.onClose();else this.onOpen();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.baseUrl = 'https://' + this.getAttribute('base-url'); // wichtig: base-url ins Element geben!
      this._cache = new Map();
      this._attachSelectors();
      this._attachListeners();

      // get global reviews io widget
      this._cacheGlobalReviewsIo();
      setTimeout(function () {
        _this._applyI18n();
      });
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _abJsonEl$textContent, _this$reviewsIoWrap;
      this.bundleBuilderMain = document.querySelector('ed-bundle-builder') || document;
      this.overlay = this.querySelector('[data-preview-overlay]');
      this.content = this.querySelector('[data-preview-content]');
      this.btnClose = this.querySelectorAll('[data-preview-close]');

      // title El
      this.productTitleEl = this.querySelector('[data-product-title]');

      // slider
      this.sliderEl = this.querySelector('[data-preview-slider]');
      this.dotsEl = this.querySelector('[data-preview-dots]');

      // global images ab test gallery
      var abJsonEl = this.querySelector('[data-ab-gallery-json]');
      this.abGallery = [];
      if (abJsonEl !== null && abJsonEl !== void 0 && (_abJsonEl$textContent = abJsonEl.textContent) !== null && _abJsonEl$textContent !== void 0 && _abJsonEl$textContent.trim()) {
        try {
          this.abGallery = JSON.parse(abJsonEl.textContent.trim()) || [];
        } catch (e) {
          console.warn('Invalid AB gallery JSON', e);
        }
      }

      // add button
      this.btnAdd = this.querySelector('[data-add]');

      // reviews.io widget
      this.reviewsIoWrap = this.querySelector('[data-ed-bb-reviews-io]');
      this.reviewsIoInner = ((_this$reviewsIoWrap = this.reviewsIoWrap) === null || _this$reviewsIoWrap === void 0 ? void 0 : _this$reviewsIoWrap.querySelector('.inner')) || null;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this$btnAdd,
        _this2 = this,
        _this$overlay;
      this.bundleBuilderMain.addEventListener('ed:bb:open-preview', this.onOpenPreview.bind(this));
      (_this$btnAdd = this.btnAdd) === null || _this$btnAdd === void 0 ? void 0 : _this$btnAdd.addEventListener('click', this.onAddFromPreview.bind(this));
      this.btnClose.forEach(function (btn) {
        btn.addEventListener('click', _this2.closeDrawer.bind(_this2));
      });
      (_this$overlay = this.overlay) === null || _this$overlay === void 0 ? void 0 : _this$overlay.addEventListener('click', this.closeDrawer.bind(this));
    }
  }, {
    key: "_applyI18n",
    value: function _applyI18n() {
      var main = this.bundleBuilderMain;
      if (!main) return;
      this.drawerHeader = this.querySelector('[data-preview-drawer-title]');
      if (this.drawerHeader) {
        this.drawerHeader.innerText = main.tplHeadingPreviewHeader;
      }
      this.labelPreviewBtnAdd = this.querySelector('[data-add]');
      if (this.labelPreviewBtnAdd) {
        this.labelPreviewBtnAdd.innerText = main.tplLabelPreviewBtnAdd;
      }
      this.labelPreviewBtnBack = this.querySelector('[data-preview-btn-back]');
      if (this.labelPreviewBtnBack) {
        this.labelPreviewBtnBack.innerText = main.tplLabelPreviewBtnBack;
      }
    }
  }, {
    key: "onOpenPreview",
    value: function () {
      var _onOpenPreview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var _ref, handle, itemData, preview;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref = e.detail || {}, handle = _ref.handle, itemData = _ref.itemData;
              if (handle) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              this._currentItemData = itemData || null;
              this._applySoldOutState(this._currentItemData);
              this.openDrawer();
              this.classList.add('is-loading');
              _context.prev = 7;
              _context.next = 10;
              return this.fetchProductPreviewByHandle(handle);
            case 10:
              preview = _context.sent;
              this.render(preview);
            case 12:
              _context.prev = 12;
              this.classList.remove('is-loading');
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7,, 12, 15]]);
      }));
      function onOpenPreview(_x) {
        return _onOpenPreview.apply(this, arguments);
      }
      return onOpenPreview;
    }()
  }, {
    key: "render",
    value: function render(preview) {
      if (!this.sliderEl) return;
      this.renderSlider(preview);
      this.renderProductTitle(preview);
      this.initSlider();
    }
  }, {
    key: "renderSlider",
    value: function renderSlider(preview) {
      this.destroySlider();
      var productImages = Array.isArray(preview.images) ? preview.images : [];
      var abImages = Array.isArray(this.abGallery) ? this.abGallery : [];
      var images = this._mergeImages(productImages, abImages);

      // Slides bauen – so ähnlich wie Theme: Carousel__Cell
      this.sliderEl.innerHTML = images.map(function (img, i) {
        var alt = (img.altText || preview.title || '').replace(/"/g, '&quot;');
        var url = img.url || '';
        return "\n        <div class=\"Carousel__Cell ed-preview-slide\" data-index=\"".concat(i, "\">\n          <div class=\"AspectRatio AspectRatio--withFallback\" style=\"padding-bottom: 100%; --aspect-ratio: 1;\">\n            <img src=\"").concat(url, "\" alt=\"").concat(alt, "\" loading=\"lazy\" />\n          </div>\n        </div>\n      ");
      }).join('');

      // build thumbnails
      if (this.dotsEl) {
        this.dotsEl.innerHTML = images.map(function (img, i) {
          var alt = (img.altText || preview.title || '').replace(/"/g, '&quot;');
          var url = img.url || '';
          return "\n              <li class=\"ed-preview-thumbItem\">\n                <button class=\"ed-preview-thumb\" type=\"button\" data-dot-index=\"".concat(i, "\" aria-label=\"Bild ").concat(i + 1, "\">\n                  <img src=\"").concat(url, "\" alt=\"").concat(alt, "\" loading=\"lazy\" />\n                </button>\n              </li>\n            ");
        }).join('');
      }
    }
  }, {
    key: "renderProductTitle",
    value: function renderProductTitle(preview) {
      if (!this.productTitleEl) return;
      this.productTitleEl.textContent = preview.title || '';
    }

    /*****
     *
     *  POPUP METHODS
     *
     **/
  }, {
    key: "onOpen",
    value: function onOpen() {
      var _this3 = this;
      this._ensureReviewsIoInjected();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          try {
            var _this3$_flickity;
            (_this3$_flickity = _this3._flickity) === null || _this3$_flickity === void 0 ? void 0 : _this3$_flickity.resize();
          } catch (e) {}
        });
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.destroySlider();
    }
  }, {
    key: "openDrawer",
    value: function openDrawer() {
      this.setAttribute('open', 'true');
    }
  }, {
    key: "closeDrawer",
    value: function closeDrawer() {
      this.removeAttribute('open');
    }
  }, {
    key: "onAddFromPreview",
    value: function onAddFromPreview() {
      var _itemData$quantity;
      var itemData = this._currentItemData;
      if (!(itemData !== null && itemData !== void 0 && itemData.variantId)) return;
      if (itemData.available === false) return; // ausverkauft -> nicht hinzufügen

      this.bundleBuilderMain.dispatchEvent(new CustomEvent('ed:bb:add-to-cart', {
        detail: _objectSpread(_objectSpread({}, itemData), {}, {
          quantity: (_itemData$quantity = itemData.quantity) !== null && _itemData$quantity !== void 0 ? _itemData$quantity : 1
        }),
        bubbles: true,
        composed: true
      }));
      this.closeDrawer();
    }
  }, {
    key: "_applySoldOutState",
    value: function _applySoldOutState(itemData) {
      var _this$bundleBuilderMa, _this$bundleBuilderMa2;
      var soldOut = (itemData === null || itemData === void 0 ? void 0 : itemData.available) === false;
      this.classList.toggle('is-sold-out', soldOut);
      if (!this.btnAdd) return;
      this.btnAdd.classList.toggle('is-disabled', soldOut);
      this.btnAdd.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      var soldOutLabel = (_this$bundleBuilderMa = this.bundleBuilderMain) === null || _this$bundleBuilderMa === void 0 ? void 0 : _this$bundleBuilderMa.labelSoldOut;
      var normalLabel = (_this$bundleBuilderMa2 = this.bundleBuilderMain) === null || _this$bundleBuilderMa2 === void 0 ? void 0 : _this$bundleBuilderMa2.tplLabelPreviewBtnAdd;
      if (soldOut && soldOutLabel) {
        this.btnAdd.textContent = soldOutLabel;
      } else if (normalLabel) {
        this.btnAdd.textContent = normalLabel;
      }
    }

    /*****
     *
     *  SLIDER
     *
     **/
  }, {
    key: "initSlider",
    value: function initSlider() {
      var _this4 = this,
        _this$dotsEl;
      if (!this.sliderEl) return;

      // Falls nur 0/1 Bild: keine Flickity Instanz nötig
      var cellCount = this.sliderEl.querySelectorAll('.Carousel__Cell').length;
      if (cellCount <= 1) {
        this._setActiveDot(0);
        return;
      }

      // Flickity init – nah am Theme, aber ohne Zoom/PrevNext
      this._flickity = new (flickity__WEBPACK_IMPORTED_MODULE_0___default())(this.sliderEl, {
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        draggable: true,
        dragThreshold: 8,
        contain: true,
        cellAlign: 'left',
        imagesLoaded: true
      });

      // Dots click => select
      this._onDotClick = function (ev) {
        var _this4$_flickity;
        var btn = ev.target.closest('[data-dot-index]');
        if (!btn) return;
        var idx = Number(btn.dataset.dotIndex || 0);
        (_this4$_flickity = _this4._flickity) === null || _this4$_flickity === void 0 ? void 0 : _this4$_flickity.select(idx);
      };
      (_this$dotsEl = this.dotsEl) === null || _this$dotsEl === void 0 ? void 0 : _this$dotsEl.addEventListener('click', this._onDotClick);

      // Sync active dot
      this._flickity.on('select', function () {
        _this4._setActiveDot(_this4._flickity.selectedIndex || 0);
      });
      this._setActiveDot(this._flickity.selectedIndex || 0);

      // Wenn Drawer animiert reinfährt: nach kurzer Zeit resize, damit Höhe passt
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          try {
            var _this4$_flickity2;
            (_this4$_flickity2 = _this4._flickity) === null || _this4$_flickity2 === void 0 ? void 0 : _this4$_flickity2.resize();
          } catch (e) {}
        });
      });
    }
  }, {
    key: "destroySlider",
    value: function destroySlider() {
      // dots handler cleanup
      if (this.dotsEl && this._onDotClick) {
        this.dotsEl.removeEventListener('click', this._onDotClick);
      }
      this._onDotClick = null;

      // flickity cleanup
      if (this._flickity) {
        try {
          this._flickity.destroy();
        } catch (e) {}
        this._flickity = null;
      }

      // active dot reset optional
      this._setActiveDot(0);
    }
  }, {
    key: "_setActiveDot",
    value: function _setActiveDot(activeIdx) {
      if (!this.dotsEl) return;
      var thumbs = this.dotsEl.querySelectorAll('.ed-preview-thumb');
      thumbs.forEach(function (btn, i) {
        var isActive = i === activeIdx;
        btn.classList.toggle('is-active', isActive);

        // optional: beim Aktivieren sichtbar scrollen (bei vielen Bildern)
        if (isActive) {
          btn.scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: 'smooth'
          });
        }
      });
    }
  }, {
    key: "_mergeImages",
    value: function _mergeImages() {
      var productImages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var abImages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var seen = new Set();
      var out = [];
      var push = function push(img) {
        var url = ((img === null || img === void 0 ? void 0 : img.url) || '').trim();
        if (!url || seen.has(url)) return;
        seen.add(url);
        out.push(img);
      };
      productImages.forEach(push);
      abImages.forEach(push);
      return out;
    }

    /*****
     *
     * STOREFRONT API
     *
     **/
  }, {
    key: "fetchProductPreviewByHandle",
    value: function () {
      var _fetchProductPreviewByHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handle) {
        var _json$data, _product$images;
        var _this$_getStorefrontC, language, country, cacheKey, query, res, json, _json$errors, _json$errors$, product, images, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (handle) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", null);
            case 2:
              _this$_getStorefrontC = this._getStorefrontContext(), language = _this$_getStorefrontC.language, country = _this$_getStorefrontC.country;
              cacheKey = "".concat(handle, "::").concat(language, "::").concat(country); // Cache
              if (!this._cache.has(cacheKey)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", this._cache.get(cacheKey));
            case 6:
              query = "\n      query ProductPreview(\n        $handle: String!,\n        $language: LanguageCode,\n        $country: CountryCode\n      ) @inContext(country: $country, language: $language) {\n        productByHandle(handle: $handle) {\n          title\n          images(first: 20) {\n            edges {\n              node {\n                url(transform: { maxWidth: 1200 })\n                altText\n                width\n                height\n              }\n            }\n          }\n        }\n      }\n    ";
              _context2.next = 9;
              return fetch(this.baseUrl + '/api/2025-10/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  query: query,
                  variables: {
                    handle: handle,
                    language: language,
                    country: country
                  }
                })
              });
            case 9:
              res = _context2.sent;
              _context2.next = 12;
              return res.json();
            case 12:
              json = _context2.sent;
              if (!json.errors) {
                _context2.next = 15;
                break;
              }
              throw new Error(((_json$errors = json.errors) === null || _json$errors === void 0 ? void 0 : (_json$errors$ = _json$errors[0]) === null || _json$errors$ === void 0 ? void 0 : _json$errors$.message) || 'Storefront GraphQL error');
            case 15:
              product = json === null || json === void 0 ? void 0 : (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.productByHandle;
              if (product) {
                _context2.next = 18;
                break;
              }
              return _context2.abrupt("return", null);
            case 18:
              images = (((_product$images = product.images) === null || _product$images === void 0 ? void 0 : _product$images.edges) || []).map(function (e) {
                return e === null || e === void 0 ? void 0 : e.node;
              }).filter(Boolean);
              result = {
                title: product.title || '',
                images: images
              };
              this._cache.set(cacheKey, result);
              return _context2.abrupt("return", result);
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchProductPreviewByHandle(_x2) {
        return _fetchProductPreviewByHandle.apply(this, arguments);
      }
      return fetchProductPreviewByHandle;
    }() /*** REVIEWS IO WIDGET ***/
  }, {
    key: "_cacheGlobalReviewsIo",
    value: function _cacheGlobalReviewsIo() {
      this._globalReviewsIoEl = document.querySelector('.ed-announcement-item-reviews-io') || null;
    }

    // nur wenn noch nicht drin, rein-rendern
  }, {
    key: "_ensureReviewsIoInjected",
    value: function _ensureReviewsIoInjected() {
      if (!this.reviewsIoWrap || !this.reviewsIoInner) return;

      // falls schon drin: nichts tun
      if (this.reviewsIoWrap.classList.contains('is-active')) return;

      // evtl. später gerendert -> erneut cachen
      if (!this._globalReviewsIoEl) this._cacheGlobalReviewsIo();

      // fallback: ausblenden
      if (!this._globalReviewsIoEl) {
        this.reviewsIoWrap.classList.remove('is-active');
        this.reviewsIoInner.innerHTML = '';
        return;
      }

      // inject
      var clone = this._globalReviewsIoEl.cloneNode(true);
      clone.classList.add('is-in-preview-drawer');
      this.reviewsIoInner.innerHTML = '';
      this.reviewsIoInner.appendChild(clone);
      this.reviewsIoWrap.classList.add('is-active');
    }
  }, {
    key: "_getStorefrontContext",
    value: function _getStorefrontContext() {
      var htmlLang = document.documentElement.getAttribute('lang') || 'de-DE';
      var normalized = htmlLang.replace('_', '-');
      var _normalized$split = normalized.split('-'),
        _normalized$split2 = _slicedToArray(_normalized$split, 2),
        _normalized$split2$ = _normalized$split2[0],
        langPart = _normalized$split2$ === void 0 ? 'en' : _normalized$split2$,
        _normalized$split2$2 = _normalized$split2[1],
        countryPart = _normalized$split2$2 === void 0 ? 'US' : _normalized$split2$2;
      return {
        raw: htmlLang,
        language: langPart.toUpperCase(),
        country: countryPart.toUpperCase()
      };
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['open'];
    }
  }]);
  return EdBundleBuilderPreviewDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-builder-preview-drawer')) {
  customElements.define('ed-bundle-builder-preview-drawer', EdBundleBuilderPreviewDrawer);
}

/***/ }),

/***/ "./src/js/modules/bundle-builder/ed-bundle-slot.js":
/*!*********************************************************!*\
  !*** ./src/js/modules/bundle-builder/ed-bundle-slot.js ***!
  \*********************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdBundleSlot = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleSlot, _HTMLElement);
  var _super = _createSuper(EdBundleSlot);
  function EdBundleSlot() {
    _classCallCheck(this, EdBundleSlot);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleSlot, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._buildMarkup();
      //this._render();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.bundleBuilderMain = this.closest('ed-bundle-builder');
      this.itemDrawer = document.querySelector('[data-bundle-builder-item-drawer]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('click', this._onClick.bind(this));
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      if (e.target.closest('[data-slot-remove]')) {
        e.stopPropagation();
        this._onRemoveClick();
        return;
      }
      if (this.classList.contains('is-empty')) {
        this._openDrawer();
        return;
      }
      this._openDrawer();
    }
  }, {
    key: "_openDrawer",
    value: function _openDrawer() {
      var _this$itemDrawer;
      (_this$itemDrawer = this.itemDrawer) === null || _this$itemDrawer === void 0 ? void 0 : _this$itemDrawer.setAttribute('open', 'true');
    }
  }, {
    key: "_buildMarkup",
    value: function _buildMarkup() {
      if (this._initialized) return;
      var index = this.dataset.index || '';
      var title = this.dataset.labelTemplate || '';
      this.innerHTML = "\n            <div class=\"image-container\">\n                <img src=\"\" data-item-image />\n                <div class=\"badge\" data-badge></div>\n                 <button class=\"slot-remove\" type=\"button\" data-slot-remove aria-label=\"Design entfernen\">\xD7</button>\n            </div>\n            <div class=\"content-container\">\n                <div class=\"item-title\" data-item-title>\n                    ".concat(this._escapeHtml(title), "\n                </div>\n            </div>\n        ");
      this._initialized = true;
    }
  }, {
    key: "_render",
    value: function _render(cartItem) {
      this._buildMarkup();
      var titleEl = this.querySelector('[data-item-title]');
      var imgEl = this.querySelector('[data-item-image]');
      var index = this.dataset.index || '';

      // badges
      var badgeEl = this.querySelector('[data-badge]');
      if (badgeEl) {
        var isFree = this.dataset.isFree === 'true';
        var freeLabel = this.dataset.badgeLabel || '';
        var isDiscounted = this.dataset.isDiscounted === 'true';
        var discountLabel = this.dataset.discountBadgeLabel || '';

        // Priorität: Gratis > Discount
        if (isFree && freeLabel) {
          badgeEl.textContent = freeLabel;
          badgeEl.classList.add('active', 'is-free');
          badgeEl.classList.remove('is-discount');
        } else if (isDiscounted && discountLabel) {
          badgeEl.textContent = discountLabel;
          badgeEl.classList.add('active', 'is-discount');
          badgeEl.classList.remove('is-free');
        } else {
          badgeEl.textContent = '';
          badgeEl.classList.remove('active', 'is-free', 'is-discount');
        }
      }

      // empty slot
      if (!cartItem) {
        var title = this._format(this.dataset.labelTemplate, {
          index: index
        });
        titleEl.textContent = title;
        var placeholderSrc = this.dataset.placeholderImage || '';
        if (imgEl) {
          imgEl.src = placeholderSrc; // <-- statt leer
          imgEl.alt = placeholderSrc ? "Platzhalter ".concat(index) : '';
        }
        this.classList.remove('is-filled');
        this.classList.add('is-empty');
        var _removeBtn = this.querySelector('[data-slot-remove]');
        if (_removeBtn) _removeBtn.classList.remove('active');
        return;
      }

      // filled slot
      if (titleEl) {
        titleEl.textContent = cartItem.title || "Design ".concat(index);
      }
      if (imgEl && cartItem.imageUrl) {
        imgEl.src = cartItem.imageUrl;
        imgEl.alt = cartItem.imageAlt || '';
      }

      // remove button
      var removeBtn = this.querySelector('[data-slot-remove]');
      if (removeBtn) {
        removeBtn.classList.add('active');
      }
      this.classList.add('is-filled');
      this.classList.remove('is-empty');
    }
  }, {
    key: "_onRemoveClick",
    value: function _onRemoveClick() {
      var cartIndex = Number(this.dataset.cartIndex);
      if (!Number.isInteger(cartIndex)) return;
      this.bundleBuilderMain.dispatchEvent(new CustomEvent('ed:bb:remove-from-cart-by-index', {
        detail: {
          index: cartIndex
        },
        bubbles: true,
        composed: true
      }));
    }

    // Helpers
  }, {
    key: "_format",
    value: function _format(tpl) {
      var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) {
        var _vars$k;
        return (_vars$k = vars[k]) !== null && _vars$k !== void 0 ? _vars$k : '';
      });
    }
  }, {
    key: "_escapeHtml",
    value: function _escapeHtml(str) {
      return String(str !== null && str !== void 0 ? str : '').replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
    }
  }, {
    key: "_escapeAttr",
    value: function _escapeAttr(str) {
      return this._escapeHtml(str);
    }
  }]);
  return EdBundleSlot;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-slot')) {
  customElements.define('ed-bundle-slot', EdBundleSlot);
}

/***/ }),

/***/ "./src/js/modules/ed-ab-sync.js":
/*!**************************************!*\
  !*** ./src/js/modules/ed-ab-sync.js ***!
  \**************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var EdAbSync = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdAbSync, _HTMLElement);
  var _super = _createSuper(EdAbSync);
  function EdAbSync() {
    var _this;
    _classCallCheck(this, EdAbSync);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_cartAttributes", {});
    _defineProperty(_assertThisInitialized(_this), "_pendingUpdate", false);
    _defineProperty(_assertThisInitialized(_this), "_queuedAttributes", {});
    _defineProperty(_assertThisInitialized(_this), "_onAssign", null);
    return _this;
  }
  _createClass(EdAbSync, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._cartAttributes = JSON.parse(this.getAttribute('current-cart-attributes') || '{}');
      this._attachListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('ed:ab:assign', this._onAssign);
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this._onAssign = this._handleAssign.bind(this);
      document.addEventListener('ed:ab:assign', this._onAssign);
    }
  }, {
    key: "_handleAssign",
    value: function _handleAssign(e) {
      var _e$detail = e.detail,
        test = _e$detail.test,
        variant = _e$detail.variant;
      if (!test || !variant) return;
      var key = "_ed-ab-".concat(test);
      var isControl = variant === 'A';
      var currentValue = this._cartAttributes[key];

      // Variante A: Attribut löschen falls vorhanden
      // Variante B/C/...: Attribut setzen falls nicht bereits korrekt gesetzt
      if (isControl && !(key in this._cartAttributes)) return;
      if (!isControl && currentValue === variant) return;
      this._queuedAttributes[key] = isControl ? '' : variant;
      this._scheduleUpdate();
    }

    // Batching: mehrere Events im selben Tick → ein einziger /cart/update.js Request
  }, {
    key: "_scheduleUpdate",
    value: function _scheduleUpdate() {
      var _this2 = this;
      if (this._pendingUpdate) return;
      this._pendingUpdate = true;
      queueMicrotask(function () {
        _this2._flushUpdate();
      });
    }
  }, {
    key: "_flushUpdate",
    value: function _flushUpdate() {
      var _this3 = this;
      var attributes = _objectSpread({}, this._queuedAttributes);
      this._queuedAttributes = {};
      this._pendingUpdate = false;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: attributes
        })
      }).then(function (res) {
        return res.json();
      }).then(function (cart) {
        var _cart$attributes;
        // Lokalen State nach Update synchronisieren
        _this3._cartAttributes = (_cart$attributes = cart.attributes) !== null && _cart$attributes !== void 0 ? _cart$attributes : {};
        console.debug('[ed-ab-sync] cart attributes synced:', _this3._cartAttributes);
      })["catch"](function (err) {
        console.error('[ed-ab-sync] failed to update cart attributes:', err);
      });
    }
  }]);
  return EdAbSync;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-ab-sync', EdAbSync);

/***/ }),

/***/ "./src/js/modules/ed-application-steps.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-application-steps.js ***!
  \************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var edApplicationSteps = /*#__PURE__*/function (_HTMLElement) {
  _inherits(edApplicationSteps, _HTMLElement);
  var _super = _createSuper(edApplicationSteps);
  function edApplicationSteps() {
    _classCallCheck(this, edApplicationSteps);
    return _super.apply(this, arguments);
  }
  _createClass(edApplicationSteps, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.applicationSteps = this.querySelectorAll(".application-step");
      this.applicationTexts = this.querySelectorAll(".application-step-text");
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.applicationSteps.forEach(function (applicationStep) {
        applicationStep.addEventListener('click', _this._changeCurrentPath.bind(_this));
      });
    }
  }, {
    key: "_changeCurrentPath",
    value: function _changeCurrentPath(event) {
      var nextStep = event.currentTarget;
      var currentStep = document.querySelector(".application-step.current-path");
      var nextApplicationText = nextStep.dataset.index;
      currentStep.classList.remove("current-path");
      nextStep.classList.add("current-path");
      var currentText = document.querySelector(".application-step-text.current-text");
      currentText.classList.remove("current-text");
      this.applicationTexts.forEach(function (applicationText) {
        if (applicationText.dataset.index === nextApplicationText) {
          applicationText.classList.add("current-text");
        }
      });
    }
  }]);
  return edApplicationSteps;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-application-steps', edApplicationSteps);

/***/ }),

/***/ "./src/js/modules/ed-bundle-builder.js":
/*!*********************************************!*\
  !*** ./src/js/modules/ed-bundle-builder.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
/* harmony import */ var _helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/scroll-to-element */ "./src/js/helpers/scroll-to-element.js");
/* harmony import */ var _bundle_builder_ed_bundle_builder_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./bundle-builder/ed-bundle-builder-cart */ "./src/js/modules/bundle-builder/ed-bundle-builder-cart.js");
/* harmony import */ var _bundle_builder_ed_bundle_builder_cart__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_bundle_builder_ed_bundle_builder_cart__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _bundle_builder_ed_bundle_slot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./bundle-builder/ed-bundle-slot */ "./src/js/modules/bundle-builder/ed-bundle-slot.js");
/* harmony import */ var _bundle_builder_ed_bundle_slot__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bundle_builder_ed_bundle_slot__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _bundle_builder_ed_bundle_builder_item__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./bundle-builder/ed-bundle-builder-item */ "./src/js/modules/bundle-builder/ed-bundle-builder-item.js");
/* harmony import */ var _bundle_builder_ed_bundle_builder_item__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_bundle_builder_ed_bundle_builder_item__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _bundle_builder_ed_bundle_builder_item_drawer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./bundle-builder/ed-bundle-builder-item-drawer */ "./src/js/modules/bundle-builder/ed-bundle-builder-item-drawer.js");
/* harmony import */ var _bundle_builder_ed_bundle_builder_item_drawer__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_bundle_builder_ed_bundle_builder_item_drawer__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _bundle_builder_ed_bundle_builder_preview_drawer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./bundle-builder/ed-bundle-builder-preview-drawer */ "./src/js/modules/bundle-builder/ed-bundle-builder-preview-drawer.js");
/* harmony import */ var _bundle_builder_ed_bundle_builder_notification__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./bundle-builder/ed-bundle-builder-notification */ "./src/js/modules/bundle-builder/ed-bundle-builder-notification.js");
/* harmony import */ var _bundle_builder_ed_bundle_builder_notification__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_bundle_builder_ed_bundle_builder_notification__WEBPACK_IMPORTED_MODULE_7__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }








var EdBundleBuilder = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBundleBuilder, _HTMLElement);
  var _super = _createSuper(EdBundleBuilder);
  function EdBundleBuilder() {
    _classCallCheck(this, EdBundleBuilder);
    return _super.apply(this, arguments);
  }
  _createClass(EdBundleBuilder, [{
    key: "bundleMasterVariantId",
    get: function get() {
      return this.getAttribute('bundle-master-variant-id');
    },
    set: function set(value) {
      this.setAttribute('bundle-master-variant-id', String(parseInt(value, 10)));
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$bundleVariants, _this$bundleVariants$, _this$bundleBuilderCa;
      this._attachSelectors();
      this._attachTemplates();
      this._attachListeners();
      this.bundleVariants = Object.entries(this.bundleVariantsJson).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          variantId = _ref2[0],
          v = _ref2[1];
        return {
          variantId: Number(variantId),
          bundleSize: Number(v.bundle_size || 0)
        };
      }).sort(function (a, b) {
        return a.bundleSize - b.bundleSize;
      });
      this.minBundleSize = ((_this$bundleVariants = this.bundleVariants) === null || _this$bundleVariants === void 0 ? void 0 : (_this$bundleVariants$ = _this$bundleVariants[0]) === null || _this$bundleVariants$ === void 0 ? void 0 : _this$bundleVariants$.bundleSize) || 0;

      // variant setup
      var foundVariant = this.bundleVariantsJson[parseInt(this.bundleMasterVariantId)];
      if (foundVariant) {
        this.currentVariant = foundVariant;
        this.currentSlotSize = Number(foundVariant.bundle_size);
      }
      this.slotSizes = Object.values(this.bundleVariantsJson).map(function (v) {
        return v.bundle_size;
      });
      this.maxSlotSize = Math.max.apply(Math, _toConsumableArray(this.slotSizes));

      // discount levels
      this.discountLevels = this._parseDiscountLevelsAttribute(this.getAttribute('discount-levels'));

      // initial state
      this.currentCart = this.currentCart || [];
      this.updateComplementarySlotsVisibility(this.bundleMasterVariantId);
      this.renderEmptySlots(true);
      this.renderDrawerCartItems(this.currentCart);
      this._updateAddToCartState();

      // intial prices + savings
      this.currentCart = ((_this$bundleBuilderCa = this.bundleBuilderCart) === null || _this$bundleBuilderCa === void 0 ? void 0 : _this$bundleBuilderCa.cart) || [];
      this.currentCartTotal = this._calculatePrices(this.currentCart);
      this.renderPricing(this.currentCartTotal);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _scriptEl$textContent, _this$itemDrawer;
      var scriptEl = this.querySelector('#bundle-variants-json');
      var jsonText = (scriptEl === null || scriptEl === void 0 ? void 0 : (_scriptEl$textContent = scriptEl.textContent) === null || _scriptEl$textContent === void 0 ? void 0 : _scriptEl$textContent.trim()) || '';
      this.bundleBuilderCart = this.querySelector('ed-bundle-builder-cart');
      this.itemDrawer = document.querySelector('[data-bundle-builder-item-drawer]');
      this.drawerCartList = (_this$itemDrawer = this.itemDrawer) === null || _this$itemDrawer === void 0 ? void 0 : _this$itemDrawer.querySelector('[data-cart-list]');
      this.bundleVariantsJson = JSON.parse(jsonText);
      this.bundleItemsContainer = this.querySelector('[data-bundle-items]');
      this.complementarySlots = Array.from(this.querySelectorAll('ed-complementary-slot'));
      this.defaultAddToCartButton = document.querySelector('#AddToCart');
      if (this.defaultAddToCartButton) {
        this.defaultAddToCartButton.removeAttribute('data-cart-add'); // Remove CartJS Attribute
      }

      // external
      this.notificationWidget = document.querySelector('#notify-pdp');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('ed:bb:cart-updated', this.onCartUpdated.bind(this));
      this.addEventListener('ed:bb:need-upgrade', this.onNeedUpgrade.bind(this));
      this.defaultAddToCartButton.addEventListener('click', this.onBtnAddToCart.bind(this));
      document.addEventListener('variant:changed', this.onVariantChange.bind(this));
    }
  }, {
    key: "_attachTemplates",
    value: function _attachTemplates() {
      this.tplAtc = this.getAttribute('data-text-atc') || '';
      this.tplAtcCompare = this.getAttribute('data-text-atc-compare') || '';
      this.tplAtcNotReady = this.getAttribute('data-text-atc-not-ready') || '';
      this.tplSavings = this.getAttribute('data-text-savings') || '-{percent}%';
      this.labelBadgeFree = this.getAttribute('data-label-badge-free') || 'Gratis';
      this.labelSoldOut = this.getAttribute('data-label-sold-out') || 'Ausverkauft';

      // Gratis-Badge per Produkt-Metafield (ed_ink.bundle_configuration.disable_free_badge) deaktivierbar
      this.disableFreeBadge = this.getAttribute('data-disable-free-badge') === 'true';

      // Design-Auswahl (Slots + Drawer) per Produkt-Metafield (ed_ink.bundle_configuration.disable_design_selection) deaktivierbar
      // -> Bundle besteht nur aus den Komplementärprodukten der Variante
      this.disableDesignSelection = this.getAttribute('data-disable-design-selection') === 'true';

      // Drawer
      this.labelBtnPreview = this.getAttribute('data-label-btn-preview') || 'Vorschau';
      this.drawerHeading = this.getAttribute('data-drawer-heading') || '';
      this.labelDrawerCta = this.getAttribute('data-label-drawer-cta') || '';
      this.labelSearchPlaceholder = this.getAttribute('data-label-search-placeholder') || '';
      this.filterLabel = this.getAttribute('data-label-filter') || '';
      this.filterLabelSize = this.getAttribute('data-label-filter-size') || '';
      this.filterLabelCategory = this.getAttribute('data-label-filter -category') || '';

      // Preview Drawer
      this.tplHeadingPreviewHeader = this.getAttribute('data-heading-preview-header') || '';
      this.tplLabelPreviewBtnAdd = this.getAttribute('data-label-preview-btn-add') || '';
      this.tplLabelPreviewBtnBack = this.getAttribute('data-label-preview-btn-back') || '';
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var _this$bundleBuilderCa2, _this$bundleBuilderCa3, _this$bundleBuilderCa6;
      var variantId = e.detail.variant.id;
      var foundVariant = this.bundleVariantsJson[variantId];
      this.currentCart = ((_this$bundleBuilderCa2 = this.bundleBuilderCart) === null || _this$bundleBuilderCa2 === void 0 ? void 0 : _this$bundleBuilderCa2.cart) || [];
      this.currentVariant = foundVariant;
      this.currentSlotSize = foundVariant.bundle_size;
      this.bundleMasterVariantId = variantId;

      // render new complementary products
      this.updateComplementarySlotsVisibility(variantId);

      /* trim current cart if new variant size is smaller */
      var limit = Number(this.currentSlotSize);
      var cartItems = ((_this$bundleBuilderCa3 = this.bundleBuilderCart) === null || _this$bundleBuilderCa3 === void 0 ? void 0 : _this$bundleBuilderCa3.cart) || [];
      if (cartItems.length > limit) {
        var _this$bundleBuilderCa4, _this$bundleBuilderCa5;
        var trimmed = cartItems.slice(0, limit);
        (_this$bundleBuilderCa4 = this.bundleBuilderCart) === null || _this$bundleBuilderCa4 === void 0 ? void 0 : (_this$bundleBuilderCa5 = _this$bundleBuilderCa4.setCart) === null || _this$bundleBuilderCa5 === void 0 ? void 0 : _this$bundleBuilderCa5.call(_this$bundleBuilderCa4, trimmed);
        return;
      }
      /* end */

      // for +1 logic in variant change
      var cartSizeAfter = (((_this$bundleBuilderCa6 = this.bundleBuilderCart) === null || _this$bundleBuilderCa6 === void 0 ? void 0 : _this$bundleBuilderCa6.cart) || []).length;
      var baseSize = Number(this.currentSlotSize || 0);
      var shouldAllowPlusOne = baseSize > 0 && cartSizeAfter >= baseSize;
      this.renderEmptySlots(!shouldAllowPlusOne);

      // if upgrade of slotSize was needed, add the pendingAdd
      if (this._pendingAdd && this._pendingUpgradeVariantId === variantId) {
        var _this$bundleBuilderCa7;
        var itemData = this._pendingAdd.itemData;
        this._pendingAdd = null;
        this._pendingUpgradeVariantId = null;
        (_this$bundleBuilderCa7 = this.bundleBuilderCart) === null || _this$bundleBuilderCa7 === void 0 ? void 0 : _this$bundleBuilderCa7.addToCart(itemData);
      }
      this._updateAddToCartState();
      this._emitUiRefresh();
    }
  }, {
    key: "renderEmptySlots",
    value: function renderEmptySlots() {
      var _this$currentVariant, _this$_getNextLimit;
      var variantChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.disableDesignSelection || !this.bundleItemsContainer) {
        this._updateAddToCartState();
        return;
      }
      var currentBaseSize = Number(((_this$currentVariant = this.currentVariant) === null || _this$currentVariant === void 0 ? void 0 : _this$currentVariant.bundle_size) || 0);
      var cartSize = Array.isArray(this.currentCart) ? this.currentCart.length : 0;

      // +1 slot logic
      var desiredSlots = currentBaseSize;
      var isPlusOne = !variantChange && cartSize >= currentBaseSize;
      if (isPlusOne) {
        desiredSlots = cartSize + 1;
      }

      // reset slots
      this.bundleItemsContainer.innerHTML = '';

      // current badge infos
      var badgeLabel = this._getBadgeLabel(this.currentSlotSize);
      var freeCount = this._getFreeCount(this.currentSlotSize);
      var placeholderImage = this.getAttribute('default-placeholder-image') || '';

      // PREVIEW LOGIC: 1 vor nächster bundle size?
      var nextLimit = Number(((_this$_getNextLimit = this._getNextLimit) === null || _this$_getNextLimit === void 0 ? void 0 : _this$_getNextLimit.call(this)) || 0);
      var isOneBeforeNextLimit = isPlusOne && nextLimit > 0 && cartSize === nextLimit - 1;
      for (var i = 0; i < desiredSlots; i++) {
        var itemEl = document.createElement('ed-bundle-slot');
        itemEl.classList.add('ed-bundle-slot');
        itemEl.dataset.placeholderImage = placeholderImage;

        // default badge infos (wie bisher)
        itemEl.dataset.badgeLabel = badgeLabel;
        itemEl.dataset.freeCount = String(freeCount);

        // normal free logic (wie bisher)
        var isFree = !this.disableFreeBadge && freeCount > 0 && i < currentBaseSize && i >= currentBaseSize - freeCount;

        // ✅ SIMPLE PREVIEW:
        // Wenn wir den +1 Slot haben und 1 vor nextLimit sind,
        // dann markiere NUR den +1 Slot als gratis
        if (!isFree && !this.disableFreeBadge && isOneBeforeNextLimit && i === desiredSlots - 1) {
          isFree = true;
          itemEl.dataset.isFreePreview = 'true'; // optional fürs Styling
        }

        if (isFree) {
          itemEl.dataset.isFree = 'true';
        }

        // discount badge - only for EXTRA slots
        if (!isFree && i >= currentBaseSize) {
          var discountPct = this._getDiscountPercentForSlotIndex(i);
          if (discountPct > 0) {
            itemEl.dataset.isDiscounted = 'true';
            itemEl.dataset.discountBadgeLabel = "-".concat(discountPct, "%");
          }
        }
        itemEl.dataset.index = String(i + 1);
        itemEl.dataset.labelTemplate = this.getAttribute('data-label-slot') || 'Design {index}';
        this.bundleItemsContainer.appendChild(itemEl);
      }
      if (this.currentCart) {
        this.renderSlotItems(this.currentCart);
      }
      this._updateAddToCartState();
    }
  }, {
    key: "onCartUpdated",
    value: function onCartUpdated(e) {
      this.currentCart = e.detail.cart;
      this.renderEmptySlots(); // ensure empty bundle slots

      if (this.bundleItemsContainer) {
        this.renderSlotItems(this.currentCart);
      }

      // cart fülle prüfen -> ggf slot hinzufügen
      this.renderDrawerCartItems(this.currentCart);

      // pricing
      var pricing = this._calculatePrices(this.currentCart);
      this.currentCartTotal = pricing;
      this.renderPricing(this.currentCartTotal);
      this._updateAddToCartState();
      this._updateNotificationWidget(pricing);
    }
  }, {
    key: "renderSlotItems",
    value: function renderSlotItems(cart) {
      if (!this.bundleItemsContainer) return;
      var bundleSlots = this.bundleItemsContainer.querySelectorAll('ed-bundle-slot');
      bundleSlots.forEach(function (bundleSlot, idx) {
        bundleSlot.dataset.cartIndex = String(idx);
        bundleSlot._render(cart[idx] || null);
      });
    }
  }, {
    key: "renderDrawerCartItems",
    value: function renderDrawerCartItems(cart) {
      if (!this.drawerCartList) return;
      var items = Array.isArray(cart) ? cart : [];
      var slotCount = Math.max(Number(this.maxSlotSize || 0), items.length);
      var placeholderUrl = this.getAttribute('default-placeholder-image');
      this.drawerCartList.innerHTML = '';
      var wrapper = document.createElement('div');
      wrapper.className = 'drawer-cart-items';
      for (var i = 0; i < slotCount; i++) {
        var slot = document.createElement('div');
        slot.className = 'drawer-cart-slot';
        var item = items[i];
        if (item) {
          slot.classList.add('is-filled');
          var img = document.createElement('img');
          img.src = (item === null || item === void 0 ? void 0 : item.imageUrl) || (item === null || item === void 0 ? void 0 : item.image) || '';
          img.alt = (item === null || item === void 0 ? void 0 : item.imageAlt) || (item === null || item === void 0 ? void 0 : item.title) || "Item ".concat(i + 1);
          slot.appendChild(img);
        } else {
          slot.classList.add('is-empty');
          if (placeholderUrl) {
            var ph = document.createElement('img');
            ph.src = placeholderUrl;
            ph.alt = '';
            ph.setAttribute('aria-hidden', 'true');
            ph.className = 'drawer-cart-placeholder';
            slot.appendChild(ph);
          }
        }
        wrapper.appendChild(slot);
      }
      this.drawerCartList.appendChild(wrapper);
    }

    /*****
     *
     *  COMPLEMENTARY PRODUCTS  LOGIC
     *
     **/
  }, {
    key: "_getActiveComplementaryItems",
    value: function _getActiveComplementaryItems() {
      var activeSlots = (this.complementarySlots || []).filter(function (el) {
        return el.classList.contains('active');
      });
      if (!activeSlots.length) return [];
      var items = [];
      activeSlots.forEach(function (el) {
        var variantId = el.dataset.variantId || el.dataset.complementaryVariantId;
        var qtyRaw = el.dataset.qty || el.dataset.quantity || '1';
        var qty = Math.max(1, Number(qtyRaw || 1));
        if (!variantId) return;
        items.push({
          variantId: String(variantId),
          quantity: qty,
          _isComplementary: true
        });
      });
      return items;
    }
  }, {
    key: "updateComplementarySlotsVisibility",
    value: function updateComplementarySlotsVisibility(variantId) {
      var _this$complementarySl;
      if (!((_this$complementarySl = this.complementarySlots) !== null && _this$complementarySl !== void 0 && _this$complementarySl.length)) return;
      var id = String(variantId);

      // alle aus
      (this.complementarySlots || []).forEach(function (el) {
        el.classList.remove('active');
      });

      // nur passende an
      (this.complementarySlots || []).forEach(function (el) {
        if (String(el.dataset.bundleVariantId) === id) {
          el.classList.add('active');
        }
      });
    }

    /*****
     *
     *  BADGES LOGIC
     *
     **/
  }, {
    key: "_getFreeCount",
    value: function _getFreeCount() {
      var _this$currentVariant2;
      // currentVariant kommt direkt aus bundleVariantsJson[variantId]
      var free = Number(((_this$currentVariant2 = this.currentVariant) === null || _this$currentVariant2 === void 0 ? void 0 : _this$currentVariant2.free_products_count) || 0);
      return Math.max(0, free);
    }
  }, {
    key: "_getBadgeLabel",
    value: function _getBadgeLabel() {
      var free = this._getFreeCount();
      return free > 0 ? this.labelBadgeFree : '';
    }

    // logic for drawer badges
  }, {
    key: "_getNextAddSlotIndex",
    value: function _getNextAddSlotIndex() {
      // 0-based index des nächsten Items (Designs im Bundle)
      var cartSize = Array.isArray(this.currentCart) ? this.currentCart.length : 0;
      return cartSize;
    }
  }, {
    key: "_getNextAddBadge",
    value: function _getNextAddBadge() {
      var _this$currentVariant3, _this$_getNextLimit2;
      var idx = this._getNextAddSlotIndex(); // 0-based = cartSize
      var baseSize = Number(((_this$currentVariant3 = this.currentVariant) === null || _this$currentVariant3 === void 0 ? void 0 : _this$currentVariant3.bundle_size) || 0);
      var freeCount = this._getFreeCount();
      if (!baseSize) return null;

      // ✅ Preview-Rule: 1 vor nächster bundle size => nächster Add wird "free"
      // Beispiel: current base=4, nextLimit=6, cartSize=5 => idx=5 => badge free
      var nextLimit = Number(((_this$_getNextLimit2 = this._getNextLimit) === null || _this$_getNextLimit2 === void 0 ? void 0 : _this$_getNextLimit2.call(this)) || 0);
      var isOneBeforeNextLimit = nextLimit > 0 && idx === nextLimit - 1;
      if (!this.disableFreeBadge && isOneBeforeNextLimit) {
        return {
          type: 'free',
          label: this._getBadgeLabel() || 'Gratis'
        };
      }

      // Free Badges Logic
      var isFree = !this.disableFreeBadge && freeCount > 0 && idx < baseSize && idx >= baseSize - freeCount;
      if (isFree) {
        return {
          type: 'free',
          label: this._getBadgeLabel() || 'Gratis'
        };
      }

      // Discount: nur für EXTRA slots (idx >= baseSize)
      if (idx >= baseSize) {
        var pct = this._getDiscountPercentForSlotIndex(idx);
        if (pct > 0) {
          return {
            type: 'discount',
            label: "-".concat(pct, "%")
          };
        }
      }
      return null;
    }

    /*****
     *
     *  VARIANT SELECT LOGIC
     *
     **/
  }, {
    key: "onNeedUpgrade",
    value: function onNeedUpgrade(e) {
      var _this$_getNextLimit3;
      var _ref3 = e.detail || {},
        requiredSize = _ref3.requiredSize,
        nextLimit = _ref3.nextLimit;
      var req = Number(requiredSize || 0);
      var limit = Number(nextLimit || ((_this$_getNextLimit3 = this._getNextLimit) === null || _this$_getNextLimit3 === void 0 ? void 0 : _this$_getNextLimit3.call(this)) || 0);

      // todo: open bundle
      if (!limit) return;
      if (req < limit) return;
      var next = this.bundleVariants.find(function (v) {
        return Number(v.bundleSize) === limit;
      });
      if (!next) return;
      if (Number(this.bundleMasterVariantId) === Number(next.variantId)) return;
      this._pendingAdd = e.detail;
      this._pendingUpgradeVariantId = next.variantId;
      this._selectVariantById(next.variantId);
    }
  }, {
    key: "_selectVariantById",
    value: function _selectVariantById(variantId) {
      var form = this.closest('form[action^="/cart/add"]') || document;
      var optionLabel = this._getOptionValueForVariantId(variantId, form); // z.B. "6er Set"
      if (optionLabel) {
        var radio = form.querySelector("input.SizeSwatch__Radio[name=\"option-0\"][value=\"".concat(CSS.escape(optionLabel), "\"]"));
        if (radio) {
          if (!radio.checked) radio.click();
          return true;
        }
      }
      return false;
    }
  }, {
    key: "_getOptionValueForVariantId",
    value: function _getOptionValueForVariantId(variantId, scopeEl) {
      try {
        var _data$product;
        var jsonEl = scopeEl.querySelector('script[type="application/json"][data-product-json]');
        if (!jsonEl) return null;
        var data = JSON.parse(jsonEl.textContent);
        var variants = (data === null || data === void 0 ? void 0 : (_data$product = data.product) === null || _data$product === void 0 ? void 0 : _data$product.variants) || [];
        var v = variants.find(function (x) {
          return Number(x.id) === Number(variantId);
        });
        return (v === null || v === void 0 ? void 0 : v.option1) || null; // "3er Set" / "6er Set" / "9er Set"
      } catch (err) {
        return null;
      }
    }
  }, {
    key: "_getNextLimit",
    value: function _getNextLimit() {
      var cur = Number(this.currentSlotSize || 0);
      var sorted = (this.slotSizes || []).map(function (n) {
        return Number(n || 0);
      }).filter(function (n) {
        return n > 0;
      }).sort(function (a, b) {
        return a - b;
      });
      return sorted.find(function (n) {
        return n > cur;
      }) || null; // z.B. 6 bei cur=3
    }

    /*****
     *
     *  DISCOUNT LEVELS
     *
     **/
  }, {
    key: "_parseDiscountLevelsAttribute",
    value: function _parseDiscountLevelsAttribute(rawAttr) {
      var _this = this;
      if (!rawAttr) return [];
      var arr = [];
      try {
        // rawAttr ist z.B. '["amount:4|discount:10","amount:6|discount:15"]'
        arr = JSON.parse(rawAttr);
      } catch (e) {
        console.warn('Invalid discount-levels attribute JSON:', rawAttr, e);
        return [];
      }
      if (!Array.isArray(arr)) return [];
      var parsed = arr.map(function (str) {
        return _this._parseDiscountLevelRow(str);
      }).filter(Boolean).sort(function (a, b) {
        return a.amount - b.amount;
      });
      return parsed;
    }
  }, {
    key: "_parseDiscountLevelRow",
    value: function _parseDiscountLevelRow(str) {
      if (!str || typeof str !== 'string') return null;

      // "amount:4|discount:10"
      var parts = str.split('|').map(function (s) {
        return s.trim();
      });
      var map = {};
      var _iterator = _createForOfIteratorHelper(parts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;
          var _p$split$map = p.split(':').map(function (x) {
              return (x || '').trim();
            }),
            _p$split$map2 = _slicedToArray(_p$split$map, 2),
            k = _p$split$map2[0],
            v = _p$split$map2[1];
          if (!k) continue;
          map[k] = v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var amount = Number(map.amount);
      var discount = Number(map.discount);
      if (!Number.isFinite(amount) || amount <= 0) return null;
      if (!Number.isFinite(discount) || discount <= 0) return null;
      return {
        amount: amount,
        discount: discount
      };
    }
  }, {
    key: "_getDiscountPercentForSlotIndex",
    value: function _getDiscountPercentForSlotIndex(idx) {
      var slotNr = idx + 1;
      var discount = 0;
      var _iterator2 = _createForOfIteratorHelper(this.discountLevels || []),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var level = _step2.value;
          if (slotNr > level.amount) discount = level.discount;else break;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return discount; // 0 wenn keiner
    }

    /*****
     *
     *  ADD TO CART METHODS
     *
     **/
  }, {
    key: "onBtnAddToCart",
    value: function onBtnAddToCart(e) {
      var _this$bundleBuilderCa8;
      e.preventDefault();
      e.stopPropagation();
      if (this.defaultAddToCartButton.getAttribute('aria-disabled')) {
        e.stopImmediatePropagation();
        this._scrollToBundleItems(-100);
        return;
      }
      var complementaryItems = this._getActiveComplementaryItems();
      var cartItems = ((_this$bundleBuilderCa8 = this.bundleBuilderCart) === null || _this$bundleBuilderCa8 === void 0 ? void 0 : _this$bundleBuilderCa8.cart) || [];
      var combined = [].concat(_toConsumableArray(complementaryItems), _toConsumableArray(cartItems));
      this.addItemsToCart(combined);
    }
  }, {
    key: "addItemsToCart",
    value: function addItemsToCart(cartItems) {
      var itemsArray = Array.isArray(cartItems) ? cartItems : [];
      var limit = Number(this.currentSlotSize || 0);
      if (!limit && !this.disableDesignSelection) return;
      var complementaryItems = itemsArray.filter(function (i) {
        return i._isComplementary;
      });
      var normalItems = itemsArray.filter(function (i) {
        return !i._isComplementary;
      });
      var itemsToBuy = [].concat(_toConsumableArray(complementaryItems), _toConsumableArray(normalItems));
      var pricing = this._calculatePrices(this.currentCart);
      var fixedPrice = (Number(pricing.totalCents || 0) / 100).toFixed(2);
      var variantIdsFlat = [];
      itemsToBuy.forEach(function (item) {
        var variantId = item.variantId;
        var qty = Number(item.quantity || 1);
        if (!variantId || qty <= 0) return;
        for (var i = 0; i < qty; i++) variantIdsFlat.push(variantId);
      });
      if (!variantIdsFlat.length) return;
      var edBundleItems = variantIdsFlat.join(',');
      var masterVariantId = parseInt(this.bundleMasterVariantId, 10);
      var bundleId = new Date().getTime(); // todo

      CartJS.addItem(masterVariantId, 1, {
        _ed_bb_items: edBundleItems,
        _ed_bb_master_id: masterVariantId,
        _ed_bb_bundle_id: bundleId,
        _ed_bb_discount_type: 'fixed_price',
        _ed_bb_discount_levels: fixedPrice,
        _ed_bb_dynamic_price: fixedPrice
      }, {
        success: function success() {},
        error: function error(jqXHR, textStatus, errorThrown) {
          alert('Error: ' + errorThrown + '!');
        }
      });
    }

    /*****
     *
     *  UPDATE DEFAULT ATC
     *
     **/
  }, {
    key: "_updateAddToCartState",
    value: function _updateAddToCartState() {
      var btn = document.querySelector('#AddToCart');
      if (!btn) return;
      var have = this._getNormalCartCount();
      var required = this.disableDesignSelection ? 0 : Number(this.currentSlotSize || 0);
      var ok = required ? have >= required : true;
      if (!ok) {
        var msg = this._format(this.tplAtcNotReady, {
          have: have,
          required: required
        });
        btn.textContent = msg;
        btn.setAttribute('aria-disabled', 'true');
        return;
      }
      btn.removeAttribute('aria-disabled');
      var pricing = this.currentCartTotal || this._calculatePrices(this.currentCart);
      var showCompare = Number((pricing === null || pricing === void 0 ? void 0 : pricing.compareAtCents) || 0) > Number((pricing === null || pricing === void 0 ? void 0 : pricing.totalCents) || 0);
      var template = showCompare ? this.tplAtcCompare : this.tplAtc;
      var html = this._format(template, {
        price: (pricing === null || pricing === void 0 ? void 0 : pricing.totalFormatted) || '',
        compare: (pricing === null || pricing === void 0 ? void 0 : pricing.compareAtFormatted) || ''
      });
      btn.innerHTML = html;
    }
  }, {
    key: "_updateNotificationWidget",
    value: function _updateNotificationWidget(pricing) {
      if (!this.notificationWidget) return;
      var priceEl = this.notificationWidget.querySelector('[data-notify-pdp-price]');
      priceEl.innerText = pricing === null || pricing === void 0 ? void 0 : pricing.totalFormatted;
    }

    /*****
     *
     *  PRICING
     *
     **/
  }, {
    key: "_calculatePrices",
    value: function _calculatePrices(cart) {
      var _this$currentVariant4,
        _this$currentVariant5,
        _this$currentVariant6,
        _this2 = this;
      var items = Array.isArray(cart) ? cart : [];
      var baseSize = Number(((_this$currentVariant4 = this.currentVariant) === null || _this$currentVariant4 === void 0 ? void 0 : _this$currentVariant4.bundle_size) || 0);
      var fixedBaseCents = Number(((_this$currentVariant5 = this.currentVariant) === null || _this$currentVariant5 === void 0 ? void 0 : _this$currentVariant5.bundle_price) || 0);

      // optional compareAt auf Variant-Level (cents)
      var fixedCompareAtCentsRaw = Number(((_this$currentVariant6 = this.currentVariant) === null || _this$currentVariant6 === void 0 ? void 0 : _this$currentVariant6.bundle_compare_at_price) || 0);
      var toCents = function toCents(amount) {
        var n = Number(amount);
        return Number.isFinite(n) ? Math.round(n * 100) : 0;
      };

      // calc extras
      var extras = items.slice(baseSize);
      var extrasBaseCents = extras.reduce(function (sum, item) {
        return sum + toCents(item === null || item === void 0 ? void 0 : item.price);
      }, 0);
      var extrasFinalCents = extras.reduce(function (sum, item, extraIdx) {
        var slotIdx = baseSize + extraIdx; // 0-based global slot index
        var pct = Number(_this2._getDiscountPercentForSlotIndex(slotIdx) || 0); // 0..100
        var baseCents = toCents(item === null || item === void 0 ? void 0 : item.price);
        if (!pct) return sum + baseCents;
        var discounted = Math.round(baseCents * (1 - pct / 100));
        return sum + Math.max(0, discounted);
      }, 0);
      var discountCents = Math.max(0, extrasBaseCents - extrasFinalCents);
      var totalCents = fixedBaseCents + extrasFinalCents;

      // CompareAt: Basis (wenn gepflegt, sonst fallback auf fixedBase) + Extras OHNE Rabatt
      var compareBase = fixedCompareAtCentsRaw > fixedBaseCents ? fixedCompareAtCentsRaw : fixedBaseCents;
      var compareAtCents = compareBase + extrasBaseCents;
      var moneyFormat = window.theme && window.theme.moneyFormat || '{{amount}} €';
      return {
        baseSize: baseSize,
        fixedBaseCents: fixedBaseCents,
        fixedCompareAtCents: fixedCompareAtCentsRaw,
        extrasCount: Math.max(0, items.length - baseSize),
        extrasBaseCents: extrasBaseCents,
        extrasFinalCents: extrasFinalCents,
        discountCents: discountCents,
        totalCents: totalCents,
        compareAtCents: compareAtCents,
        totalFormatted: (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(totalCents, moneyFormat),
        compareAtFormatted: (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(compareAtCents, moneyFormat),
        // für UI/Debug:
        discountFormatted: (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(discountCents, moneyFormat)
      };

      /*** TODO: PRICE METHOD FOR COMPLETELY DYNAMIC BUNDLES
       const items = Array.isArray(cart) ? cart : [];
        const totalAmount = items.reduce((sum, item) => {
       const n = Number(item?.price);
       if (!Number.isFinite(n)) return sum;
       return sum + n;
       }, 0);
        return {
       totalAmount,
       totalFormatted: totalAmount.toFixed(2)
       };
       ***/
    }
  }, {
    key: "renderPricing",
    value: function renderPricing(pricing) {
      var wrap = document.querySelector('.ProductMeta__PriceList');
      if (!wrap) return;
      var priceEl = wrap.querySelector('.Price:not(.Price--compareAt)');
      if (priceEl) {
        priceEl.textContent = pricing.totalFormatted;
        priceEl.setAttribute('data-money-convertible', '');
      }
      var shouldShowCompare = Number(pricing.compareAtCents || 0) > Number(pricing.totalCents || 0);

      // --- compareAt price ---
      var compareEl = wrap.querySelector('.Price--compareAt');
      if (shouldShowCompare) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'ProductMeta__Price Price Price--compareAt Text--subdued';
          compareEl.setAttribute('data-money-convertible', '');
          wrap.insertBefore(compareEl, wrap.querySelector('.ProductMeta__Price__TaxShipping') || null);
        }
        compareEl.textContent = pricing.compareAtFormatted;
        priceEl === null || priceEl === void 0 ? void 0 : priceEl.classList.add('Price--highlight', 'Text--subdued');
      } else {
        if (compareEl) compareEl.remove();
        priceEl === null || priceEl === void 0 ? void 0 : priceEl.classList.remove('Price--highlight', 'Text--subdued');
      }

      // --- savings badge (percent) ---
      var pct = this._getSavingsPercent(pricing.compareAtCents, pricing.totalCents);
      var savingsEl = wrap.querySelector('[data-bb-savings]');
      compareEl = wrap.querySelector('.Price--compareAt'); // re-read after create/remove
      var taxEl = wrap.querySelector('.ProductMeta__Price__TaxShipping');
      if (pct && shouldShowCompare && compareEl) {
        if (!savingsEl) {
          savingsEl = document.createElement('span');
          savingsEl.setAttribute('data-bb-savings', 'true');
          savingsEl.className = 'bb-savings-badge';
        }
        var label = this._format(this.tplSavings, {
          percent: "".concat(pct, "%")
        });
        savingsEl.textContent = label;

        // Position: nach compareAt, aber vor TaxShipping
        if (taxEl) {
          wrap.insertBefore(savingsEl, taxEl);
        } else {
          compareEl.insertAdjacentElement('afterend', savingsEl);
        }
      } else {
        if (savingsEl) savingsEl.remove();
      }
    }

    // for savings badge
  }, {
    key: "_getSavingsPercent",
    value: function _getSavingsPercent(compareAtCents, totalCents) {
      var compare = Number(compareAtCents || 0);
      var total = Number(totalCents || 0);
      if (!Number.isFinite(compare) || !Number.isFinite(total)) return null;
      if (compare <= 0) return null;
      if (total <= 0) return null;
      if (compare <= total) return null;

      // ((compare - total) / compare) * 100
      var pct = Math.round((compare - total) / compare * 100);

      // Safety: only show when >= 1%
      if (!Number.isFinite(pct) || pct <= 0) return null;
      return pct;
    }

    /*****
     *
     *  MORE HELPERS
     *
     **/
  }, {
    key: "_scrollToBundleItems",
    value: function _scrollToBundleItems() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -100;
      var header = document.querySelector('.Header');
      var headerHeight = header ? header.offsetHeight : 0;
      (0,_helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_1__.scrollToElement)(this.bundleItemsContainer, offset - headerHeight);
    }
  }, {
    key: "_getNormalCartCount",
    value: function _getNormalCartCount() {
      var _this$bundleBuilderCa9;
      var cartItems = ((_this$bundleBuilderCa9 = this.bundleBuilderCart) === null || _this$bundleBuilderCa9 === void 0 ? void 0 : _this$bundleBuilderCa9.cart) || [];
      return cartItems.length; // without complementary products
    }
  }, {
    key: "_isSelectedSizeReached",
    value: function _isSelectedSizeReached() {
      var _this$currentVariant7;
      var required = Number(this.currentSlotSize || ((_this$currentVariant7 = this.currentVariant) === null || _this$currentVariant7 === void 0 ? void 0 : _this$currentVariant7.bundle_size) || 0);
      if (!required) return true;
      return this._getNormalCartCount() >= required;
    }
  }, {
    key: "_isMinReached",
    value: function _isMinReached() {
      var min = Number(this.minBundleSize || 0);
      if (!min) return true;
      return this._getNormalCartCount() >= min;
    }
  }, {
    key: "_getNextVariant",
    value: function _getNextVariant() {
      var _this$currentVariant8, _this$bundleVariantsJ, _this$bundleVariantsJ2;
      var cur = Number(((_this$currentVariant8 = this.currentVariant) === null || _this$currentVariant8 === void 0 ? void 0 : _this$currentVariant8.bundle_size) || 0);
      if (!cur || !Array.isArray(this.bundleVariants)) return null;
      var nextSize = (this.bundleVariants || []).map(function (v) {
        return Number(v.bundleSize || 0);
      }).filter(function (n) {
        return n > cur;
      }).sort(function (a, b) {
        return a - b;
      })[0];
      if (!nextSize) return null;
      var entry = (this.bundleVariants || []).find(function (v) {
        return Number(v.bundleSize) === nextSize;
      });
      if (!entry) return null;
      var nextVariant = ((_this$bundleVariantsJ = this.bundleVariantsJson) === null || _this$bundleVariantsJ === void 0 ? void 0 : _this$bundleVariantsJ[String(entry.variantId)]) || ((_this$bundleVariantsJ2 = this.bundleVariantsJson) === null || _this$bundleVariantsJ2 === void 0 ? void 0 : _this$bundleVariantsJ2[entry.variantId]);
      return nextVariant || null;
    }
  }, {
    key: "_format",
    value: function _format(template) {
      var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!template) return '';
      return String(template).replace(/\{(\w+)\}/g, function (_, key) {
        return vars[key] != null ? String(vars[key]) : '';
      });
    }
  }, {
    key: "_emitUiRefresh",
    value: function _emitUiRefresh() {
      var _this$bundleBuilderCa10, _this$bundleBuilderCa11;
      (_this$bundleBuilderCa10 = this.bundleBuilderCart) === null || _this$bundleBuilderCa10 === void 0 ? void 0 : (_this$bundleBuilderCa11 = _this$bundleBuilderCa10._emitCartUpdated) === null || _this$bundleBuilderCa11 === void 0 ? void 0 : _this$bundleBuilderCa11.call(_this$bundleBuilderCa10);
    }
  }]);
  return EdBundleBuilder;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-bundle-builder')) {
  customElements.define('ed-bundle-builder', EdBundleBuilder);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-reservation-label.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/ed-cart-reservation-label.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var edCartReservationLabel = /*#__PURE__*/function (_HTMLElement) {
  _inherits(edCartReservationLabel, _HTMLElement);
  var _super = _createSuper(edCartReservationLabel);
  function edCartReservationLabel() {
    _classCallCheck(this, edCartReservationLabel);
    return _super.apply(this, arguments);
  }
  _createClass(edCartReservationLabel, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.reservationText = this.getAttribute('reservation-label');
      this.endedReservationText = this.getAttribute('ended-reservation-label');
      this.countdownEl = this.querySelector(".countdown-label-container");
      this.counterStatus = this._getCounterStatusLocalStorage();
      this.reservationTextEl = this.querySelector(".reservation-text");
      this.fadeOutInterval;
      this.countdownInterval;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('cartItemAdded', function (event) {
        this._setCounterStatusLocalStorage('false');
        this._activateCountdown();
      }.bind(this));
      document.addEventListener('DOMContentLoaded', function () {
        this._activateCountdown();
      }.bind(this));
    }
  }, {
    key: "_activateCountdown",
    value: function _activateCountdown() {
      var edTimer = this.querySelector('#timer');
      this.counterStatus = this._getCounterStatusLocalStorage();
      if (this.counterStatus === 'false') {
        this._restartCounter(edTimer);
      } else {
        this._continueCounter(edTimer);
      }
    }
  }, {
    key: "_restartCounter",
    value: function _restartCounter(edTimer) {
      var edReservationText = document.querySelector(".reservation-text");
      this._clearCurrentCounterInterval();
      edReservationText.innerHTML = this.reservationText;
      edTimer = document.querySelector('#timer');
      var startCounter = new Date().getTime();
      var endCounter = new Date().getTime() + 15 * 60 * 1000;
      this._startCounterLocalStorage(startCounter);
      this._setCounterStatusLocalStorage('true');
      this._endCounterLocalStorage(endCounter);
      var counterDifference = endCounter - startCounter;
      var countdownTime = counterDifference / 1000;
      this._startTimer(countdownTime, edTimer);
    }
  }, {
    key: "_continueCounter",
    value: function _continueCounter(edTimer) {
      var currentCounter = new Date().getTime();
      var endCounter = this._getCounterLocalStorage();
      var counterDifference = endCounter - currentCounter;
      var countdownTime = counterDifference / 1000;
      this._startTimer(countdownTime, edTimer);
    }
  }, {
    key: "_startTimer",
    value: function _startTimer(duration, edTimer) {
      this._clearCurrentCounterInterval();
      this._removeFadeOutEffect();
      var timer = duration;
      var minutes, seconds;
      this.countdownInterval = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        edTimer.textContent = minutes + ":" + seconds;
        if (--timer < 0) {
          this._clearCurrentCounterInterval();
          this.reservationTextEl.innerHTML = this.endedReservationText;
          this._removeFadeOutEffect();
        }
      }.bind(this), 1000);
      this.fadeOutInterval = setTimeout(this._addFadeOutEffect.bind(this), 10000);
    }
  }, {
    key: "_addFadeOutEffect",
    value: function _addFadeOutEffect() {
      this.countdownEl.classList.add('counter-transition');
    }
  }, {
    key: "_removeFadeOutEffect",
    value: function _removeFadeOutEffect() {
      this.countdownEl.classList.remove('counter-transition');
      clearTimeout(this.fadeOutInterval);
    }
  }, {
    key: "_setCounterStatusLocalStorage",
    value: function _setCounterStatusLocalStorage(status) {
      window.localStorage.setItem('restart_counter', status);
    }
  }, {
    key: "_getCounterStatusLocalStorage",
    value: function _getCounterStatusLocalStorage() {
      return window.localStorage.getItem('restart_counter');
    }
  }, {
    key: "_startCounterLocalStorage",
    value: function _startCounterLocalStorage(startCounter) {
      window.localStorage.setItem('start_counter', startCounter);
    }
  }, {
    key: "_endCounterLocalStorage",
    value: function _endCounterLocalStorage(endCounter) {
      window.localStorage.setItem('end_counter', endCounter);
    }
  }, {
    key: "_getCounterLocalStorage",
    value: function _getCounterLocalStorage() {
      return window.localStorage.getItem('end_counter');
    }
  }, {
    key: "_clearCurrentCounterInterval",
    value: function _clearCurrentCounterInterval() {
      clearInterval(this.countdownInterval);
    }
  }]);
  return edCartReservationLabel;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-reservation-label', edCartReservationLabel);

/***/ }),

/***/ "./src/js/modules/ed-copy-clipboard-widget.js":
/*!****************************************************!*\
  !*** ./src/js/modules/ed-copy-clipboard-widget.js ***!
  \****************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var edCopyClipboardWidget = /*#__PURE__*/function (_HTMLElement) {
  _inherits(edCopyClipboardWidget, _HTMLElement);
  var _super = _createSuper(edCopyClipboardWidget);
  function edCopyClipboardWidget() {
    _classCallCheck(this, edCopyClipboardWidget);
    return _super.apply(this, arguments);
  }
  _createClass(edCopyClipboardWidget, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.copyClipboardButton = this.querySelector(".edCopyClipboardButton");
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.copyClipboardButton.addEventListener('click', this._copyToClipboard.bind(this));
    }
  }, {
    key: "_copyToClipboard",
    value: function _copyToClipboard(event) {
      var copyClipboardInput = this.querySelector(".edCopyClipboardInput");
      this.copyClipboardButton.classList.remove('uncopied-state');
      this.copyClipboardButton.classList.add('copied-state');
      copyClipboardInput.select();
      copyClipboardInput.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyClipboardInput.value);
    }
  }]);
  return edCopyClipboardWidget;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-copy-clipboard-widget', edCopyClipboardWidget);

/***/ }),

/***/ "./src/js/modules/ed-free-gift-auto.js":
/*!*********************************************!*\
  !*** ./src/js/modules/ed-free-gift-auto.js ***!
  \*********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdFreeGiftAuto = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdFreeGiftAuto, _HTMLElement);
  var _super = _createSuper(EdFreeGiftAuto);
  function EdFreeGiftAuto() {
    _classCallCheck(this, EdFreeGiftAuto);
    return _super.apply(this, arguments);
  }
  _createClass(EdFreeGiftAuto, [{
    key: "cartTotal",
    get: function get() {
      return this.getAttribute('cart-total');
    },
    set: function set(value) {
      return this.setAttribute('cart-total', value);
    }

    /*
    static get observedAttributes() {
     return ['cart-total'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
     if (name === 'cart-total' && !this.isFreeGiftAlreadyInCart) {
         this.checkFreeGift();
     }
    }
    */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.threshold = this.getAttribute('threshold');
      this.freeGift = this.getAttribute('free-gift');
      this.cartItems = this.getAttribute('cart-items');
      this.actualPriceOfFreeGift = JSON.parse(this.getAttribute('actual-price'));
      this.withoutDiscount = this.classList.contains('ed-without-discount-logic');
      this.allowRemoval = this.getAttribute('allow-removal') === '';
      if (this.cartItems) {
        this.cartItems = JSON.parse(this.cartItems);
      }
      this._attachSelectors();
      this._attachListeners();

      //this.isFreeGiftAlreadyInCart = this.isFreeGiftInCart(this.cartItems);
      //this.checkFreeGift();
      setTimeout(function () {
        _this.updateFreeGiftCartStyling();
      });
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.freeGiftUpsellItem = document.querySelector('[data-free-gift-upsell-item]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      document.addEventListener('ed:cart:change', function (e) {
        _this2.onCartChange(e.detail.cart);
        _this2.updateFreeGiftCartStyling();
      });
    }
  }, {
    key: "onCartChange",
    value: function onCartChange(cart) {
      this.cartTotal = cart.total_price;
      if (this.withoutDiscount) {
        if (this.isFreeGiftAlreadyInCart) {
          this.cartTotal = cart.total_price - this.actualPriceOfFreeGift;
        }
      }
      this.cartItems = cart.items;
      this.isFreeGiftAlreadyInCart = this.isFreeGiftInCart(this.cartItems);
      this.checkFreeGift();
    }
  }, {
    key: "checkFreeGift",
    value: function checkFreeGift() {
      var cartTotal = parseFloat(this.cartTotal);
      var threshold = parseFloat(this.threshold);
      if (cartTotal >= threshold && !this.isFreeGiftAlreadyInCart) {
        var _this$freeGiftUpsellI;
        // check if it already got added by cookies

        if (this.withoutDiscount) {
          this.addFreeGiftToCart(this.freeGift);
        } else {
          if (!this.getCookie('ed_free_gift_added')) {
            this.addFreeGiftToCart(this.freeGift);
          }
        }
        (_this$freeGiftUpsellI = this.freeGiftUpsellItem) === null || _this$freeGiftUpsellI === void 0 ? void 0 : _this$freeGiftUpsellI.classList.remove('hide');
      }

      // remove upsell if threshold is not reached and not in cat
      if (cartTotal < threshold && this.isFreeGiftAlreadyInCart) {
        CartJS.removeItemById(this.freeGift);
      }

      // remove upsell if threshold is not reached and not in cat
      if (cartTotal < threshold && !this.isFreeGiftAlreadyInCart) {
        var _this$freeGiftUpsellI2;
        (_this$freeGiftUpsellI2 = this.freeGiftUpsellItem) === null || _this$freeGiftUpsellI2 === void 0 ? void 0 : _this$freeGiftUpsellI2.classList.add('hide');
      }
    }
  }, {
    key: "updateFreeGiftCartStyling",
    value: function updateFreeGiftCartStyling() {
      var _this3 = this;
      var cartItems = document.querySelectorAll('.cart__products .cart__product');
      cartItems.forEach(function (item) {
        if (item.dataset.productId === _this3.freeGift) {
          item.classList.add('free-gift');
        } else {
          item.classList.remove('free-gift');
        }
      });
    }
  }, {
    key: "isFreeGiftInCart",
    value: function isFreeGiftInCart(items) {
      var _this4 = this;
      return items.some(function (item) {
        return item.id.toString() === _this4.freeGift;
      });
    }
  }, {
    key: "addFreeGiftToCart",
    value: function addFreeGiftToCart(variantId) {
      var _this5 = this;
      if (this.withoutDiscount) {
        CartJS.addItem(variantId, 1, {}, {
          "success": function success() {
            _this5.isFreeGiftAlreadyInCart = true;
            document.dispatchEvent(new CustomEvent('cartItemAdded'));
            if (window.globalEnableRedirectToCart) {
              document.querySelector('.trigger-cart').click();
            }
          }
        });
      } else {
        CartJS.addItem(variantId, 1, {
          '_ed_free_gift': true,
          '_token': this.getAttribute('token'),
          '_hash': this.getAttribute('hash')
        }, {
          "success": function success() {
            _this5.isFreeGiftAlreadyInCart = true;
            document.dispatchEvent(new CustomEvent('cartItemAdded'));
            if (window.globalEnableRedirectToCart) {
              document.querySelector('.trigger-cart').click();
            }
            if (_this5.allowRemoval) {
              var _this5$freeGiftUpsell;
              (_this5$freeGiftUpsell = _this5.freeGiftUpsellItem) === null || _this5$freeGiftUpsell === void 0 ? void 0 : _this5$freeGiftUpsell.classList.add('hide');
              _this5.setCookie('ed_free_gift_added', 'true', 15); // Set a simple flag that expires in 15 minutes
            }
          }
        });
      }
    }

    /** COOKIE METHODS **/
  }, {
    key: "setCookie",
    value: function setCookie(name, value, minutes) {
      var d = new Date();
      d.setTime(d.getTime() + minutes * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }]);
  return EdFreeGiftAuto;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-free-gift-auto', EdFreeGiftAuto);

/***/ }),

/***/ "./src/js/modules/ed-free-gift-select.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-free-gift-select.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdFreeGiftSelect = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdFreeGiftSelect, _HTMLElement);
  var _super = _createSuper(EdFreeGiftSelect);
  function EdFreeGiftSelect() {
    _classCallCheck(this, EdFreeGiftSelect);
    return _super.apply(this, arguments);
  }
  _createClass(EdFreeGiftSelect, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$actualPrices,
        _this = this;
      this.threshold = parseFloat(this.getAttribute('threshold')) || 0;
      this.freeGift1 = this.getAttribute('free-gift-1');
      this.freeGift2 = this.getAttribute('free-gift-2');
      this.actualPrice1 = parseFloat(this.getAttribute('actual-price-1')) || 0;
      this.actualPrice2 = parseFloat(this.getAttribute('actual-price-2')) || 0;
      this.withoutDiscount = this.classList.contains('ed-without-discount-logic');
      this.allowRemoval = this.hasAttribute('allow-removal');
      this.hash = this.getAttribute('hash');
      this.token = this.getAttribute('token');
      this.isAddingFreeGift = false;
      this.freeGiftIds = [this.freeGift1, this.freeGift2];
      this.actualPrices = (_this$actualPrices = {}, _defineProperty(_this$actualPrices, this.freeGift1, this.actualPrice1), _defineProperty(_this$actualPrices, this.freeGift2, this.actualPrice2), _this$actualPrices);
      this._attachSelectors();
      this._attachListeners();
      setTimeout(function () {
        var cartItemsAttr = _this.getAttribute('cart-items');
        if (cartItemsAttr) {
          try {
            var parsed = JSON.parse(cartItemsAttr);
            var items = Array.isArray(parsed) ? parsed : parsed.items || [];
            var cartData = {
              items: items,
              total_price: _this.getAttribute('cart-total')
            };
            _this._onCartData(cartData);
            _this.updateCombinedProgressBar(cartData);
          } catch (e) {}
        }
        _this.updateFreeGiftCartStyling();
      });
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cards = this.querySelectorAll('.ed-free-gift-select__card');
      this.buttons = this.querySelectorAll('.ed-free-gift-select__card__button');
      this.removeBtn = this.querySelector('[data-remove-free-gift]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      document.addEventListener('ed:cart:change', function (e) {
        _this2.onCartChange(e.detail.cart);
        _this2.updateFreeGiftCartStyling();
        _this2.updateCombinedProgressBar(e.detail.cart);
      });
      this.cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          return _this2.onAddClick(e, card);
        });
      });
      if (this.removeBtn) {
        this.removeBtn.addEventListener('click', function (e) {
          return _this2.onRemoveClick(e);
        });
      }
    }
  }, {
    key: "updateCombinedProgressBar",
    value: function updateCombinedProgressBar(cart) {
      var bar = document.querySelector('.cart__progress-bar--combined');
      if (!bar) return;
      var maxThreshold = parseFloat(bar.dataset.maxThreshold) || 0;
      var freeShip = parseFloat(bar.dataset.freeShippingThreshold) || 0;
      var freeGift = parseFloat(bar.dataset.freeGiftThreshold) || 0;
      var minThreshold = Math.min(freeShip, freeGift) || maxThreshold;
      var thresholdGap = maxThreshold - minThreshold;
      var cartTotal = parseFloat(cart.total_price) || 0;
      var freeGiftInCart = this.getFreeGiftInCart(cart.items || []);
      var cartTotalForGift = this.withoutDiscount && freeGiftInCart ? cartTotal - (this.actualPrices[freeGiftInCart] || 0) : cartTotal;
      bar.dataset.cartTotal = cartTotal;
      var stepsActive = bar.querySelector('.cart__progress-bar__steps-active');
      var freeGiftEnabled = bar.dataset.edEnableFreeGift === 'true';
      if (stepsActive && maxThreshold > 0) {
        var pct;
        if (!freeGiftEnabled || thresholdGap <= 0) {
          pct = Math.min(100, cartTotal / maxThreshold * 100);
        } else if (cartTotal >= maxThreshold) {
          pct = 100;
        } else if (cartTotal < minThreshold) {
          pct = Math.min(90, cartTotal / minThreshold * 90);
        } else {
          pct = 90 + (cartTotal - minThreshold) / thresholdGap * 10;
        }
        bar.style.setProperty('--combined-progress-width', Math.min(100, pct) + '%');
      }
      var milestones = bar.querySelectorAll('.cart__progress-bar__milestone');
      var iconMarkers = bar.querySelectorAll('.cart__progress-bar__icon-marker');
      milestones.forEach(function (m, i) {
        var threshold = parseFloat(m.dataset.threshold) || 0;
        var isFreeGift = m.dataset.type === 'free-gift';
        var total = isFreeGift ? cartTotalForGift : cartTotal;
        var unlocked = total >= threshold;
        m.classList.toggle('cart__progress-bar__milestone--locked', !unlocked);
        m.classList.toggle('cart__progress-bar__milestone--unlocked', unlocked);
        if (iconMarkers[i]) {
          iconMarkers[i].classList.toggle('cart__progress-bar__icon-marker--unlocked', unlocked);
        }
      });
    }
  }, {
    key: "onCartChange",
    value: function onCartChange(cart) {
      this._onCartData(cart);
    }
  }, {
    key: "_onCartData",
    value: function _onCartData(cart) {
      var _freeGiftItems$;
      var items = cart.items || [];
      var totalPrice = parseFloat(cart.total_price) || 0;
      var freeGiftItems = this.getFreeGiftItems(items);
      var freeGiftInCart = ((_freeGiftItems$ = freeGiftItems[0]) === null || _freeGiftItems$ === void 0 ? void 0 : _freeGiftItems$.variantId) || null;
      if (freeGiftItems.length > 1) {
        freeGiftItems.slice(1).forEach(function (entry) {
          CartJS.removeItemById(entry.variantId);
        });
        return;
      }
      var cartTotal = totalPrice;
      if (this.withoutDiscount && freeGiftInCart) {
        var price = this.actualPrices[freeGiftInCart];
        if (price !== undefined) cartTotal = totalPrice - price;
      }
      var threshold = this.threshold;
      var meetsThreshold = cartTotal >= threshold;
      if (!meetsThreshold && freeGiftInCart) {
        CartJS.removeItemById(freeGiftInCart);
        return;
      }
      this._updateCardStates(items, meetsThreshold);
      this._updateRemoveButton(freeGiftInCart);
    }
  }, {
    key: "_updateRemoveButton",
    value: function _updateRemoveButton(freeGiftInCart) {
      if (!this.removeBtn || !this.allowRemoval) return;
      if (freeGiftInCart) {
        this.removeBtn.style.display = '';
        this.removeBtn.dataset.removeVariantId = freeGiftInCart;
      } else {
        this.removeBtn.style.display = 'none';
      }
    }
  }, {
    key: "onRemoveClick",
    value: function onRemoveClick(e) {
      var _this$removeBtn;
      e.preventDefault();
      if (!this.allowRemoval) return;
      var variantId = (_this$removeBtn = this.removeBtn) === null || _this$removeBtn === void 0 ? void 0 : _this$removeBtn.dataset.removeVariantId;
      if (!variantId) return;
      CartJS.removeItemById(variantId);
    }
  }, {
    key: "getFreeGiftInCart",
    value: function getFreeGiftInCart(items) {
      var _iterator = _createForOfIteratorHelper(items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var vid = (item.variant_id || item.id || '').toString();
          if (this.freeGiftIds.includes(vid)) return vid;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "getFreeGiftItems",
    value: function getFreeGiftItems(items) {
      var result = [];
      var _iterator2 = _createForOfIteratorHelper(items),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          var vid = (item.variant_id || item.id || '').toString();
          if (this.freeGiftIds.includes(vid)) {
            result.push({
              variantId: vid,
              item: item
            });
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result;
    }
  }, {
    key: "_updateCardStates",
    value: function _updateCardStates(items, meetsThreshold) {
      var freeGiftInCart = this.getFreeGiftInCart(items);
      var anyFreeGiftInCart = !!freeGiftInCart;
      this.cards.forEach(function (card) {
        var variantId = card.dataset.freeGiftVariantId;
        var inCart = freeGiftInCart === variantId;
        card.classList.remove('ed-free-gift--disabled', 'ed-free-gift--active', 'ed-free-gift--in-cart', 'ed-free-gift--locked');
        if (!meetsThreshold) {
          card.classList.add('ed-free-gift--disabled');
        } else if (inCart) {
          card.classList.add('ed-free-gift--active', 'ed-free-gift--in-cart');
        } else {
          card.classList.add('ed-free-gift--active');
        }
        if (anyFreeGiftInCart) card.classList.add('ed-free-gift--locked');
        var btn = card.querySelector('.ed-free-gift-select__card__button');
        if (btn) {
          btn.disabled = !meetsThreshold || anyFreeGiftInCart;
          btn.textContent = inCart ? "\u2714" : '+';
        }
      });
    }
  }, {
    key: "onAddClick",
    value: function onAddClick(e, card) {
      var _this3 = this;
      e.preventDefault();
      var variantId = card.dataset.freeGiftVariantId;
      if (!variantId) return;
      var items = CartJS.cart && CartJS.cart.items || [];
      var freeGiftInCart = this.getFreeGiftInCart(items);
      if (freeGiftInCart) return;
      if (this.isAddingFreeGift) return;
      this.isAddingFreeGift = true;
      var addItem = function addItem() {
        if (_this3.withoutDiscount) {
          CartJS.addItem(variantId, 1, {}, {
            success: function success() {
              _this3.isAddingFreeGift = false;
              document.dispatchEvent(new CustomEvent('cartItemAdded'));
              if (window.globalEnableRedirectToCart) {
                var trigger = document.querySelector('.trigger-cart');
                if (trigger) trigger.click();
              }
            }
          });
        } else {
          CartJS.addItem(variantId, 1, {
            '_ed_free_gift': true,
            '_token': _this3.token,
            '_hash': _this3.hash
          }, {
            success: function success() {
              _this3.isAddingFreeGift = false;
              document.dispatchEvent(new CustomEvent('cartItemAdded'));
              if (window.globalEnableRedirectToCart) {
                var trigger = document.querySelector('.trigger-cart');
                if (trigger) trigger.click();
              }
            }
          });
        }
      };
      addItem();
    }
  }, {
    key: "updateFreeGiftCartStyling",
    value: function updateFreeGiftCartStyling() {
      var _this4 = this;
      var cartProducts = document.querySelectorAll('.cart__products .cart__product');
      cartProducts.forEach(function (item) {
        var pid = (item.dataset.productId || item.getAttribute('data-product-id') || item.getAttribute('rv-data-product-id') || '').toString();
        if (_this4.freeGiftIds.includes(pid)) {
          item.classList.add('free-gift');
        } else {
          item.classList.remove('free-gift');
        }
      });
    }
  }]);
  return EdFreeGiftSelect;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-free-gift-select', EdFreeGiftSelect);

/***/ }),

/***/ "./src/js/modules/ed-mobile-zoom.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-mobile-zoom.js ***!
  \******************************************/
/***/ (() => {

(function () {
  'use strict';

  if (!document.body.classList.contains('allow-wider-image-gallery-mobile')) {
    return;
  }
  if (!document.querySelector('.Product__Gallery')) {
    return;
  }
  function isMobile() {
    return window.innerWidth <= 1000;
  }
  function isPhotoSwipeClosed() {
    var pswpElement = document.querySelector('.pswp');
    return !pswpElement || !pswpElement.classList.contains('pswp--open');
  }
  function initMobileZoom() {
    if (!isMobile()) {
      return;
    }
    var productGallery = document.querySelector('.Product__Gallery');
    if (!productGallery) {
      return;
    }
    var images = productGallery.querySelectorAll('.Product__Slideshow img');
    if (images.length > 0) {
      setupMobileZoom(productGallery, images);
    }
  }
  function setupMobileZoom(gallery, images) {
    var lastTapTime = 0;
    var doubleTapDelay = 300;
    images.forEach(function (image) {
      image.addEventListener('touchstart', function (e) {
        if (!isPhotoSwipeClosed()) {
          return;
        }
        var now = Date.now();
        var timeSinceLastTap = now - lastTapTime;
        if (timeSinceLastTap < doubleTapDelay && timeSinceLastTap > 0) {
          e.preventDefault();
          openPhotoSwipe(image, images);
        }
        lastTapTime = now;
      }, {
        passive: false
      });
      image.addEventListener('click', function (e) {
        if (!isPhotoSwipeClosed()) {
          return;
        }
        if (isMobile() && !e.target.closest('[data-action="open-product-zoom"]')) {
          e.preventDefault();
          openPhotoSwipe(image, images);
        }
      });
    });
  }
  function openPhotoSwipe(clickedImage, allImages) {
    var zoomButton = clickedImage.closest('.Product__Gallery').querySelector('[data-action="open-product-zoom"]');
    if (zoomButton) {
      zoomButton.click();
      setTimeout(function () {
        var pswpElement = document.querySelector('.pswp');
        if (pswpElement) {
          var closeButton = pswpElement.querySelector('.pswp__button--close');
          if (closeButton) {
            closeButton.addEventListener('click', function () {
              cleanupPhotoSwipe();
            }, {
              once: true
            });
          }
          var pswpBg = pswpElement.querySelector('.pswp__bg');
          if (pswpBg) {
            pswpBg.addEventListener('click', function () {
              cleanupPhotoSwipe();
            }, {
              once: true
            });
          }
          var escapeHandler = function escapeHandler(e) {
            if (e.key === 'Escape') {
              cleanupPhotoSwipe();
              document.removeEventListener('keydown', escapeHandler);
            }
          };
          document.addEventListener('keydown', escapeHandler);
          pswpElement.addEventListener('pswpDestroy', function () {
            cleanupPhotoSwipe();
          }, {
            once: true
          });
        }
      }, 50);
    } else {
      createPhotoSwipeItems(clickedImage, allImages, 0);
    }
  }
  function createPhotoSwipeItems(clickedImage, allImages, selectedIndex) {
    var items = Array.from(allImages).map(function (image) {
      var maxWidth = parseInt(image.getAttribute('data-max-width')) || image.naturalWidth;
      var maxHeight = parseInt(image.getAttribute('data-max-height')) || image.naturalHeight;
      var maxDimension = 1200;
      var reduceFactor = 1.0;
      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.src
      };
    });
    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement) {
      return;
    }
    var options = {
      index: selectedIndex,
      showHideOpacity: true,
      showAnimationDuration: 300,
      loop: false,
      history: false,
      closeOnVerticalDrag: true,
      allowPanToNext: true,
      pinchToClose: true,
      errorMsg: '<p class="pswp__error-msg">Image loading error</p>',
      scaleMode: 'zoom',
      getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
        return item.initialZoomLevel < 0.7 ? 1 : 1.33;
      },
      getThumbBoundsFn: function getThumbBoundsFn(index) {
        var thumbnail = allImages[index];
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var rect = thumbnail.getBoundingClientRect();
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
      }
    };
    var gallery = new PhotoSwipe(pswpElement, false, items, options);
    gallery.listen('doubleTap', function (point) {
      var initialZoomLevel = gallery.currItem.initialZoomLevel;
      if (gallery.getZoomLevel() !== initialZoomLevel) {
        gallery.zoomTo(initialZoomLevel, point, 333);
      } else {
        gallery.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
      }
    });
    gallery.init();
  }
  function cleanupPhotoSwipe() {
    var pswpElement = document.querySelector('.pswp');
    if (pswpElement) {
      pswpElement.classList.remove('pswp--open', 'pswp--visible', 'pswp--animate_opacity', 'pswp--touch', 'pswp--css_animation', 'pswp--svg');
      pswpElement.style.display = 'none';
      pswpElement.style.position = '';
      pswpElement.style.opacity = '';
      pswpElement.style.visibility = 'hidden';
      pswpElement.style.pointerEvents = 'none';
      pswpElement.style.zIndex = '-1';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.bottom = '';
      document.body.style.height = '';
      document.body.style.width = '';
      var pswpScrollWrap = pswpElement.querySelector('.pswp__scroll-wrap');
      if (pswpScrollWrap) {
        pswpScrollWrap.style.overflow = '';
        pswpScrollWrap.style.position = '';
        pswpScrollWrap.style.pointerEvents = 'none';
      }
      var pswpContainer = pswpElement.querySelector('.pswp__container');
      if (pswpContainer) {
        pswpContainer.style.transform = '';
        pswpContainer.style.pointerEvents = 'none';
      }
      var pswpBg = pswpElement.querySelector('.pswp__bg');
      if (pswpBg) {
        pswpBg.style.opacity = '';
        pswpBg.style.pointerEvents = 'none';
      }
      setTimeout(function () {
        if (pswpElement) {
          pswpElement.remove();
        }
      }, 1000);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileZoom);
  } else {
    initMobileZoom();
  }
  var scrollAttempts = 0;
  document.addEventListener('scroll', function () {
    var pswpElement = document.querySelector('.pswp');
    if (pswpElement && pswpElement.classList.contains('pswp--open') && pswpElement.classList.contains('pswp--visible')) {
      scrollAttempts++;
      if (scrollAttempts > 2) {
        cleanupPhotoSwipe();
        scrollAttempts = 0;
      }
    } else {
      scrollAttempts = 0;
    }
  }, {
    passive: true
  });
  window.addEventListener('resize', function () {
    setTimeout(initMobileZoom, 100);
  });
})();

/***/ }),

/***/ "./src/js/modules/ed-model-view.js":
/*!*****************************************!*\
  !*** ./src/js/modules/ed-model-view.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdModelView = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdModelView, _HTMLElement);
  var _super = _createSuper(EdModelView);
  function EdModelView() {
    _classCallCheck(this, EdModelView);
    return _super.call(this);
  }
  _createClass(EdModelView, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.textTrue = this.getAttribute('data-text-true');
      this.textFalse = this.getAttribute('data-text-false');
      this.addEventListener('click', function () {
        return _this.toggle();
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          _this.toggle();
        }
      });
      document.addEventListener('ed-model-view:swap', function () {
        return _this.swapImages();
      });
      this.syncCollectionMode();
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.offsetParent !== null && getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "isDesignMode",
    value: function isDesignMode() {
      return this.classList.contains('ed-model-view--right');
    }
  }, {
    key: "isSkinMode",
    value: function isSkinMode() {
      return !this.isDesignMode();
    }
  }, {
    key: "isCollectionDesignMode",
    value: function isCollectionDesignMode() {
      return this.isVisible() && this.isDesignMode();
    }
  }, {
    key: "syncCollectionMode",
    value: function syncCollectionMode() {
      document.documentElement.classList.toggle('ed-collection--model-view-design', this.isCollectionDesignMode());
    }
  }, {
    key: "updateToggleLabel",
    value: function updateToggleLabel() {
      var label = this.querySelector('.ed-model-view__text');
      if (!label) return;
      label.textContent = this.isSkinMode() ? this.textTrue : this.textFalse;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (!this.isVisible()) return;
      this.classList.toggle('ed-model-view--right');
      this.updateToggleLabel();
      this.swapImages();
    }
  }, {
    key: "swapImages",
    value: function swapImages() {
      var _this2 = this;
      if (this.isVisible()) {
        // Same breakpoint as the collection image slider (mobile up to 748px)
        var isDesktop = !window.matchMedia('(max-width: 748px)').matches;
        if (isDesktop) {
          var productSection = document.querySelector('.shopify-section');
          if (productSection) {
            productSection.dispatchEvent(new CustomEvent('product:slideshow:refresh'));
          }
        }
        var containers = document.querySelectorAll('.ed-product-item__image-slide-container');
        containers.forEach(function (container) {
          if (container.classList.contains('ed-model-view--disabled')) {
            return;
          }
          var slide1 = container.querySelector('.ed-product-item__image-slide-1');
          var slide2 = container.querySelector('.ed-product-item__image-slide-2');
          if (slide1 && slide2) {
            var slideTrack = container.querySelector('.ed-product-image-slider__track');
            if (slideTrack) {
              slideTrack.style.transform = '';
            }
            if (isDesktop) {
              var scrollPosition = _this2.isSkinMode() ? 0 : slide1.offsetWidth;
              container.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
              });
            } else {
              var slideParent = slideTrack && slideTrack.contains(slide1) ? slideTrack : container;
              if (_this2.isSkinMode()) {
                slideParent.insertBefore(slide1, slide2);
              } else {
                slideParent.insertBefore(slide2, slide1);
              }
              container.scrollTo({
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        });
      }
      this.syncCollectionMode();
      document.dispatchEvent(new CustomEvent('ed:model-view:swapped'));
    }
  }]);
  return EdModelView;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-model-view')) {
  customElements.define('ed-model-view', EdModelView);
}

/***/ }),

/***/ "./src/js/modules/ed-pdp-gallery-recommendations.js":
/*!**********************************************************!*\
  !*** ./src/js/modules/ed-pdp-gallery-recommendations.js ***!
  \**********************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// INK-354: the tile won the A/B test on desktop only, mobile keeps the original gallery
var DESKTOP_MEDIA_QUERY = 'screen and (min-width: 1008px)';
var EdPdpGalleryRecommendations = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdPdpGalleryRecommendations, _HTMLElement);
  var _super = _createSuper(EdPdpGalleryRecommendations);
  function EdPdpGalleryRecommendations() {
    _classCallCheck(this, EdPdpGalleryRecommendations);
    return _super.apply(this, arguments);
  }
  _createClass(EdPdpGalleryRecommendations, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this._isInitialized) {
        return;
      }
      this._isInitialized = true;
      this._attachSelectors();
      if (!this.grid || !this.slideItem || !this.slideshow) {
        return;
      }
      this._desktopQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
      this._onBreakpointChange = this._applyBreakpoint.bind(this);
      this._desktopQuery.addEventListener('change', this._onBreakpointChange);
      this._applyBreakpoint();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Parking the slide on mobile detaches this element as well, the breakpoint listener has to survive that
      if (this._isParked) {
        return;
      }
      this._cleanup();
    }
  }, {
    key: "_applyBreakpoint",
    value: function _applyBreakpoint() {
      if (this._isRemoved) {
        return;
      }
      if (!this.slideshow.isConnected) {
        this._cleanup();
        return;
      }
      if (!this._desktopQuery.matches) {
        this._park();
        return;
      }
      this._unpark();
      this._load();
    }
  }, {
    key: "_load",
    value: function _load() {
      var _this = this;
      if (this._isLoaded) {
        // Content may have arrived while the nav thumbnail was parked
        if (this._hasContent) {
          this._populateNavThumbnail();
        }
        return;
      }
      this._isLoaded = true;
      if (this._tryPopulate()) {
        return;
      }
      var sourceSection = this._getSourceSection();
      if (!sourceSection) {
        this._removeSyntheticSlide();
        return;
      }
      if (sourceSection.matches('[data-section-type="featured-collections"]')) {
        this._removeSyntheticSlide();
        return;
      }
      this._observeSourceSection(sourceSection);
      this._fallbackTimer = window.setTimeout(function () {
        if (!_this._hasContent) {
          _this._removeSyntheticSlide();
        }
      }, 2500);
    }
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      if (this._desktopQuery) {
        this._desktopQuery.removeEventListener('change', this._onBreakpointChange);
        this._desktopQuery = null;
      }
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._fallbackTimer) {
        window.clearTimeout(this._fallbackTimer);
        this._fallbackTimer = null;
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.grid = this.querySelector('[data-ed-pdp-recommendations-grid]');
      this.gallery = this.closest('.Product__Gallery');
      this.slideshow = this.closest('.Product__Slideshow');
      this.slideItem = this.closest('.Product__SlideItem');
      this.mediaId = this.slideItem ? this.slideItem.getAttribute('data-media-id') : null;
    }
  }, {
    key: "_getSourceSection",
    value: function _getSourceSection() {
      var recommendationsSection = document.querySelector('[data-section-type="product-recommendations"]');
      if (recommendationsSection) {
        return recommendationsSection;
      }
      return document.querySelector('[data-section-type="featured-collections"]');
    }
  }, {
    key: "_getSourceCards",
    value: function _getSourceCards() {
      var sourceSection = this._getSourceSection();
      if (!sourceSection) {
        return [];
      }
      if (sourceSection.matches('[data-section-type="product-recommendations"]')) {
        return Array.from(sourceSection.querySelectorAll('.ProductRecommendations .Carousel__Cell .ProductItem:not(.ed-hide-product)'));
      }
      return Array.from(sourceSection.querySelectorAll('.ProductListWrapper .ProductItem:not(.ed-hide-product)')).slice(0, 4);
    }
  }, {
    key: "_tryPopulate",
    value: function _tryPopulate() {
      var _this2 = this;
      var sourceCards = this._getSourceCards();
      if (!sourceCards.length) {
        return false;
      }
      var cards = sourceCards.slice(0, 4).map(function (sourceCard) {
        return _this2._buildCard(sourceCard);
      });
      this.grid.innerHTML = '';
      cards.forEach(function (card) {
        return _this2.grid.appendChild(card);
      });
      this._hasContent = true;
      this.slideItem.classList.add('Product__SlideItem--recommendationsReady');
      this.grid.setAttribute('data-recommendations-count', String(cards.length));
      this._populateNavThumbnail();
      return true;
    }
  }, {
    key: "_populateNavThumbnail",
    value: function _populateNavThumbnail() {
      var _this3 = this;
      if (this._isRemoved || !this.gallery) {
        return;
      }
      var navItem = this.gallery.querySelector('.Product__SlideshowNavImage--recommendations');
      if (!navItem) {
        if (document.readyState === 'loading' && !this._navRetryBound) {
          this._navRetryBound = true;
          document.addEventListener('DOMContentLoaded', function () {
            return _this3._populateNavThumbnail();
          }, {
            once: true
          });
        }
        return;
      }
      if (navItem.querySelector('.ed-pdp-gallery-recommendations__navGrid')) {
        return;
      }
      var urls = this._getSourceCards().slice(0, 4).map(function (card) {
        return _this3._getCardImageUrl(card);
      }).filter(Boolean);
      if (!urls.length) {
        return;
      }
      var navGrid = document.createElement('div');
      navGrid.className = 'ed-pdp-gallery-recommendations__navGrid';
      urls.forEach(function (url) {
        // The image needs its own positioned cell: as a direct grid item WebKit resolves
        // its height: 100% against the grid container instead of the row, which makes the
        // four thumbnails overlap on iOS Safari.
        var cell = document.createElement('div');
        cell.className = 'ed-pdp-gallery-recommendations__navCell';
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.loading = 'lazy';
        cell.appendChild(img);
        navGrid.appendChild(cell);
      });
      var badge = document.createElement('span');
      badge.className = 'ed-pdp-gallery-recommendations__navBadge';
      badge.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">' + '<circle cx="12" cy="12" r="12" fill="#1f1f1f"/>' + '<path d="M12 3.5l2.6 5.3 5.9.8-4.2 4.1 1 5.8-5.3-2.8-5.3 2.8 1-5.8-4.2-4.1 5.9-.8L12 3.5z" fill="#f6e85f"/>' + '</svg>';
      navGrid.appendChild(badge);
      navItem.appendChild(navGrid);
      navItem.classList.add('Product__SlideshowNavImage--recommendationsLive');
    }
  }, {
    key: "_getCardImageUrl",
    value: function _getCardImageUrl(card) {
      var img = card.querySelector('.ProductItem__ImageWrapper img:not(.ProductItem__Image--alternate)') || card.querySelector('img');
      if (!img) {
        return null;
      }
      if (img.currentSrc) {
        return img.currentSrc;
      }
      var src = img.getAttribute('src');
      if (src && src.indexOf('data:') !== 0) {
        return src;
      }
      var dataSrc = img.getAttribute('data-src');
      return dataSrc ? dataSrc.replace('{width}', '160') : null;
    }
  }, {
    key: "_buildCard",
    value: function _buildCard(sourceCard) {
      var card = sourceCard.cloneNode(true);
      var primaryLink = card.querySelector('.ProductItem__ImageWrapper[href], a[href]');
      var priceList = card.querySelector('.ProductItem__PriceList');
      if (priceList) {
        priceList.remove();
      }
      var atc = card.querySelector('.ed-product-item-atc-container');
      if (atc) {
        atc.remove();
      }
      card.classList.add('ed-pdp-gallery-recommendations__card');
      if (!primaryLink) {
        return card;
      }
      card.tabIndex = 0;
      card.setAttribute('role', 'link');
      card.setAttribute('aria-label', primaryLink.getAttribute('aria-label') || 'Open product');
      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button, input, label, select, textarea')) {
          return;
        }
        window.location.href = primaryLink.href;
      });
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          window.location.href = primaryLink.href;
        }
      });
      return card;
    }
  }, {
    key: "_observeSourceSection",
    value: function _observeSourceSection(sourceSection) {
      var _this4 = this;
      this._observer = new MutationObserver(function () {
        if (_this4._tryPopulate()) {
          _this4._observer.disconnect();
          _this4._observer = null;
          if (_this4._fallbackTimer) {
            window.clearTimeout(_this4._fallbackTimer);
            _this4._fallbackTimer = null;
          }
        }
      });
      this._observer.observe(sourceSection, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "_removeSyntheticSlide",
    value: function _removeSyntheticSlide() {
      if (this._isRemoved) {
        return;
      }
      this._park();
      this._isRemoved = true;
      this._parkedNavItems.forEach(function (_ref) {
        var marker = _ref.marker;
        return marker.remove();
      });
      this._parkedNavItems = [];
      this._cleanup();
    }

    // Takes slide, thumbnail and dots out of the gallery but keeps them for a switch back to desktop
  }, {
    key: "_park",
    value: function _park() {
      if (this._isParked) {
        return;
      }
      this._isParked = true;
      this._slideIndex = Array.from(this.slideshow.querySelectorAll('.Product__SlideItem')).indexOf(this.slideItem);

      // A comment marks the original spot, so nav items return to the same position
      this._parkedNavItems = this._getNavItems().map(function (element) {
        var marker = document.createComment('');
        element.replaceWith(marker);
        return {
          element: element,
          marker: marker
        };
      });
      this._revealSlides();
      this._reindexMobileDots();
      this._removeFromFlickity();
      this._reindexSlidePositions();
    }
  }, {
    key: "_unpark",
    value: function _unpark() {
      if (!this._isParked) {
        return;
      }
      this._isParked = false;
      this._parkedNavItems.forEach(function (_ref2) {
        var element = _ref2.element,
          marker = _ref2.marker;
        return marker.replaceWith(element);
      });
      this._parkedNavItems = [];
      this._revealSlides();
      this._insertIntoFlickity();
      this._reindexMobileDots();
      this._reindexSlidePositions();
    }

    // On desktop the theme hides every unselected slide after a slide change (Product__SlideItem--hidden) and only
    // reveals them before its own slide changes. Without this, the slide selected after parking would stay blank.
  }, {
    key: "_revealSlides",
    value: function _revealSlides() {
      this.slideshow.querySelectorAll('.Product__SlideItem--hidden').forEach(function (slide) {
        slide.classList.remove('Product__SlideItem--hidden');
      });
    }
  }, {
    key: "_getNavItems",
    value: function _getNavItems() {
      if (!this.gallery || !this.mediaId) {
        return [];
      }
      var mediaId = String(this.mediaId);
      return Array.from(this.gallery.querySelectorAll([".Product__SlideshowNavImage[data-media-id=\"".concat(mediaId, "\"]"), ".Product__SlideshowNavDot[data-media-id=\"".concat(mediaId, "\"]"), ".Product__SlideshowMobileNav .dot[data-media-id=\"".concat(mediaId, "\"]")].join(', ')));
    }
  }, {
    key: "_reindexSlidePositions",
    value: function _reindexSlidePositions() {
      if (!this.slideshow) {
        return;
      }
      this.slideshow.querySelectorAll('.Product__SlideItem').forEach(function (slide, index) {
        slide.setAttribute('data-media-position', String(index + 1));
      });
    }
  }, {
    key: "_removeFromFlickity",
    value: function _removeFromFlickity() {
      var _this5 = this;
      if (!this.slideshow || !window.Flickity) {
        this.slideItem.remove();
        return;
      }
      var flickityInstance = window.Flickity.data(this.slideshow);

      // Inactive (stacked gallery on desktop): Flickity reads its cells from the DOM again on activation
      if (!flickityInstance || !flickityInstance.isActive) {
        this.slideItem.remove();
        return;
      }
      var slideIndex = flickityInstance.cells.findIndex(function (cell) {
        return cell.element === _this5.slideItem;
      });
      if (slideIndex === -1) {
        this.slideItem.remove();
        return;
      }
      if (flickityInstance.selectedIndex === slideIndex) {
        flickityInstance.select(Math.max(0, slideIndex - 1), false, true);
      }
      flickityInstance.remove(this.slideItem);
      flickityInstance.resize();
    }
  }, {
    key: "_insertIntoFlickity",
    value: function _insertIntoFlickity() {
      var flickityInstance = window.Flickity ? window.Flickity.data(this.slideshow) : null;
      if (flickityInstance && flickityInstance.isActive) {
        flickityInstance.insert(this.slideItem, this._slideIndex);
        flickityInstance.resize();
        return;
      }
      var slides = this.slideshow.querySelectorAll('.Product__SlideItem');
      if (slides[this._slideIndex]) {
        slides[this._slideIndex].before(this.slideItem);
      } else if (slides.length) {
        slides[slides.length - 1].after(this.slideItem);
      } else {
        this.slideshow.appendChild(this.slideItem);
      }
    }
  }, {
    key: "_reindexMobileDots",
    value: function _reindexMobileDots() {
      if (!this.gallery) {
        return;
      }
      var dots = this.gallery.querySelectorAll('.Product__SlideshowMobileNav .dot');
      dots.forEach(function (dot, index) {
        dot.setAttribute('data-index', String(index));
      });
    }
  }]);
  return EdPdpGalleryRecommendations;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-pdp-gallery-recommendations')) {
  customElements.define('ed-pdp-gallery-recommendations', EdPdpGalleryRecommendations);
}

/***/ }),

/***/ "./src/js/modules/ed-product-action-list.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-product-action-list.js ***!
  \**************************************************/
/***/ (() => {

/**
 * Product Action List Handler
 * Moves Product__ActionList into flickity-viewport under specific conditions
 * Only for screen width under 1000px and when media_count is over 7
 */

(function () {
  'use strict';

  function shouldRunScript() {
    if (window.innerWidth >= 1000) {
      return false;
    }
    var productGallery = document.querySelector('.Product__Gallery');
    if (!productGallery) {
      return false;
    }
    var mediaCount = productGallery.getAttribute('data-media-count');
    return mediaCount && parseInt(mediaCount) > 7;
  }
  if (!shouldRunScript()) {
    return;
  }
  function productActionListExists() {
    return document.getElementById('ProductActionList') !== null;
  }
  function productSlideshowExists() {
    return document.querySelector('.Product__Slideshow') !== null;
  }
  function isMobileWidth() {
    return window.innerWidth < 1000;
  }
  function isAlreadyInFlickity(actionList) {
    return actionList.closest('.flickity-viewport') || actionList.closest('.flickity-slider');
  }
  function moveActionListToFlickity() {
    var actionList = document.getElementById('ProductActionList');
    var slideshow = document.querySelector('.Product__Slideshow');
    if (!actionList || !slideshow || !isMobileWidth()) {
      return;
    }
    if (!isAlreadyInFlickity(actionList)) {
      var flickityViewport = slideshow.querySelector('.flickity-viewport');
      if (flickityViewport) {
        flickityViewport.appendChild(actionList);
      }
    }
  }
  function init() {
    if (!productActionListExists() || !productSlideshowExists()) {
      return;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveActionListToFlickity);
    } else {
      moveActionListToFlickity();
    }
  }
  init();
})();

/***/ }),

/***/ "./src/js/modules/ed-product-image-slider.js":
/*!***************************************************!*\
  !*** ./src/js/modules/ed-product-image-slider.js ***!
  \***************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MOBILE_QUERY = '(max-width: 748px)';
var TEASE_DELAY_MS = 1200;
var TEASE_ANIMATION_MS = 400;
var TEASE_PAUSE_MS = 400;
var mobileQuery = window.matchMedia(MOBILE_QUERY);
var sliders = new Set();
function onBreakpointChange() {
  if (!sliders.size) {
    return;
  }
  sliders.forEach(function (slider) {
    slider._syncWithBreakpoint();
  });

  // Re-apply the current model view (skin/design) to the rebuilt or restored slides
  document.dispatchEvent(new CustomEvent('ed-model-view:swap'));
}
if (mobileQuery.addEventListener) {
  mobileQuery.addEventListener('change', onBreakpointChange);
} else {
  mobileQuery.addListener(onBreakpointChange);
}
var EdProductImageSlider = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdProductImageSlider, _HTMLElement);
  var _super = _createSuper(EdProductImageSlider);
  function EdProductImageSlider() {
    _classCallCheck(this, EdProductImageSlider);
    return _super.apply(this, arguments);
  }
  _createClass(EdProductImageSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.closest('[data-section-type="collection"]')) {
        return;
      }
      this._slides = this.querySelectorAll('.ed-product-item__image-slide');
      if (this._slides.length < 2) {
        return;
      }
      if (!this._hasConnected) {
        this._hasConnected = true;
        // Tease only when the card is first rendered on mobile, not after a breakpoint change
        this._shouldTease = mobileQuery.matches && this.hasAttribute('data-tease-slider');
      }
      sliders.add(this);
      this._syncWithBreakpoint();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      sliders["delete"](this);
      if (this._mobileInitialized) {
        this._destroyMobileSlider();
      }
    }
  }, {
    key: "_syncWithBreakpoint",
    value: function _syncWithBreakpoint() {
      if (mobileQuery.matches && !this._mobileInitialized) {
        this._initMobileSlider();
      } else if (!mobileQuery.matches && this._mobileInitialized) {
        this._destroyMobileSlider();
      }
    }
  }, {
    key: "_initMobileSlider",
    value: function _initMobileSlider() {
      this._mobileInitialized = true;
      this._teaseAborted = false;
      this._isTeasing = false;
      this._wrapSlidesInTrack();
      this._initProgressBar();
      this._attachListeners();
      this._setProgressRatio(0);
      if (this._shouldTease) {
        this._shouldTease = false;
        this._scheduleTease();
      }
    }
  }, {
    key: "_destroyMobileSlider",
    value: function _destroyMobileSlider() {
      this._mobileInitialized = false;
      this._teaseAborted = true;
      this._isTeasing = false;
      this._detachListeners();
      this._removeProgressBar();
      this._unwrapSlidesFromTrack();
      this.classList.remove('ed-product-item__image-slide-container--teasing');
      this.scrollLeft = 0;
    }
  }, {
    key: "_wrapSlidesInTrack",
    value: function _wrapSlidesInTrack() {
      var slide1 = this.querySelector('.ed-product-item__image-slide-1');
      if (!slide1) {
        return;
      }
      var track = document.createElement('div');
      track.className = 'ed-product-image-slider__track';
      this.insertBefore(track, slide1);
      this._slides.forEach(function (slide) {
        track.appendChild(slide);
      });
      this._slideTrack = track;
    }
  }, {
    key: "_unwrapSlidesFromTrack",
    value: function _unwrapSlidesFromTrack() {
      var track = this._slideTrack;
      if (!track) {
        return;
      }

      // Restore the original slide order; the model view may have reordered the slides on mobile
      this._slides.forEach(function (slide) {
        this.insertBefore(slide, track);
      }.bind(this));
      track.remove();
      this._slideTrack = null;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this._onScroll = this._onScrollUpdate.bind(this);
      this._onUserInteract = this._abortTease.bind(this);
      this._onModelViewSwapped = this._updateProgressFromScroll.bind(this);
      this.addEventListener('scroll', this._onScroll);
      this.addEventListener('touchstart', this._onUserInteract, {
        passive: true
      });
      this.addEventListener('mousedown', this._onUserInteract);
      document.addEventListener('ed:model-view:swapped', this._onModelViewSwapped);
    }
  }, {
    key: "_detachListeners",
    value: function _detachListeners() {
      this.removeEventListener('scroll', this._onScroll);
      this.removeEventListener('touchstart', this._onUserInteract);
      this.removeEventListener('mousedown', this._onUserInteract);
      document.removeEventListener('ed:model-view:swapped', this._onModelViewSwapped);
    }
  }, {
    key: "_onScrollUpdate",
    value: function _onScrollUpdate() {
      if (!this._isTeasing) {
        this._updateProgressFromScroll();
      }
    }
  }, {
    key: "_initProgressBar",
    value: function _initProgressBar() {
      if (this._progressContainer || !this.parentNode) {
        return;
      }
      var progressContainer = document.createElement('div');
      progressContainer.className = 'ed-image-slider-progress';
      progressContainer.innerHTML = '<div class="ed-image-slider-progress__track">' + '<div class="ed-image-slider-progress__indicator" data-progress-indicator></div>' + '</div>';
      this.parentNode.insertBefore(progressContainer, this.nextSibling);
      this._progressContainer = progressContainer;
      this._progressIndicator = progressContainer.querySelector('[data-progress-indicator]');
    }
  }, {
    key: "_removeProgressBar",
    value: function _removeProgressBar() {
      if (this._progressContainer) {
        this._progressContainer.remove();
      }
      this._progressContainer = null;
      this._progressIndicator = null;
    }
  }, {
    key: "_updateProgressFromScroll",
    value: function _updateProgressFromScroll() {
      if (!this._progressIndicator) {
        return;
      }
      var maxScroll = this.scrollWidth - this.clientWidth;
      var ratio = maxScroll > 0 ? this.scrollLeft / maxScroll : 0;
      if (this._isDesignOrderMobile()) {
        ratio = 1 - ratio;
      }
      this._setProgressRatio(ratio);
    }
  }, {
    key: "_setProgressRatio",
    value: function _setProgressRatio(ratio) {
      if (!this._progressIndicator) {
        return;
      }
      this._progressIndicator.style.transform = 'translate3d(' + ratio * 100 + '%, 0, 0)';
    }
  }, {
    key: "_isDesignOrderMobile",
    value: function _isDesignOrderMobile() {
      if (!this._slideTrack) {
        return false;
      }
      var firstSlide = this._slideTrack.querySelector('.ed-product-item__image-slide');
      return Boolean(firstSlide && firstSlide.classList.contains('ed-product-item__image-slide-2'));
    }
  }, {
    key: "_abortTease",
    value: function _abortTease() {
      if (!this._isTeasing) {
        this._teaseAborted = true;
      }
    }
  }, {
    key: "_scheduleTease",
    value: function _scheduleTease() {
      window.setTimeout(function () {
        if (!this._teaseAborted && this.isConnected) {
          this._runTease();
        }
      }.bind(this), TEASE_DELAY_MS);
    }
  }, {
    key: "_runTease",
    value: function _runTease() {
      if (this._teaseAborted || this._slides.length < 2 || !this._slideTrack) {
        return;
      }
      var track = this._slideTrack;
      this._isTeasing = true;
      this.classList.add('ed-product-item__image-slide-container--teasing');
      if (this._progressIndicator) {
        this._progressIndicator.style.transition = 'none';
      }
      this.scrollLeft = 0;
      var peekOffset = this.clientWidth * 0.5;
      var maxScroll = this.scrollWidth - this.clientWidth;
      var peekRatio = maxScroll > 0 ? peekOffset / maxScroll : 0.5;
      this._animateTrackTranslate(track, peekOffset, peekRatio, TEASE_ANIMATION_MS).then(function () {
        return this._wait(TEASE_PAUSE_MS);
      }.bind(this)).then(function () {
        if (this._teaseAborted) {
          return;
        }
        return this._animateTrackTranslate(track, 0, 0, TEASE_ANIMATION_MS);
      }.bind(this)).then(function () {
        track.style.transform = '';
        track.style.willChange = '';
        if (this._progressIndicator) {
          this._progressIndicator.style.transition = '';
        }
        this._setProgressRatio(0);
        this.classList.remove('ed-product-item__image-slide-container--teasing');
        this._isTeasing = false;
      }.bind(this));
    }
  }, {
    key: "_animateTrackTranslate",
    value: function _animateTrackTranslate(track, targetOffset, targetRatio, duration) {
      if (this._teaseAborted) {
        return Promise.resolve();
      }
      var startOffset = this._getTrackTranslateX(track);
      var maxScroll = this.scrollWidth - this.clientWidth;
      var startRatio = maxScroll > 0 ? startOffset / maxScroll : 0;
      var distance = targetOffset - startOffset;
      var ratioDistance = targetRatio - startRatio;
      track.style.willChange = 'transform';
      return new Promise(function (resolve) {
        var startTime = performance.now();
        function step(now) {
          if (this._teaseAborted) {
            resolve();
            return;
          }
          var elapsed = now - startTime;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 0.5 - Math.cos(progress * Math.PI) / 2;
          var currentOffset = startOffset + distance * eased;
          var currentRatio = startRatio + ratioDistance * eased;
          track.style.transform = 'translate3d(' + -currentOffset + 'px, 0, 0)';
          this._setProgressRatio(currentRatio);
          if (progress < 1) {
            requestAnimationFrame(step.bind(this));
          } else {
            resolve();
          }
        }
        requestAnimationFrame(step.bind(this));
      }.bind(this));
    }
  }, {
    key: "_getTrackTranslateX",
    value: function _getTrackTranslateX(track) {
      var transform = window.getComputedStyle(track).transform;
      if (!transform || transform === 'none') {
        return 0;
      }
      var matrix = transform.match(/matrix\(([^)]+)\)/);
      if (matrix) {
        return Math.abs(parseFloat(matrix[1].split(',')[4]) || 0);
      }
      return 0;
    }
  }, {
    key: "_wait",
    value: function _wait(ms) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, ms);
      });
    }
  }]);
  return EdProductImageSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-product-image-slider')) {
  customElements.define('ed-product-image-slider', EdProductImageSlider);
}

/***/ }),

/***/ "./src/js/modules/ed-product-item-atc.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-product-item-atc.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProductItemAtc = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductItemAtc, _HTMLElement);
  var _super = _createSuper(ProductItemAtc);
  function ProductItemAtc() {
    var _this;
    _classCallCheck(this, ProductItemAtc);
    _this = _super.call(this);
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this)); // Hier wird die gebundene Methode gespeichert
    return _this;
  }
  _createClass(ProductItemAtc, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.form.removeEventListener('submit', this.onSubmit);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cart = document.getElementById('cart');
      this.form = this.firstElementChild;
      this.submitButton = this.querySelector('button[type="submit"]');
      this.circleContainer = this.querySelector('.animation-circle-container');
      this.icon = this.querySelector('svg');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.form.addEventListener('submit', this.onSubmit);
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      e.preventDefault();

      // loading icon
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.createAnimationCircle();
      var variantId = this.getAttribute('variant-id');
      this.addToCart(variantId);
    }
  }, {
    key: "addToCart",
    value: function addToCart(variantId) {
      var redirectToCart = window.globalEnableRedirectToCart;
      if (!document.body.classList.contains('ed-ab-ink-246') && !document.body.classList.contains('ed-ab-ink-263') && !document.body.classList.contains('ed-ab-ink-322')) {
        CartJS.addItem(variantId);
      }
      if (redirectToCart) {
        document.querySelector('.trigger-cart').click();
      }
      document.dispatchEvent(new CustomEvent('cartItemAdded'));
      this.pulseAnimation();
    }
  }, {
    key: "createAnimationCircle",
    value: function createAnimationCircle() {
      var _this2 = this;
      var circle = document.createElement("span");
      circle.classList.add("animation-circle");
      this.circleContainer.appendChild(circle);
      setTimeout(function () {
        circle.style.opacity = '0'; // Beginnen Sie mit dem Ausblenden
      }, 200);
      setTimeout(function () {
        _this2.circleContainer.removeChild(circle);
        if (_this2.classList.contains('swym-added')) _this2.classList.remove('animate');
      }, 350);
    }
  }, {
    key: "pulseAnimation",
    value: function pulseAnimation() {
      var _this3 = this;
      if (!this.icon) {
        return;
      }
      var animationName = 'ed-wishlist-pulse';
      var animationDuration = '1.5s';
      this.icon.style.animationName = animationName;
      this.icon.style.animationDuration = animationDuration;
      this.icon.style.animationIterationCount = '1';
      this.icon.style.animationFillMode = 'forwards';
      this.icon.addEventListener('animationend', function () {
        _this3.icon.style.animationName = '';
        _this3.icon.style.animationDuration = '';
        _this3.icon.style.animationIterationCount = '';
        _this3.icon.style.animationFillMode = '';
      }, {
        once: true
      });
    }
  }]);
  return ProductItemAtc;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-product-item-atc', ProductItemAtc);

/***/ }),

/***/ "./src/js/modules/ed-product-sticky-gallery.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/ed-product-sticky-gallery.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * Product Sticky Gallery
 * Wraps the product gallery, which is sticky on desktop (see ed-product-sticky-gallery.scss).
 * When the gallery is taller than the viewport, the default top offset would cut off
 * the lower part (thumbnails). In that case the offset is shifted so the gallery sticks
 * with its bottom edge inside the viewport instead.
 */

var DESKTOP_MIN_WIDTH = 1008;
var GAP = 25;
var TOP_PROPERTY = '--ed-sticky-gallery-top';
var EdProductStickyGallery = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdProductStickyGallery, _HTMLElement);
  var _super = _createSuper(EdProductStickyGallery);
  function EdProductStickyGallery() {
    _classCallCheck(this, EdProductStickyGallery);
    return _super.apply(this, arguments);
  }
  _createClass(EdProductStickyGallery, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._update = this._update.bind(this);
      this._attachListeners();
      this._update();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this._update);
      window.removeEventListener('load', this._update);
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      window.addEventListener('resize', this._update);
      window.addEventListener('load', this._update);
      if (window.ResizeObserver) {
        this._resizeObserver = new ResizeObserver(this._update);
        this._resizeObserver.observe(this);
      }
    }
  }, {
    key: "_getHeaderHeight",
    value: function _getHeaderHeight() {
      var value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      return parseInt(value, 10) || 0;
    }
  }, {
    key: "_update",
    value: function _update() {
      if (window.innerWidth < DESKTOP_MIN_WIDTH) {
        this.style.removeProperty(TOP_PROPERTY);
        return;
      }
      var defaultTop = this._getHeaderHeight() + GAP;
      var bottomAlignedTop = window.innerHeight - this.offsetHeight - GAP;
      if (bottomAlignedTop < defaultTop) {
        this.style.setProperty(TOP_PROPERTY, "".concat(bottomAlignedTop, "px"));
      } else {
        this.style.removeProperty(TOP_PROPERTY);
      }
    }
  }]);
  return EdProductStickyGallery;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ed-product-sticky-gallery')) {
  customElements.define('ed-product-sticky-gallery', EdProductStickyGallery);
}

/***/ }),

/***/ "./src/js/modules/ed-reviewsio.js":
/*!****************************************!*\
  !*** ./src/js/modules/ed-reviewsio.js ***!
  \****************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ReviewsIo = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ReviewsIo, _HTMLElement);
  var _super = _createSuper(ReviewsIo);
  function ReviewsIo() {
    _classCallCheck(this, ReviewsIo);
    return _super.apply(this, arguments);
  }
  _createClass(ReviewsIo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.getReviewsIoData();
    }
  }, {
    key: "getReviewsIoData",
    value: function getReviewsIoData() {
      var _this = this;
      fetch('https://api.reviews.io/reviews?store=inkster.eu&type=product_review').then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.json();
      }).then(function (data) {
        return _this.updateUI(data);
      })["catch"](function (error) {
        return console.error('Error fetching data:', error);
      });
    }
  }, {
    key: "updateUI",
    value: function updateUI(data) {
      if (data && data.stats) {
        var edWord = 'Hervorragend';
        var edTotalReviews = data.stats.company.review_count + data.results_count;
        this.setTextContent('.ed-reviewsio__word', edWord);
        this.setTextContent('.ed-reviewsio__average-rating', data.stats.company.average_rating);
        this.setTextContent('.ed-reviewsio__total-reviews', edTotalReviews);
        this.updateStarDisplay(data.stats.company.average_rating);
      }
    }
  }, {
    key: "setTextContent",
    value: function setTextContent(selector, text) {
      var element = this.querySelector(selector);
      if (element) {
        element.textContent = text;
      }
    }
  }, {
    key: "updateStarDisplay",
    value: function updateStarDisplay(rating) {
      var stars = this.querySelectorAll('.ed-reviewsio .star');
      if (!stars) return;
      var fullStars = Math.floor(rating);
      var hasHalfStar = rating % 1 >= 0.5;
      var halfStarIndex = hasHalfStar ? fullStars : -1;
      stars.forEach(function (star, index) {
        star.classList.remove('star-filled', 'star-half', 'star-empty');
        if (index < fullStars) {
          star.classList.add('star-filled');
        } else if (index === halfStarIndex) {
          star.classList.add('star-half');
        } else {
          star.classList.add('star-empty');
        }
      });
    }
  }]);
  return ReviewsIo;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-reviewsio', ReviewsIo);

/***/ }),

/***/ "./src/js/modules/ed-scrolling-bar-collection.js":
/*!*******************************************************!*\
  !*** ./src/js/modules/ed-scrolling-bar-collection.js ***!
  \*******************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ScrollingBarCollection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ScrollingBarCollection, _HTMLElement);
  var _super = _createSuper(ScrollingBarCollection);
  function ScrollingBarCollection() {
    _classCallCheck(this, ScrollingBarCollection);
    return _super.apply(this, arguments);
  }
  _createClass(ScrollingBarCollection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.edFeaturedCollectionScrollBar = document.querySelector('.ed-container-no-padding-right .SectionHeader__TabList');
      this.edFeaturedCollectionScrollBarElements = document.querySelectorAll('button.edScrollElement');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.edFeaturedCollectionScrollBarElements.forEach(function (element) {
        element.addEventListener('click', _this._adjustScrollingItem.bind(_this));
      });
    }
  }, {
    key: "_adjustScrollingItem",
    value: function _adjustScrollingItem(event) {
      var element = event.currentTarget;
      var containerRect = this.edFeaturedCollectionScrollBar.getBoundingClientRect();
      var elementRect = element.getBoundingClientRect();

      // Calculate the scroll amount to center the clicked element
      var scrollAmount = elementRect.left - containerRect.left - (containerRect.width - elementRect.width) / 2;

      // Scroll the container to center the clicked element
      this.edFeaturedCollectionScrollBar.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  }]);
  return ScrollingBarCollection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-collection-scrolling-bar', ScrollingBarCollection);

/***/ }),

/***/ "./src/js/modules/ed-shipping-info-text-cart-container.js":
/*!****************************************************************!*\
  !*** ./src/js/modules/ed-shipping-info-text-cart-container.js ***!
  \****************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ShippingInfoCart = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ShippingInfoCart, _HTMLElement);
  var _super = _createSuper(ShippingInfoCart);
  function ShippingInfoCart() {
    _classCallCheck(this, ShippingInfoCart);
    return _super.apply(this, arguments);
  }
  return _createClass(ShippingInfoCart);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-shipping-info-text-cart-container', ShippingInfoCart);

/***/ }),

/***/ "./src/js/modules/ed-staggered-discounts.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-staggered-discounts.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdStaggeredDiscounts = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdStaggeredDiscounts, _HTMLElement);
  var _super = _createSuper(EdStaggeredDiscounts);
  function EdStaggeredDiscounts() {
    var _this;
    _classCallCheck(this, EdStaggeredDiscounts);
    _this = _super.call(this);
    _this.cards = _this.querySelectorAll('.ed-staggered-discounts__card');
    _this.quantityInput = _this.querySelector('.QuantitySelector__CurrentQuantity');
    _this.addToCartButton = document.querySelector('#AddToCart');
    _this.activeClass = 'ed-staggered-discounts__card--active';
    _this.priceList = document.querySelector('.ProductMeta__PriceList');
    _this.basePrice = parseInt(_this.dataset.basePrice);
    _this.baseComparePrice = parseInt(_this.dataset.baseComparePrice);
    _this.hasBaseComparePrice = _this.dataset.hasBaseComparePrice === 'true';
    _this.init();
    return _this;
  }
  _createClass(EdStaggeredDiscounts, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.cards.forEach(function (card) {
        card.addEventListener('click', _this2.handleCardClick.bind(_this2));
      });
      var activeCard = this.querySelector('.ed-staggered-discounts__card--active');
      if (activeCard) {
        this.updatePrice(activeCard);
      }
    }
  }, {
    key: "handleCardClick",
    value: function handleCardClick(event) {
      var _this3 = this;
      event.preventDefault();
      this.cards.forEach(function (card) {
        card.classList.remove(_this3.activeClass);
      });
      var clickedCard = event.currentTarget;
      clickedCard.classList.add(this.activeClass);
      var quantity = clickedCard.dataset.quantity;
      if (this.quantityInput) {
        this.quantityInput.value = quantity;
      }
      if (this.addToCartButton && this.addToCartButton.hasAttribute('data-cart-quantity')) {
        this.addToCartButton.setAttribute('data-cart-quantity', quantity);
      }
      this.updatePrice(clickedCard);
    }
  }, {
    key: "updatePrice",
    value: function updatePrice(card) {
      if (!this.priceList) return;
      var discountedPrice = parseInt(card.dataset.discountedPrice);
      var comparePrice = parseInt(card.dataset.comparePrice);
      var hasDiscount = card.dataset.hasDiscount === 'true';
      var formattedDiscountedPrice = this.formatMoney(discountedPrice);
      var formattedComparePrice = this.formatMoney(comparePrice);
      this.updatePriceDisplay(formattedDiscountedPrice, formattedComparePrice, hasDiscount);
    }
  }, {
    key: "updatePriceDisplay",
    value: function updatePriceDisplay(discountedPrice, comparePrice, hasDiscount) {
      var _window$theme, _window$theme$transla;
      this.priceList.innerHTML = '';
      var taxShippingElement = document.createElement('small');
      taxShippingElement.className = 'ProductMeta__Price__TaxShipping';
      taxShippingElement.textContent = ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$transla = _window$theme.translations) === null || _window$theme$transla === void 0 ? void 0 : _window$theme$transla.price_tax_shipping) || 'incl. VAT, plus shipping';
      if (hasDiscount) {
        var discountedPriceElement = document.createElement('span');
        discountedPriceElement.className = 'ProductMeta__Price Price Price--highlight Text--subdued';
        discountedPriceElement.textContent = discountedPrice;
        var comparePriceElement = document.createElement('span');
        comparePriceElement.className = 'ProductMeta__Price Price Price--compareAt Text--subdued';
        comparePriceElement.textContent = comparePrice;
        this.priceList.appendChild(discountedPriceElement);
        this.priceList.appendChild(comparePriceElement);
      } else {
        var regularPriceElement = document.createElement('span');
        regularPriceElement.className = 'ProductMeta__Price Price';
        regularPriceElement.textContent = discountedPrice;
        this.priceList.appendChild(regularPriceElement);
      }
      this.priceList.appendChild(taxShippingElement);
    }
  }, {
    key: "formatMoney",
    value: function formatMoney(cents) {
      var _this$priceList;
      var currencySymbol = ((_this$priceList = this.priceList) === null || _this$priceList === void 0 ? void 0 : _this$priceList.dataset.shopCurrency) || '€';
      var euros = (cents / 100).toFixed(2);
      return "".concat(euros, " ").concat(currencySymbol);
    }
  }]);
  return EdStaggeredDiscounts;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-staggered-discounts', EdStaggeredDiscounts);

/***/ }),

/***/ "./src/js/modules/ed-subcollections-plain.js":
/*!***************************************************!*\
  !*** ./src/js/modules/ed-subcollections-plain.js ***!
  \***************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SubcollectionsPlain = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SubcollectionsPlain, _HTMLElement);
  var _super = _createSuper(SubcollectionsPlain);
  function SubcollectionsPlain() {
    _classCallCheck(this, SubcollectionsPlain);
    return _super.apply(this, arguments);
  }
  _createClass(SubcollectionsPlain, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._highlightCurrentPath();
      this.scrollToCurrentPath();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.subCollectionItem = this.querySelectorAll('.story-link');
    }
  }, {
    key: "_highlightCurrentPath",
    value: function _highlightCurrentPath() {
      var currentPath = window.location.pathname + window.location.search;
      // console.log(currentPath);
      this.subCollectionItem.forEach(function (link) {
        var linkPath = link.pathname + link.search;
        if (currentPath === linkPath) {
          link.classList.add('current-path');
        }
      });
    }
  }, {
    key: "scrollToCurrentPath",
    value: function scrollToCurrentPath() {
      var currentPathItem = this.querySelector('.stories-nav .current-path');
      if (currentPathItem) {
        currentPathItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }]);
  return SubcollectionsPlain;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-subcollections-plain', SubcollectionsPlain);

/***/ }),

/***/ "./src/js/modules/ed-tc-size-selector.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-tc-size-selector.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * ed-tc-size-selector
 * ---------------------------------------------------------------------------
 * Web-Component für die Tattoo-Größen-Auswahl auf Landing-Pages.
 *
 * Zwei unabhängige Interaktionen:
 *  1) Carousel: nativer horizontaler Scroll (Snap) + Prev/Next-Pfeile (Desktop).
 *  2) Bild-Swipe pro Kachel mit 2 Bildern (TcImageSwipe): Touch-Swipe zwischen
 *     Primary/Secondary, Richtung (horizontal/vertikal) aus dem Section-Setting
 *     (data-ed-tc-swipe-direction). Auf Hover-Geräten zeigt zusätzlich der Hover das
 *     2. Bild. Nav-Dots als Indikator.
 */
var EdTcSizeSelector = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdTcSizeSelector, _HTMLElement);
  var _super = _createSuper(EdTcSizeSelector);
  function EdTcSizeSelector() {
    _classCallCheck(this, EdTcSizeSelector);
    return _super.apply(this, arguments);
  }
  _createClass(EdTcSizeSelector, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      if (this.track) {
        this._attachListeners();
        this._updateArrows();
      }
      this._setupImageSwipes();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('resize', this._onScroll);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.track = this.querySelector('[data-ed-tc-track]');
      this.prevBtn = this.querySelector('[data-ed-tc-prev]');
      this.nextBtn = this.querySelector('[data-ed-tc-next]');
    }

    /* ----------------------------- Carousel ----------------------------- */
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this._onScroll = this._onScroll.bind(this);
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () {
        return _this._scrollByPage(-1);
      });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () {
        return _this._scrollByPage(1);
      });
      this.track.addEventListener('scroll', this._onScroll, {
        passive: true
      });
      window.addEventListener('resize', this._onScroll, {
        passive: true
      });
    }
  }, {
    key: "_scrollByPage",
    value: function _scrollByPage(direction) {
      var amount = this.track.clientWidth * 0.8;
      this.track.scrollBy({
        left: amount * direction,
        behavior: 'smooth'
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll() {
      var _this2 = this;
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(function () {
        return _this2._updateArrows();
      });
    }
  }, {
    key: "_updateArrows",
    value: function _updateArrows() {
      var _this$track = this.track,
        scrollLeft = _this$track.scrollLeft,
        scrollWidth = _this$track.scrollWidth,
        clientWidth = _this$track.clientWidth;
      var maxScroll = scrollWidth - clientWidth;
      var canScroll = maxScroll > 1;
      this.toggleAttribute('data-ed-tc-scrollable', canScroll);
      if (this.prevBtn) this.prevBtn.disabled = !canScroll || scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = !canScroll || scrollLeft >= maxScroll - 1;
    }

    /* --------------------------- Bild-Swipe ----------------------------- */
  }, {
    key: "_setupImageSwipes",
    value: function _setupImageSwipes() {
      // Default vertikal (kein Konflikt mit dem horizontalen Carousel-Scroll).
      var vertical = this.dataset.edTcSwipeDirection !== 'horizontal';
      this.querySelectorAll('[data-ed-tc-swipe]').forEach(function (tile) {
        var track = tile.querySelector('[data-ed-tc-swipe-track]');
        if (track && track.children.length >= 2) {
          new TcImageSwipe(tile, track, vertical);
        }
      });
    }
  }]);
  return EdTcSizeSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
/**
 * Swipe/Hover zwischen genau 2 Bildern einer Kachel.
 * Achsen-generisch: `vertical` schaltet die gesamte Logik (Pointer-Delta,
 * translate, touch-action) von X auf Y. Snap nach Distanz (22 %) oder Velocity.
 */
var TcImageSwipe = /*#__PURE__*/function () {
  // Anteil der Kachelseite
  // px/ms
  // px bis die Achse "einrastet"
  // Cross-Achse dominiert → Scroll durchlassen

  function TcImageSwipe(tile, track, vertical) {
    _classCallCheck(this, TcImageSwipe);
    this.tile = tile;
    this.track = track;
    this.vertical = vertical;
    this.dots = tile.querySelectorAll('[data-ed-tc-dot]');
    this.index = 0;
    this.suppressClick = false;
    this._bindSwipe();
    this._bindHover();
    this._bindClickGuard();
    this._render(false);
  }

  // Position auf der Swipe-Achse bzw. quer dazu.
  _createClass(TcImageSwipe, [{
    key: "_main",
    value: function _main(e) {
      return this.vertical ? e.clientY : e.clientX;
    }
  }, {
    key: "_cross",
    value: function _cross(e) {
      return this.vertical ? e.clientX : e.clientY;
    }
  }, {
    key: "_size",
    value: function _size() {
      return (this.vertical ? this.tile.clientHeight : this.tile.clientWidth) || 1;
    }
  }, {
    key: "_setTransform",
    value: function _setTransform(percent, animate) {
      this.track.style.transition = animate ? 'transform 260ms cubic-bezier(.22,.61,.36,1)' : 'none';
      this.track.style.transform = this.vertical ? "translate3d(0,".concat(percent, "%,0)") : "translate3d(".concat(percent, "%,0,0)");
    }
  }, {
    key: "_render",
    value: function _render() {
      var _this3 = this;
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this._setTransform(-this.index * 50, animate);
      this.dots.forEach(function (dot, i) {
        return dot.classList.toggle('is-active', i === _this3.index);
      });
    }
  }, {
    key: "_goTo",
    value: function _goTo(index) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.index = Math.max(0, Math.min(1, index));
      this._render(animate);
    }
  }, {
    key: "_bindSwipe",
    value: function _bindSwipe() {
      var _this4 = this;
      var start = 0,
        startCross = 0,
        last = 0,
        lastT = 0,
        velocity = 0;
      var dragging = false,
        locked = false,
        onAxis = false;
      var down = function down(e) {
        var _this4$tile$setPointe, _this4$tile;
        // Maus nutzt Hover (s. u.), nicht Drag → Konflikt vermeiden.
        if (e.pointerType === 'mouse') return;
        dragging = true;
        locked = false;
        onAxis = false;
        start = last = _this4._main(e);
        startCross = _this4._cross(e);
        lastT = performance.now();
        velocity = 0;
        _this4.suppressClick = false;
        _this4._setTransform(-_this4.index * 50, false);
        (_this4$tile$setPointe = (_this4$tile = _this4.tile).setPointerCapture) === null || _this4$tile$setPointe === void 0 ? void 0 : _this4$tile$setPointe.call(_this4$tile, e.pointerId);
      };
      var move = function move(e) {
        if (!dragging) return;
        var delta = _this4._main(e) - start;
        var deltaCross = _this4._cross(e) - startCross;
        if (!locked) {
          if (Math.abs(delta) < TcImageSwipe.LOCK_THRESHOLD && Math.abs(deltaCross) < TcImageSwipe.LOCK_THRESHOLD) return;
          locked = true;
          // Quer-Bewegung dominiert → das ist Scrollen, kein Bild-Swipe.
          if (Math.abs(deltaCross) > Math.abs(delta) * TcImageSwipe.AXIS_RATIO) {
            dragging = false;
            return;
          }
          onAxis = true;
        }
        if (!onAxis) return;
        if (Math.abs(delta) > 8) _this4.suppressClick = true;
        e.preventDefault(); // Scroll auf der Swipe-Achse unterbinden

        var now = performance.now();
        velocity = (_this4._main(e) - last) / Math.max(1, now - lastT);
        last = _this4._main(e);
        lastT = now;
        var percent = Math.min(0, Math.max(-50, -_this4.index * 50 + delta / _this4._size() * 50));
        _this4._setTransform(percent, false);
      };
      var up = function up(e) {
        if (!dragging) return;
        dragging = false;
        if (_this4.suppressClick) setTimeout(function () {
          _this4.suppressClick = false;
        }, 0);
        var moved = (_this4._main(e) - start) / _this4._size();
        var next = _this4.index;
        if (Math.abs(velocity) > TcImageSwipe.SNAP_VELOCITY) next = velocity < 0 ? 1 : 0;else if (Math.abs(moved) > TcImageSwipe.SNAP_DISTANCE) next = moved < 0 ? 1 : 0;
        _this4._goTo(next);
      };
      this.tile.addEventListener('pointerdown', down, {
        passive: true
      });
      this.tile.addEventListener('pointermove', move, {
        passive: false
      });
      this.tile.addEventListener('pointerup', up, {
        passive: true
      });
      this.tile.addEventListener('pointercancel', up, {
        passive: true
      });
    }
  }, {
    key: "_bindHover",
    value: function _bindHover() {
      var _this5 = this;
      if (!window.matchMedia('(hover: hover)').matches) return;
      // Desktop: 2. Bild INSTANT (animate=false) — keine Slide-Animation wie beim
      // Mobile-Swipe.
      this.tile.addEventListener('mouseenter', function () {
        return _this5._goTo(1, false);
      });
      this.tile.addEventListener('mouseleave', function () {
        return _this5._goTo(0, false);
      });
    }
  }, {
    key: "_bindClickGuard",
    value: function _bindClickGuard() {
      var _this6 = this;
      // Ein Swipe darf den Kachel-Link nicht auslösen (Tap navigiert weiterhin).
      this.tile.addEventListener('click', function (e) {
        if (_this6.suppressClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }
  }]);
  return TcImageSwipe;
}();
_defineProperty(TcImageSwipe, "SNAP_DISTANCE", 0.22);
_defineProperty(TcImageSwipe, "SNAP_VELOCITY", 0.5);
_defineProperty(TcImageSwipe, "LOCK_THRESHOLD", 6);
_defineProperty(TcImageSwipe, "AXIS_RATIO", 1.2);
if (!customElements.get('ed-tc-size-selector')) {
  customElements.define('ed-tc-size-selector', EdTcSizeSelector);
}

/***/ }),

/***/ "./src/js/modules/ed-video-component.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-video-component.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);
  var _super = _createSuper(EdVideoThumbnail);
  function EdVideoThumbnail() {
    var _this;
    _classCallCheck(this, EdVideoThumbnail);
    _this = _super.call(this);

    // SELECTORS
    _this.popUp = document.querySelector('.video-popup-container');
    _this.popUpVideo = _this.popUp.querySelector('.video-container'); // video inside of popup

    _this.openButton = _this.querySelector('.btn-open');
    _this.closeButton = _this.popUp.querySelector('.btn-close');
    _this.playButton = _this.querySelector('.play-btn');

    // ENABLE EXTERNAL POPUP ELEMENT
    if (_this.popUp) {
      document.querySelector('ed-video-popup').setAttribute('enabled', '');
    }

    // SETUP EVENT LISTENERS
    _this._attachListeners();
    return _this;
  }
  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this));
      this.playButton.addEventListener('click', this.openPopup.bind(this));

      // click outside
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;

      /** settings **/
      video.autoplay = true;
      video.controls = true;
      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }
      if (this.controls === 'false') {
        video.controls = false;
      }
      this.popUpVideo.appendChild(video);
    }
  }]);
  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-video-thumbnail', EdVideoThumbnail);
var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);
  var _super2 = _createSuper(EdVideoPopup);
  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);
    return _super2.call(this);
  }
  return _createClass(EdVideoPopup);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-video-popup', EdVideoPopup);

/***/ }),

/***/ "./src/js/modules/ed-warranty-video-component.js":
/*!*******************************************************!*\
  !*** ./src/js/modules/ed-warranty-video-component.js ***!
  \*******************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdWarrantyVideo = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdWarrantyVideo, _HTMLElement);
  var _super = _createSuper(EdWarrantyVideo);
  function EdWarrantyVideo() {
    var _this;
    _classCallCheck(this, EdWarrantyVideo);
    _this = _super.call(this);
    _this.video = null;
    _this.isFullscreen = false;
    _this.wasPlaying = false;
    _this.currentTime = 0;
    _this.videoContainer = _this.querySelector('.ed-warranty-video-container');
    _this.playButton = _this.querySelector('.ed-warranty-play-button');
    _this.hintText = _this.querySelector('.ed-warranty-video-hint');
    _this.closeButton = _this.querySelector('.ed-warranty-close-button');
    _this._initializeVideo();
    _this._attachListeners();
    return _this;
  }
  _createClass(EdWarrantyVideo, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay') !== 'false';
    }
  }, {
    key: "muted",
    get: function get() {
      return this.getAttribute('muted') !== 'false';
    }
  }, {
    key: "loop",
    get: function get() {
      return this.getAttribute('loop') !== 'false';
    }
  }, {
    key: "_initializeVideo",
    value: function _initializeVideo() {
      if (!this.videoSrc) return;
      this.video = document.createElement('video');
      this.video.src = this.videoSrc;
      this.video.muted = this.muted;
      this.video.loop = this.loop;
      this.video.playsInline = true;
      this.video.controls = false;
      this.videoContainer.appendChild(this.video);
      if (this.autoPlay) {
        this._attemptAutoplay();
      }
    }
  }, {
    key: "_attemptAutoplay",
    value: function _attemptAutoplay() {
      var _this2 = this;
      var playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise.then(function () {
          _this2._hideOverlay();
        })["catch"](function () {
          _this2._showOverlay();
        });
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.playButton) {
        this.playButton.addEventListener('click', this._enterFullscreen.bind(this));
      }
      if (this.closeButton) {
        this.closeButton.addEventListener('click', this._exitFullscreen.bind(this));
      }
      if (this.videoContainer) {
        this.videoContainer.addEventListener('click', this._handleVideoClick.bind(this));
      }
      document.addEventListener('keydown', this._handleKeydown.bind(this));
      document.addEventListener('fullscreenchange', this._handleFullscreenChange.bind(this));
      document.addEventListener('webkitfullscreenchange', this._handleFullscreenChange.bind(this));
      document.addEventListener('mozfullscreenchange', this._handleFullscreenChange.bind(this));
      document.addEventListener('MSFullscreenChange', this._handleFullscreenChange.bind(this));
      if (this.video) {
        this.video.addEventListener('timeupdate', this._handleTimeUpdate.bind(this));
        this.video.addEventListener('play', this._handlePlay.bind(this));
        this.video.addEventListener('pause', this._handlePause.bind(this));
      }
    }
  }, {
    key: "_handleVideoClick",
    value: function _handleVideoClick(e) {
      if (e.target === this.video && this.getAttribute('video-clickable') === 'true') {
        this._enterFullscreen();
      }
    }
  }, {
    key: "_handleKeydown",
    value: function _handleKeydown(e) {
      if (this.isFullscreen) {
        if (e.key === 'Escape') {
          this._exitFullscreen();
        }
      } else if (e.key === 'Enter' || e.key === ' ') {
        if (document.activeElement === this.playButton) {
          e.preventDefault();
          this._enterFullscreen();
        }
      }
    }
  }, {
    key: "_handleFullscreenChange",
    value: function _handleFullscreenChange() {
      var isCurrentlyFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
      if (isCurrentlyFullscreen && !this.isFullscreen) {
        this.isFullscreen = true;
        this._showCloseButton();
      } else if (!isCurrentlyFullscreen && this.isFullscreen) {
        this._cleanupAfterFullscreen();
      }
    }
  }, {
    key: "_handleTimeUpdate",
    value: function _handleTimeUpdate() {
      this.currentTime = this.video.currentTime;
    }
  }, {
    key: "_handlePlay",
    value: function _handlePlay() {
      this.wasPlaying = true;
    }
  }, {
    key: "_handlePause",
    value: function _handlePause() {
      this.wasPlaying = false;
    }
  }, {
    key: "_enterFullscreen",
    value: function _enterFullscreen() {
      if (!this.video) return;
      this.currentTime = this.video.currentTime;
      this.wasPlaying = !this.video.paused;
      this.video.controls = true;
      this.video.muted = false;
      var fullscreenElement = this.videoContainer || this.video;
      if (fullscreenElement.requestFullscreen) {
        fullscreenElement.requestFullscreen();
      } else if (fullscreenElement.webkitRequestFullscreen) {
        fullscreenElement.webkitRequestFullscreen();
      } else if (fullscreenElement.mozRequestFullScreen) {
        fullscreenElement.mozRequestFullScreen();
      } else if (fullscreenElement.msRequestFullscreen) {
        fullscreenElement.msRequestFullscreen();
      }
      this.isFullscreen = true;
      this._hideOverlay();
      this._showCloseButton();
    }
  }, {
    key: "_exitFullscreen",
    value: function _exitFullscreen() {
      if (!this.video) return;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, {
    key: "_cleanupAfterFullscreen",
    value: function _cleanupAfterFullscreen() {
      var _this3 = this;
      if (!this.video) return;
      this.video.controls = false;
      this.video.muted = this.muted;
      this.video.currentTime = this.currentTime;
      if (this.wasPlaying) {
        this.video.play()["catch"](function () {
          _this3._showOverlay();
        });
      }
      this.isFullscreen = false;
      this._showOverlay();
      this._hideCloseButton();
    }
  }, {
    key: "_showOverlay",
    value: function _showOverlay() {
      if (this.playButton) {
        this.playButton.style.display = 'flex';
      }
      if (this.hintText) {
        this.hintText.style.display = 'block';
      }
    }
  }, {
    key: "_hideOverlay",
    value: function _hideOverlay() {
      if (this.playButton) {
        this.playButton.style.display = 'none';
      }
      if (this.hintText) {
        this.hintText.style.display = 'none';
      }
    }
  }, {
    key: "_showCloseButton",
    value: function _showCloseButton() {
      if (this.closeButton) {
        this.closeButton.style.display = 'flex';
      }
    }
  }, {
    key: "_hideCloseButton",
    value: function _hideCloseButton() {
      if (this.closeButton) {
        this.closeButton.style.display = 'none';
      }
    }
  }]);
  return EdWarrantyVideo;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-warranty-video', EdWarrantyVideo);

/***/ }),

/***/ "./src/js/modules/ed-wishlist-btn.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-wishlist-btn.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var WishlistButton = /*#__PURE__*/function (_HTMLElement) {
  _inherits(WishlistButton, _HTMLElement);
  var _super = _createSuper(WishlistButton);
  function WishlistButton() {
    _classCallCheck(this, WishlistButton);
    return _super.apply(this, arguments);
  }
  _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.circleContainer = this.querySelector('.animation-circle-container');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('click', this.onBtnClick.bind(this));
    }
  }, {
    key: "onBtnClick",
    value: function onBtnClick(e) {
      e.preventDefault();
      if (!this.classList.contains('swym-added')) {
        this.classList.add('ed-animate');
      }
      this.createAnimationCircle();
    }
  }, {
    key: "createAnimationCircle",
    value: function createAnimationCircle() {
      var _this = this;
      var circle = document.createElement("span");
      circle.classList.add("animation-circle");
      this.circleContainer.appendChild(circle);
      setTimeout(function () {
        circle.style.opacity = '0'; // Beginnen Sie mit dem Ausblenden
      }, 200);
      setTimeout(function () {
        _this.circleContainer.removeChild(circle);
        if (_this.classList.contains('swym-added')) _this.classList.remove('animate');
      }, 350);
    }
  }]);
  return WishlistButton;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-product-item-wishlist-btn', WishlistButton);

/***/ }),

/***/ "./src/js/modules/sticky-add-to-cart-bar.js":
/*!**************************************************!*\
  !*** ./src/js/modules/sticky-add-to-cart-bar.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var StickyAddToCartBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(StickyAddToCartBar, _HTMLElement);
  var _super = _createSuper(StickyAddToCartBar);
  function StickyAddToCartBar() {
    _classCallCheck(this, StickyAddToCartBar);
    return _super.apply(this, arguments);
  }
  _createClass(StickyAddToCartBar, [{
    key: "active",
    get: /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    }
  }, {
    key: "setActive",
    value: function setActive(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "setProductAvailability",
    value: function setProductAvailability(value) {
      this.setAttribute('product-available', value);
    }

    /** END GETTERS AND SETTERS **/
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      /** SETTINGS **/
      this.observerType = this.getAttribute('observer-type');
      this._attachSelectors();
      this._attachListeners();
      this.renderAddToCartButton();
      this.renderPrices();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAddToCart = this.querySelector('[data-ed-atc-btn]');
      this.stickyPrice = this.querySelector('[data-ed-product-price]');
      this.stickyComparePrice = this.querySelector('[data-ed-compare-at-price]');

      // get default data, as we clone elements from default to the sticky banner
      this.defaultAtcButton = document.querySelector('#AddToCart'); // TODO: UPDATE
      this.defaultPrice = document.querySelector('.product__price span[data-product-price]'); // TODO: UPDATE
      this.defaultComparePrice = document.querySelector('.Price--compareAt'); // TODO: UPDATE
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnAddToCart.addEventListener('click', this.onAddToCart.bind(this));
      this.observeElement(this.defaultAtcButton);
      document.addEventListener('theme:variant:change', this.onVariantChange.bind(this)); // TODO: UPDATE
    }
  }, {
    key: "renderPrices",
    value: function renderPrices() {
      if (this.defaultComparePrice) {
        var _this$defaultPrice;
        this.stickyComparePrice.innerText = this.defaultComparePrice.innerText;
        this.stickyPrice.innerText = (_this$defaultPrice = this.defaultPrice) === null || _this$defaultPrice === void 0 ? void 0 : _this$defaultPrice.innerText;
      } else {
        var _this$defaultPrice2;
        this.stickyComparePrice.innerText = '';
        this.stickyPrice.innerText = (_this$defaultPrice2 = this.defaultPrice) === null || _this$defaultPrice2 === void 0 ? void 0 : _this$defaultPrice2.innerText;
      }
    }
  }, {
    key: "renderAddToCartButton",
    value: function renderAddToCartButton() {
      this.btnAddToCart.innerHTML = '';
      this.btnAddToCart.appendChild(this.defaultAtcButton.cloneNode(true));
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      this.defaultPrice = document.querySelector('.product__price span[data-product-price]'); // TODO: UPDATE
      this.defaultComparePrice = document.querySelector('[data-compare-price]'); // TODO: UPDATE
      this.defaultAtcButton = document.querySelector('.product__submit__add'); // TODO: UPDATE

      this.renderPrices();
      this.renderAddToCartButton();
    }
  }, {
    key: "onAddToCart",
    value: function onAddToCart(e) {
      e.stopPropagation();
      this.defaultAtcButton.click();
    }

    /** INTERSECTION HANDLING **/
  }, {
    key: "observeElement",
    value: function observeElement() {
      var observer;
      if (this.observerType === 'not-visible') {
        observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          root: null,
          rootMargin: '-10px',
          threshold: 1
        });
      } else {
        observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        });
      }
      observer.observe(this.defaultAtcButton);
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entries) {
      var _this = this;
      // show sticky bar, whenever not visible
      if (this.observerType === 'not-visible') {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            // hide sticky bar
            _this.setActive('false');
          } else {
            // show sticky bar
            _this.setActive('true');
          }
        });
      } else {
        // show sticky bar, after selector scroll
        var dif = entries[0].boundingClientRect.top;
        if (dif < 0) {
          if (entries[0].isIntersecting) {
            // entered viewport at the top edge, hence scroll direction is up
            this.setActive('true');
          } else {
            // left viewport at the top edge, hence scroll direction is down
            this.setActive('true');
          }
        } else {
          // show sticky bar
          if (window.innerWidth <= 1007 && document.body.classList.contains('ed-show-only-sticky-atc-button-mobile')) {
            this.setActive('true');
          } else {
            this.setActive('false');
          }
        }
      }
    }

    /** END INTERSECTION HANDLING **/
  }]);
  return StickyAddToCartBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-sticky-add-to-cart-bar', StickyAddToCartBar);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_product_item_atc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-product-item-atc */ "./src/js/modules/ed-product-item-atc.js");
/* harmony import */ var _modules_ed_product_item_atc__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_item_atc__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/sticky-add-to-cart-bar */ "./src/js/modules/sticky-add-to-cart-bar.js");
/* harmony import */ var _modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_cart_reservation_label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-cart-reservation-label */ "./src/js/modules/ed-cart-reservation-label.js");
/* harmony import */ var _modules_ed_cart_reservation_label__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_reservation_label__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_wishlist_btn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-wishlist-btn */ "./src/js/modules/ed-wishlist-btn.js");
/* harmony import */ var _modules_ed_wishlist_btn__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_wishlist_btn__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_ed_reviewsio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-reviewsio */ "./src/js/modules/ed-reviewsio.js");
/* harmony import */ var _modules_ed_reviewsio__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_reviewsio__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_scrolling_bar_collection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-scrolling-bar-collection */ "./src/js/modules/ed-scrolling-bar-collection.js");
/* harmony import */ var _modules_ed_scrolling_bar_collection__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_scrolling_bar_collection__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_ed_application_steps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-application-steps */ "./src/js/modules/ed-application-steps.js");
/* harmony import */ var _modules_ed_application_steps__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_application_steps__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_free_gift_auto__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-free-gift-auto */ "./src/js/modules/ed-free-gift-auto.js");
/* harmony import */ var _modules_ed_free_gift_auto__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_free_gift_auto__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _modules_ed_free_gift_select__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/ed-free-gift-select */ "./src/js/modules/ed-free-gift-select.js");
/* harmony import */ var _modules_ed_free_gift_select__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_free_gift_select__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js");
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_component__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _modules_ed_warranty_video_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/ed-warranty-video-component */ "./src/js/modules/ed-warranty-video-component.js");
/* harmony import */ var _modules_ed_warranty_video_component__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_warranty_video_component__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _modules_ed_subcollections_plain__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/ed-subcollections-plain */ "./src/js/modules/ed-subcollections-plain.js");
/* harmony import */ var _modules_ed_subcollections_plain__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_subcollections_plain__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _modules_ed_copy_clipboard_widget__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/ed-copy-clipboard-widget */ "./src/js/modules/ed-copy-clipboard-widget.js");
/* harmony import */ var _modules_ed_copy_clipboard_widget__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_copy_clipboard_widget__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _modules_ed_shipping_info_text_cart_container__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/ed-shipping-info-text-cart-container */ "./src/js/modules/ed-shipping-info-text-cart-container.js");
/* harmony import */ var _modules_ed_shipping_info_text_cart_container__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_shipping_info_text_cart_container__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _modules_ed_staggered_discounts__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/ed-staggered-discounts */ "./src/js/modules/ed-staggered-discounts.js");
/* harmony import */ var _modules_ed_staggered_discounts__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_staggered_discounts__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _modules_ed_mobile_zoom__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/ed-mobile-zoom */ "./src/js/modules/ed-mobile-zoom.js");
/* harmony import */ var _modules_ed_mobile_zoom__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_mobile_zoom__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _modules_ed_product_action_list__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/ed-product-action-list */ "./src/js/modules/ed-product-action-list.js");
/* harmony import */ var _modules_ed_product_action_list__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_action_list__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _modules_ed_model_view__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/ed-model-view */ "./src/js/modules/ed-model-view.js");
/* harmony import */ var _modules_ed_model_view__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_model_view__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _modules_ed_pdp_gallery_recommendations__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/ed-pdp-gallery-recommendations */ "./src/js/modules/ed-pdp-gallery-recommendations.js");
/* harmony import */ var _modules_ed_pdp_gallery_recommendations__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_pdp_gallery_recommendations__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _modules_ed_product_sticky_gallery__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./modules/ed-product-sticky-gallery */ "./src/js/modules/ed-product-sticky-gallery.js");
/* harmony import */ var _modules_ed_product_sticky_gallery__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_sticky_gallery__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _modules_ed_product_image_slider__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./modules/ed-product-image-slider */ "./src/js/modules/ed-product-image-slider.js");
/* harmony import */ var _modules_ed_product_image_slider__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_image_slider__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _modules_ed_tc_size_selector__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./modules/ed-tc-size-selector */ "./src/js/modules/ed-tc-size-selector.js");
/* harmony import */ var _modules_ed_tc_size_selector__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_tc_size_selector__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _modules_ed_bundle_builder__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./modules/ed-bundle-builder */ "./src/js/modules/ed-bundle-builder.js");
/* harmony import */ var _modules_bundle_builder_ed_bundle_builder_cart_helper__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./modules/bundle-builder/ed-bundle-builder-cart-helper */ "./src/js/modules/bundle-builder/ed-bundle-builder-cart-helper.js");
/* harmony import */ var _modules_bundle_builder_ed_bundle_builder_cart_helper__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_modules_bundle_builder_ed_bundle_builder_cart_helper__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _modules_ed_ab_sync__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./modules/ed-ab-sync */ "./src/js/modules/ed-ab-sync.js");
/* harmony import */ var _modules_ed_ab_sync__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_ab_sync__WEBPACK_IMPORTED_MODULE_24__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/


























})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;